import { Component, OnInit, TemplateRef, ViewChild, OnDestroy, NgZone, Inject, EventEmitter, HostListener, DOCUMENT } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { PersonSearchService } from '../_services/person-search.service';
import * as _ from 'underscore';
import { DataService } from '../data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CandidateService } from '../_services/candidate.service';
import { of, Subject, Subscription, SubscriptionLike } from 'rxjs';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { __spreadArrays } from 'tslib';

import { LocalStorageService } from '../_services/local-storage.service';
import { SaveSearchModalComponent } from '../save-search-modal/save-search-modal.component';
import { GlobalService } from '../_services/global.service';
import { AggregationService } from '../_services/aggregation.service';
import { AggReqObjectHandlerService } from '../_services/agg-req-object-handler.service';
import { FilterDataHandlerService } from '../_services/filter-data-handler.service';
import { InsightsDataService } from '../_services/insights-data.service';
import { MatrixFilter } from '../common-interfaces-classes/MatrixFilter';
import { StatsMatrixHandlerService } from '../_services/stats-matrix-handler.service';
import { LoaderType } from '../enums/LoaderType';
import { LoaderEventsService } from '../_services/loader-events.service';
import PersonSearchResponse from '../common-interfaces-classes/PersonSearchResponse';
import { SessionStorageService } from '../_services/session-storage.service';
import { SimilarCandidateService } from '../_services/similar-candidate.service';
import { GeneralConstants } from '../constants/GeneralConstants';
import { FilterParams } from '../common-interfaces-classes/FilterParams';

import { BulkRevealModalComponent } from '../bulk-reveal-modal/bulk-reveal-modal.component';
import { CampaignService } from '../_services/campaign.service';
import { debounceTime, distinctUntilChanged, filter, skip, switchMap, takeUntil } from 'rxjs/operators';
import { Location } from '@angular/common';
import { SuggestedTitle } from "../openai/suggested-titles/suggested-titles.component";
import { SimilarCandidateFilterComponent } from '../similar-candidate-filter/similar-candidate-filter.component';
import { JdDataService } from '../jd-data.service';
import { SimilarCandidateDetails } from '../common-interfaces-classes/SimilarCandidate';
import { GenAiJdSearchComponent } from '../gen-ai-jd-search/gen-ai-jd-search.component';
import { JdData } from '../common-interfaces-classes/JdData';
import { CompanyInsightsService } from '../_services/company-insights.service';
import { HashService } from '../_services/hash.service';
import { EuropeAccessModalComponent } from '../europe-access-modal/europe-access-modal.component';
import { UnifiedService } from '../unified/unified.service';
import { AtsCandidate, AtsJob, IUnifiedIntegration } from '../unified/unified.types';
import { MatAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import cjson from 'compressed-json';
import { CallStage } from '../enums/CallStage';
import { ContinentHandlerService } from '../_services/continent-handler.service';
import moment from 'moment';
import { TalentInsightsService } from '../_services/talent-insights.service';
import * as __ from 'lodash';
import { AtsResumeScreenService } from '../_services/ats-resume-screen.service';
import { HttpErrorResponse } from '@angular/common/http';
import { TransactionService } from '../_services/transaction.service';
import { AddCandidateAegisModalComponent } from './add-candidate-aegis-modal/add-candidate-aegis-modal.component';
import { AegisIntegrationService } from '../_services/aegisIntegration.service';

declare const clevertap;

declare var google;
const CONTINENT_MAP = {
  "asia": "142",
  "south america": "005",
  "north america": "021",
  "africa": "002",
  "Oceania": "009"
}

@Component({
    selector: 'app-person-search-listing',
    templateUrl: './person-search-listing.component.html',
    styleUrls: ['./person-search-listing.component.scss'],
    standalone: false
})
export class PersonSearchListingComponent implements OnInit, OnDestroy {
  searchKeyword: string;
  totalCandidatesCount: number = 0;
  totalMedianTanureCount: number = 0;
  editQuery: boolean = false;
  success_message: string;
  selectable = true;
  removable = true;
  searchtype: any
  addOnBlur: any
  gender: string = 'All';
  /**
   * Flag is set when when any gender is selected except 'ALL'
   */
  isGenderSelected: boolean = false;
  isGenderSelectionDisabled = false;
  contacts: string = 'All';

  seniority: any = [];

  /**
   * Job Title Status Filter for radio button
   */
  jobTitleStatus: string = 'Current';

  /**
   * Job Title Input for autocomplete
   */
  jobTitleInput: UntypedFormControl = new UntypedFormControl(null);

  /**
   * Job Title List for autocomplete
   */
  jobTitleList: any = [];

  /**
   * Job Title Selected List for autocomplete
   */
  jobTitleSelectedList: any = [];

  jobTitleTopList: any = [];

  locationInput: UntypedFormControl = new UntypedFormControl(null);

  locationList: any = [];

  locationSelectedList: any = [];

  locationTopList: any = [];


  // current work city
  currentWorkCityInput: UntypedFormControl = new UntypedFormControl(null);

  currentWorkCityList: any = [];

  currentWorkCitySelectedList: any = [];

  // current work country
  currentWorkCountryInput: UntypedFormControl = new UntypedFormControl(null);

  currentWorkCountryList: any = [];

  currentWorkCountrySelectedList: any = [];

  // current work locality
  currentWorkLocalityInput: UntypedFormControl = new UntypedFormControl(null);

  currentWorkLocalityList: any = [];

  currentWorkLocalitySelectedList: any = [];

  // skills
  skillsInput: UntypedFormControl = new UntypedFormControl(null);

  skillsList: any = [];

  skillsSelectedList: any = [];

  skillsTopList: any = [];

  // company
  companyInput: UntypedFormControl = new UntypedFormControl(null);

  companyList: any = [];

  companySelectedList: any = [];

  // industry
  industryInput: UntypedFormControl = new UntypedFormControl(null);

  industryList: any = [];

  industrySelectedList: any = [];

  industryTopList: any = [];

  industryStatus: string = 'Current';

  // field of study
  fieldOfStudyInput: UntypedFormControl = new UntypedFormControl(null);

  fieldOfStudyList: any = [];

  fieldOfStudySelectedList: any = [];

  fieldOfStudyTopList: any = [];

  // Seniority Level
  seniorityLevelInput: UntypedFormControl = new UntypedFormControl(null);

  seniorityLevelList: any = [];

  seniorityLevelSelectedList: any = [];

  // education
  educationInput: UntypedFormControl = new UntypedFormControl(null);

  educationList: any = [];

  educationSelectedList: any = [];
  schoolLocationSelectedList: any = [];

  educationTopList: any = [];
  filterAppliedOnYearsOfGraduation: boolean = false
  filterAppliedOnYearsOfExperience: boolean = false
  filterAppliedOnCurrentYearsOfExperience: boolean = false
  // zip code
  zipCodeInput: UntypedFormControl = new UntypedFormControl(null);

  zipCodeList: any = [];

  zipCodeSelectedList: any = [];

  // school
  schoolInput: UntypedFormControl = new UntypedFormControl(null);

  schoolList: any = [];

  schoolSelectedList: any = [];

  schoolTopList: any = [];

  // company size
  companySizeInput: UntypedFormControl = new UntypedFormControl(null);

  companySizeList: any = [];

  companySizeSelectedList: any = [];

  companysize: any = [];
  /**
  * Flag is set when any company size is selected except 'ALL'
  */
  isCompanySizeSelected: boolean = false

  /**
   * Flag is set when filtered according to contactsAvailability
   */
  contactsAvailabilitySelectedFromInsights: boolean = false
  companyTopList: any = [];

  companyStatus: string = 'Current';

  // graduation year
  graduationYearInput: UntypedFormControl = new UntypedFormControl(null);

  graduationYearList: any = [];

  graduationYearSelectedList: any = [];

  //salary
  salary: any = 'All';
  isSalarySelected: Boolean = false

  // Likely To Move
  filterLikelyToMoveIn: any = 'All'
  isLikelyToMoveInFilterSelected: Boolean = false
  separatorKeysCodes: number[] = [ENTER, COMMA];

  pageNumber: number = 1;
  pageSize: number = 100;
  currentPage: number = 1;
  start: any = 0; //- start number for pagination (from)
  end: any  = 100//- end number for paginatuin (to)

  isInsightsActive: boolean = false;
  isListingActive: boolean = true;

  candidateList: any[] = [];

  requestObject: any = {};

  reportsAggs: any = {};
  dataSourceCurrentExperience: any = [];
  dataSourceExpInCurrentRole: any = [];
  dataSourceCurrentIndustry: any = [];
  dataSourcePastIndustry: any = [];
  dataSourceTopLocations: any = [];
  dataSourceCurrentCompany: any = [];
  dataSourceCompany: any = [];
  dataSourceEducation: any = [];
  dataSourceFieldOfStudy: any = [];

  dataSourceFunctions: any = [];
  dataSourceWorkCountry: any = [];
  dataSourcePastCompany: any = [];
  dataSourceSkills: any = [];
  dataSourceCurrentJobTitle: any = [];
  dataSourcePastJobTitle: any = [];
  dataSourceGender: any = [];
  dataSourceSeniority: any = [];
  aggregations: any = [];
  dataSourceYearsOfExperience: any = [];

  dataSourceCurrentYearsOfExperience: any = []
  languageInput: UntypedFormControl = new UntypedFormControl(null);

  languageList: any = [];

  languageSelectedList: any = [];

  languageTopList: any = [];

  yearsofexperience: any = 'Total';

  yearsofexperienceFrom: UntypedFormControl = new UntypedFormControl(null);

  yearsofexperienceTo: UntypedFormControl = new UntypedFormControl(null);




  currentfromyearsofexperience: UntypedFormControl = new UntypedFormControl(null);
  currenttoyearsofexperience: UntypedFormControl = new UntypedFormControl(null);

  platformselected: any = 'LinkedIn';

  candidatetoBeGrabbed: any[] = [];

  totalCandidateforTalentpool: any[] = [];

  selected: boolean = false;

  previousTotalCandidateCount: number = 0
  contactsAvailableArray: any[] = [
    { key: 'Personal Email', doc_count: 0 },
    { key: 'Current Professional Email', doc_count: 0 },
    { key: 'Mobile Number', doc_count: 0 },
    { key: 'Social Profiles', doc_count: 0 },
  ];

  contactSelectedList: any[] = [];
  receivedData: any;

  dataSourceYearsOfGraduation: any = null;

  fromgraduationyear: UntypedFormControl = new UntypedFormControl(null);

  tograduationyear: UntypedFormControl = new UntypedFormControl(null);

  profileurlsarray: any = []

  @ViewChild('extractToTalentpool') extractToTalentpool: TemplateRef<any>;

  modalDismissed: Boolean = false;

  talentpoolAndCandidateData: any;
  bulkGrabbingDonePreviously: any;

  @ViewChild('extractingProfile') extractingProfile: TemplateRef<any>;

  @ViewChild('premiumUserError') premiumUserError: TemplateRef<any>;

  successMessage: string;

  errorMessage: string;

  disablebutton: Boolean = true;

  sourceRedirectRef: any;

  bucketName: any;

  showCandidate: boolean = false;

  currentCandidate: any = null;

  bucketbooleanquery: any = null;

  yearsofexperror: any = null;

  yearsofgraderror: any = null;

  likelyToMoveIn: number = 0;

  contactsAvailability: any = null;
  changedJobs: any = null;

  /**Matrix of  Changed Jobs selected or not */
  isChangedJobsSelected: boolean = false;
  /** change Job value i.e yes or no*/
  changedJobStatus: string = 'all';
  /**changed job duration */
  changedJobDuration: number = 12;
  /**changedJobEndDuration */
  changedJobEndDuration: number = 12;
  /**changedJobStartDuration */
  changedJobStartDuration: number = 0;

  /**Male candidate selected in matrix */
  isMaleMatrixSelected: boolean = false;
  /**Female candidate selected in matrix */
  isFemaleMatrixSelected: boolean = false;

  malePercent: any = null;

  femalePercent: any = null;

  experienceError: Boolean = false

  bucketId: any;
  tabType: any = 'profileTab'


  /**
   * Flag is set if any filter applied from above insights
  */
  isFilteredFromInsights: Boolean = false

  /**
    * Flag is set if filter applied from above insights  is candidateslikelytomove
   */
  candidateslikelytomove: String = null
  similarobject: any
  isCalledFromSimilar: boolean = false;

  isOpenAILoading: boolean = true;

  /** Must have fields of similar candidate header */
  mustHaveSimilarCandidate: any[] = [];

  jobTitleTable: MatTableDataSource<any>;

  displayedJobTitleTable: string[] = ['key', 'doc_count'];

  skillsTable: MatTableDataSource<any>;

  displayedSkillsTable: string[] = ['key', 'doc_count'];

  educationTable: MatTableDataSource<any>;
  fieldOfStudyTable: MatTableDataSource<any>;

  topLocationsTable: MatTableDataSource<any>;


  displayedEducationTable: string[] = ['key', 'doc_count'];
  displayedFieldOfStudyTable: string[] = ['key', 'doc_count'];


  displayedTopLocation: string[] = ['key', 'doc_count'];
  talentdiscoveryhistoryid: any;
  currentIndex: any;
  showJobTitleLoader: boolean = false
  showSkillLoader: boolean = false;
  showCompanyLoader: boolean = false;
  showIndustryLoader: boolean = false;
  showFieldOfStudyLoader: boolean = false;
  showEducationLoader: boolean = false;
  showSchoolLoader: boolean = false;
  showLocationLoader: boolean = false;
  showLanguageLoader: boolean = false;
  isLoadingForYearsOfGradFilter: boolean = false;

  minSearchLengthToActivateTypeaheads: number = 3;
  isSimilarCanidate: boolean = false
  similarCanidateFullName: string = ''
  hideSearchBox: boolean = false;
  isCalledFromHistory: boolean = false;
  continentstobeincluded: any[] = [];
  companyInsightsContinents: any[] = [];

  /**Number of  profiles in each page */
  profilesPerPage: number = 25;

  /**Used for talentinsights redirection, if redirected from search talent-insights */
  talentInsightsContinent: any = [];
  parsedjdkeys: any = null;

  // ScreenAI modal state
  @ViewChild('addCandidateToScreenAiModal') addCandidateToScreenAiModal: TemplateRef<any>;
  job_input= new UntypedFormControl(null, [Validators.required]);
  jobList: any[] = [];
  selectedJob: any = null;
  screenAiDuplicateCheckDone: boolean = false;
  isLoadingScreenAiApi: boolean = false;
  postAddMssg: string = '';
  addCandidateSuccess: boolean = false;
  screenAiCandidatesArray: any[] = [];
  private destroy$ = new Subject<void>();
  isDropdownOpen: boolean = false;

  /**Used to get talent selected insights continent */
  getTalentInsightContinent(){
    return this.talentInsightsContinent || this.localstorageservice.getItem('talentRegion');
  }

  get selectedContinent() {
    if(this.sessionStorageService.getItem('historyRegion')) {
      return [this.sessionStorageService.getItem('historyRegion')];
    } else
      return [];

  }

  get geoIpLocation() {
    const location = JSON.parse(this.localstorageservice.getItem('userGeoIpLocation'));
    const country = location?.country?.toLowerCase();
    const city = location?.city?.toLowerCase();
    const region = location?.region?.toLowerCase();
    const continent = location?.continent?.toLowerCase();
    return { location: `${city || ''}${city && (region || country) ? ', ' : ''}${region || ''}${region && country ? ', ' : ''}${country || ''}`, continent }
  }

  currentCompanyInformation: any = {}

  isSearchSaved: boolean = false;
  savedSearchDetails: any = null;

  showFunctionsLoader: boolean = false
  linkedInUrlFromSimilarCandidates: any;

  functionsList: any = []
  functionSelectedList: any = []
  functionsInput: UntypedFormControl = new UntypedFormControl(null)
  seniorityList = GlobalService.seniorityLevels;
  functionTopList: any
  fullNameSelectedList: any[] = []
  searchedfrom: any;
  highlightkeywords: any
  fullnames: any[] = []

  // Flags for showing individual loaders on person listing tab
  totalCandidatesCountAvailable: boolean = false;
  likelyToMoveInCountAvailable: boolean = false;
  medianTenureInCountAvailable: boolean = false;
  contactsAvailabilityCountAvailable = false;
  genderDataAvailable = false;
  changedJobsCountAvailable = false;



  ChartForCurrentYearsofExperience: any = []
  /**
   * Defines the source from where the user is redirected to this page
   */
  redirectSource: string;
  /**
   * Contains the data of the redirect source
   */
  redirectData: any;
  redirectDataV2: FilterParams;
  /**
   * Redirect Filters
   */
  redirectFilters: any;

  redirectJobTitleFilters: any = [];
  redirectPastJobTitleFilters: any = [];

  redirectSkillsFilters: any = [];

  redirectLocationFilters: any = [];
  quicksearchaidata: any = {};
  insightsaidata: any;
  insightsSubject: Subject<any> = new Subject();

  showregion: string;
  searchHistoryRegion = null;
  @ViewChild('addCandidateToTalentPool') addCandidateToTalentPool: TemplateRef<any>;

  @ViewChild('addCandidateToEmailCampaign') addCandidateToEmailCampaign: TemplateRef<any>;

  @ViewChild('addCandidateToIntegrationTemplate') addCandidateToIntegrationTemplate: TemplateRef<any>;

  @ViewChild('tagToAtsJobTemplate') tagToAtsJobTemplate: TemplateRef<any>;
  unifiedJobInput: UntypedFormControl = new UntypedFormControl(null, [Validators.required]);
  unifiedJobList: AtsJob[] = [];
  isLoadingJobApi: boolean = false;
  selectedCampaign: any;
  campaignList: any;
  campaign_input = new UntypedFormControl(null, [Validators.required]);
  emailFoundCount: number;
  showOpenAISuggestions: number;
  searchType: string;
  searchSource: string;
  filterValue: string;
  showLoaderbeforeDataLoad: Boolean = false;
  filterType: string = null;

  aiSuggestion: SuggestedTitle[] = [];
  updateChips: EventEmitter<SuggestedTitle[]> = new EventEmitter<SuggestedTitle[]>();

  public queryForAI: string = "";
  public excludeFromAI: string[] = [];
  get aiQuery() {
    return ([this.searchKeyword].concat([this.queryForAI]).filter(Boolean).join(" OR ")).trim();
  }
  addToTalentpoolSpinner: boolean = false;
  goodToHaveFilters: any[] = [];

  modalFilters = [];

  addToEmailCampaignFromSlider: any[] = [];
  get CompanyLocation() {
    const locations = this.redirectData && this.redirectData.locations ? this.redirectData.locations : [];
    const mandatorylocations = this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatorylocations ? this.redirectData.additionalFilters.mandatorylocations : [];
    const continents = this.redirectData && this.redirectData.continents ? this.redirectData.continents : [];

    if (locations || mandatorylocations.length || continents.length) {
      return _.uniq(locations.concat(mandatorylocations).concat(continents).map(i => i.replace(/\.searchastext/g, '')));
    }
  }

  showLocationDisplayCard: boolean = false;

  topSuggestedLocations: any[] = [];

  get disableSuggestedLocationApplyButton() {
    return !this.topSuggestedLocations.filter(i => i.isSelected).length;
  }

  showCompanyDisplayCard: boolean = false;

  topSuggestedCompanies: any[] = [];

  get disableSuggestedCompanyApplyButton() {
    return !this.topSuggestedCompanies.filter(i => i.isSelected).length;
  }

  /**
   * Flag used to disable onclick on add to email campaing when migration is pending
   */
  isLoadingEmailCampaignApi: boolean = false;

  /**
   * Array of candidates selected for email-campaign
   */
  campaignCandidatesArray: any[] = [];
  companyredirectData: any

  viewMoreSkills: boolean = false;

  selectedTitles: SuggestedTitle[] = [];

  generateAIMOdalLoader: Boolean = false;
  get getMandatorySkills() {
    const filterData = this.filterDataHandlerService.fetchFilterData;

    let mandatoryskills = [];
    if (this.redirectData?.mandatoryskills) {
      mandatoryskills = this.redirectData.mandatoryskills;
    } if (this.redirectSource == 'company-insights' && this.companyredirectData?.skillsSelectedList.length) {
      mandatoryskills = mandatoryskills.concat(this.companyredirectData.skillsSelectedList.filter(s => s.isMandatory == true).map(s => s.key));
    } if (filterData && filterData.skillsSelectedList?.length)
      mandatoryskills = mandatoryskills.concat(filterData.skillsSelectedList.filter(s => s.isMandatory == true).map(s => s.key));
    return mandatoryskills;
  }

  // Fields related to showing message after adding canddiate(s) in talent pool
  showTalentPoolInput = true;
  talentPoolMessage: string = null;
  candidateName: string = null;
  addTalentPoolSuccess = false;
  talentpoolNumber: number = null;
  hasEuAccess: number;
  // ================================
  availableIntegrations: (IUnifiedIntegration & { user: null | { enabled: boolean, connection_id: string }, processing: boolean })[] = [];

  selectedIntegration: IUnifiedIntegration & { user: null | { enabled: boolean, connection_id: string }, processing: boolean } = null;

  subscriptionsLike: SubscriptionLike[] = [];
  browserBackEvent: boolean = false;
  filterData = new FilterParams();
  onRefreshAvoidApiCall: boolean = false;
  savehistory: boolean = true;
  insightsEvent: boolean = false;
  euAccessMessage: string = '';
  euAccessTIMessage: string = '';
  jdInsightsHistoryId: number = null;


  /** This boolean controls whether both elements are "stuck" */
  isScrolled: boolean = false;
  /**The pixel threshold for activation */
  private readonly scrollThreshold = 55;
  nlSearchQuery: string = '';
locationContinents: any[] = [];
resetAll: boolean = false;
showAllFilters: boolean = false;
  personSearchSub: Subscription = null;
  similarLocationContinents: any = [];
    @ViewChild('addToEmailCampaignWithViewCampaign') addToEmailCampaignWithViewCampaign: TemplateRef<any>;
  campaignName: string = '';
  excludeFilters: any = [];

  isAddToAegisAvailable: boolean = false;
  tagToAegisCandidate: any = null;
  isAegisConnected: boolean = false;

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const verticalOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    this.isScrolled = verticalOffset >= this.scrollThreshold;
  }

  constructor(private route: ActivatedRoute, private router: Router, private personSearchService: PersonSearchService, private modalService: NgbModal, private candidateservice: CandidateService, private dataService: DataService,
    private localstorageservice: LocalStorageService,
    private aggregationService: AggregationService, private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private filterDataHandlerService: FilterDataHandlerService,
    private insightsDataService: InsightsDataService,
    private statsMatrixHandlerService: StatsMatrixHandlerService,
    private loaderEventService: LoaderEventsService, private ngZone: NgZone,
  private sessionStorageService: SessionStorageService,
    private similarCandidateService: SimilarCandidateService,
    private emailCampaignService: CampaignService,
    private companyInsightsService: CompanyInsightsService,
    @Inject(DOCUMENT) private document: Document,
    private jdDataService: JdDataService,
    private location: Location,
    private hashService: HashService,
    private unifiedService: UnifiedService,
    private atsResumeScreenService: AtsResumeScreenService,
    private continentHandlerService: ContinentHandlerService,
    private transactionService: TransactionService,
    private aegisIntegrationService: AegisIntegrationService
  ) {

    /** profiles per page selection */
    const preferenceArray = this.localstorageservice.getItem('userdata').preferenceData;
    preferenceArray && preferenceArray.length && preferenceArray.map(item => {
      if (item.listing_type == 'person-search' && item.preference_type == 'page-size') {
        this.profilesPerPage = item.preference_value;
        this.end = Number(this.profilesPerPage);
      }
    })

    this.searchKeyword = '';
    if (this.jdDataService.isComingFromJobDescription || this.jdDataService.isComingFromNLSearch) {
      this.similarobject = {
        data: this.jdDataService.jdDataFromSession
      };
      this.personSearchService.passsimilarcandidatesdata({ ...this.similarobject });
      this.similarCandidateService.setSimilarCandidatesData(this.similarobject);
      this.getsimilarcandidatetooltiptext();
    }


    this.searchedfrom = this.route.snapshot.queryParams['type'];
    this.redirectSource = this.route.snapshot.queryParams['redirectSource'];

    if (this.route.snapshot.queryParams.type === 'quick-search' ||
       this.route.snapshot.queryParams.type === 'advanced-search' ||
       this.route.snapshot.queryParams.type === 'similar-candidate-from-linkedinurl' ||
       this.route.snapshot.queryParams.type === 'similar-candidate-resume-upload' ||
       this.route.snapshot.queryParams.type === 'job-description' ||
       this.route.snapshot.queryParams.redirectSource === 'talent-insights' ||
       this.route.snapshot.queryParams.redirectSource === 'company-insights' ||
       this.route.snapshot.queryParams.searchSource== 'history-component' || this.route.snapshot.queryParams.type === 'nl-search') {
        this.searchKeyword = this.route.snapshot.queryParams['keyword'] || '';
    if (!this.router.url.includes("filter=")) {
      this.setFilterDataInLocalStorage(true);
    }else {
      const cacheRequest = localStorage.getItem(this.route.snapshot.queryParams.filter);
      const filterData = cjson.decompress(JSON.parse(cacheRequest))
        if(filterData?.calledFrom == 'history' || filterData?.calledFrom == 'advance'){
          this.onRefreshAvoidApiCall = true;
          this.dataService.setData(filterData);

        } else if (this.route.snapshot.queryParams.type === 'similar-candidate-from-linkedinurl' || this.route.snapshot.queryParams.type === 'similar-candidate-resume-upload') {
          this.onRefreshAvoidApiCall = true;
          this.isSimilarCanidate = true;
          this.isCalledFromSimilar = true;
          this.similarCandidateService.setListingCalledFromSimilarCandidate(true);
          this.similarobject = JSON.parse(this.localstorageservice.getItem('similar-candidates-additional-filters'));
          this.loadFilterFromLocalStorage(filterData);
        } else if (this.route.snapshot.queryParams.type === 'job-description' || this.route.snapshot.queryParams.type === 'nl-search') {

          this.onRefreshAvoidApiCall = true;
          this.loadFilterFromLocalStorage(filterData);
        } else if (this.route.snapshot.queryParams.redirectSource === 'talent-insights') {
          this.onRefreshAvoidApiCall = true;
          this.redirectData = this.redirectSource == 'talent-insights' && this.localstorageservice.getItem('talentfilters') ? JSON.parse(this.localstorageservice.getItem('talentfilters')) : this.redirectSource == 'company-insights' && this.localstorageservice.getItem('companyinsightsdetails') ? JSON.parse(this.localstorageservice.getItem('companyinsightsdetails')) : null;
          const redirectDataV2 = this.aggregationService.getTalentInsightsRedirectDataV2();
          this.redirectDataV2 = redirectDataV2;
          const redirectDataMandatory = this.aggregationService.getTalentInsightsMandatoryData();
          if (this.redirectSource === 'talent-insights' && redirectDataV2 && !_.isEmpty(redirectDataV2) && redirectDataMandatory?.additionalFilters) {
            this.redirectData = redirectDataMandatory;
            this.talentInsightsContinent = this.redirectDataV2.continentstobeincluded;
            // this.setTalentInsightsRedirectData(redirectDataV2);
            this.checkGenderSelectionFromInsights(redirectDataV2);
          }
          this.loadFilterFromLocalStorage(filterData);
        } else if (this.route.snapshot.queryParams.redirectSource === 'company-insights') {
          this.onRefreshAvoidApiCall = true;
          const companyredirectDataV2 = this.aggregationService.getCompanyInsightsRedirectDataV2();
          companyredirectDataV2 && (companyredirectDataV2.continentstobeincluded = []);
          this.companyredirectData = companyredirectDataV2;
          const companyRedirectMandatory = this.aggregationService.getCompanyInsightsMandatoryData();
          if (this.redirectSource === 'company-insights' && companyredirectDataV2 && !_.isEmpty(companyredirectDataV2) && companyRedirectMandatory.additionalFilters) {
            this.redirectData = companyRedirectMandatory;
            this.setTalentInsightsRedirectData(companyredirectDataV2);
            this.hasEuAccess = this.localstorageservice.getItem('hasEUPersonSearchAccess');
          }
          this.loadFilterFromLocalStorage(filterData);
        } else {
          this.onRefreshAvoidApiCall = true;
          this.loadFilterFromLocalStorage(filterData);
        }
    }

  }
    const statemanagementSub = this.location.subscribe((p) => {
      this.browserBackEvent = true;
      this.insightsDataService.setRefreshAiData(true);
      const parsedUrl = this.router.parseUrl(p.url);
      const searchSource = parsedUrl.queryParams.searchSource;
      const localKey = parsedUrl.queryParams.filter;
      const filterType = parsedUrl.queryParams.filtertype;
      const filtervalue = parsedUrl.queryParams.filtervalue;
      const keyword = parsedUrl.queryParams.keyword;
      const type = parsedUrl.queryParams.type;
      const redirectSource = parsedUrl.queryParams.redirectSource;

      if (localKey  && (type == 'quick-search' || type == 'advanced-search' || type == 'similar-candidate-from-linkedinurl' || type === 'similar-candidate-resume-upload' || type === 'job-description' || searchSource == 'history-component' || redirectSource == 'talent-insights' || redirectSource == 'company-insights' || type === 'nl-search')) {
        const cacheRequest = localStorage.getItem(localKey);
        const filterData = cjson.decompress(JSON.parse(cacheRequest))

        if (filterData?.calledFrom == 'history' || filterData?.calledFrom == 'advance') {


          if(filterData?.calledFrom == 'history'){
            filterData.allLists['booleanquery'] = filterData.requestObject?.booleanquery;
          }

          this.dataService.setData(filterData);
          this.loadFilterFromLocalStorage(filterData.allLists);
        } else if (type === 'similar-candidate-from-linkedinurl' || type === 'similar-candidate-resume-upload') {
          this.isSimilarCanidate = true;
          this.isCalledFromSimilar = true;
          this.similarCandidateService.setListingCalledFromSimilarCandidate(true);
          this.similarobject = JSON.parse(this.localstorageservice.getItem('similar-candidates-additional-filters'));
          this.loadFilterFromLocalStorage(filterData);
        } else if (type === 'job-description' || type === 'nl-search') {
          this.loadFilterFromLocalStorage(filterData);
        } else {
          const recCandidateDataSub = this.aggregationService.recCandidateDataEvent.subscribe(data =>  this.talentdiscoveryhistoryid = data.talentdiscoveryhistoryid);
          this.subscriptions.push(recCandidateDataSub);
          this.loadFilterFromLocalStorage(filterData);
        }
      }
    });

    this.subscriptionsLike.push(statemanagementSub);

    this.receivedData = this.dataService.getData();
    if (this.receivedData != null && this.receivedData != undefined && this.receivedData.calledFrom == 'advance') {
      delete this?.receivedData?.requestObject?.fetchtotalpersoncountincontinent;
      Object.keys(this.receivedData.allLists).forEach(x => {
        if (x == 'fromgraduationyear') {
          this.fromgraduationyear.setValue(this.receivedData.allLists[x]);
        } else if (x == 'tograduationyear') {
          this.tograduationyear.setValue(this.receivedData.allLists[x]);
        } else if (x == 'yearsofexperienceFrom') {
          this.yearsofexperienceFrom.setValue(this.receivedData.allLists[x])
        } else if (x == 'yearsofexperienceTo') {
          this.yearsofexperienceTo.setValue(this.receivedData.allLists[x])
        } else if (x == 'currentfromyearsofexperience') {
          this.currentfromyearsofexperience.setValue(this.receivedData.allLists[x])
        } else if (x == 'currenttoyearsofexperience') {
          this.currenttoyearsofexperience.setValue(this.receivedData.allLists[x])
        } else if (x == 'continentstobeincluded') {
          this.locationContinents = this.receivedData.allLists[x]
        } else {

          this[x] = this.receivedData.allLists[x]

          const keysToRemove = new Set(this.receivedData.allLists.contactSelectedList.map(item => item.key));

          this.receivedData.allLists.contactsAvailableArray = this.receivedData.allLists.contactsAvailableArray.filter(item => !keysToRemove.has(item.key));



        }
      })

      //Add salary range selected
      this.getPersonSearchRecommendedCandidates(this.receivedData.requestObject, true)

    } else if (this.receivedData != null && this.receivedData != undefined && this.receivedData.calledFrom == 'history') {
      this.isCalledFromHistory = true;
      // console.log(this.receivedData.allLists)
      if (this.receivedData?.allLists?.isSimilarCanidate) {
        this.isCalledFromSimilar = true;
        this.similarCandidateService.setListingCalledFromSimilarCandidate(true);
        this.similarobject = this.receivedData.allLists.similarobject;
        this.similarCandidateService.setSimilarCandidatesData(this.similarobject);
        this.getsimilarcandidatetooltiptext();
      }

      if(this.jdDataService.isComingFromJobDescription){
        this.localstorageservice.setItem('jdinsightshistoryid', this.receivedData.requestObject['jdsearchhistoryid']);

        this.filterData.booleanquery = this.receivedData.requestObject['booleanquery'];
        this.filterDataHandlerService.setFilterData(this.filterData);
      }
      Object.keys(this.receivedData.allLists).forEach(x => {
        if (x == 'fromgraduationyear') {
          this.fromgraduationyear.setValue(this.receivedData.allLists[x]);
        } else if (x == 'tograduationyear') {
          this.tograduationyear.setValue(this.receivedData.allLists[x]);
        } else if (x == 'yearsofexperienceFrom') {
          this.yearsofexperienceFrom.setValue(this.receivedData.allLists[x])
        } else if (x == 'yearsofexperienceTo') {
          this.yearsofexperienceTo.setValue(this.receivedData.allLists[x])
        } else if (x == 'currentfromyearsofexperience') {
          this.currentfromyearsofexperience.setValue(this.receivedData.allLists[x])
        } else if (x == 'currenttoyearsofexperience') {
          this.currenttoyearsofexperience.setValue(this.receivedData.allLists[x])
        } else if (x == 'continentstobeincluded') {
           if(this.receivedData.allLists.locationSelectedList && this.receivedData.allLists.locationSelectedList.length > 0) {
            this.locationSelectedList = this.receivedData.allLists.locationSelectedList;
            this.locationContinents = this.receivedData.allLists[x];
          } else {
            if(this.receivedData.allLists["continentstobeincluded"][0] != "" && !this.isComingFromJD && !this.isComingNLSearch && !this.isCalledFromSimilar) {
              this.sessionStorageService.setItem("historyRegion", this.receivedData.allLists["continentstobeincluded"][0])
              this.locationSelectedList.push({key: this.searchHistoryRegion, chipkey: this.searchHistoryRegion, value: this.searchHistoryRegion, location_type: 'continent'});

            }
          }

     if(!Array.isArray(this.receivedData.allLists?.continentstobeincluded)) {
      this.requestObject.continentstobeincluded = [];
    }
    if(this.isComingFromJD || this.isComingNLSearch || this.isCalledFromSimilar) {
      if(this.receivedData.allLists["continentstobeincluded"] && this.receivedData.allLists["continentstobeincluded"].length > 0 && this.receivedData.allLists["continentstobeincluded"][0] != "") {
      this.locationContinents = this.receivedData.allLists["continentstobeincluded"] ? this.receivedData.allLists["continentstobeincluded"] : [];
      if(this.locationContinents.length > 0) {
      this.sessionStorageService.setItem("historyRegion", this.locationContinents);
      if(this.receivedData.allLists['locationcontinents']?.length == 0) {
         if(this.isComingFromJD || this.isComingNLSearch || this.isCalledFromSimilar) {
        this.similarobject.data.locationcontinent = this.locationContinents;
       }
      }

      }
    } else {
      if(typeof this.receivedData.allLists["continentstobeincluded"] == "string") {
        this.locationContinents = [this.receivedData.allLists["continentstobeincluded"]];
        if(this.receivedData.allLists['locationcontinents']?.length == 0) {
 if(this.isComingFromJD || this.isComingNLSearch || this.isCalledFromSimilar) {
                this.similarobject.data.locationcontinent = this.locationContinents;

              }
             }
      }
    }
    }
        } else if (x == 'companysize') {
          this.companysize = this.receivedData.allLists['companysize']
        } else if (x == 'seniority') {
          this.seniority = this.receivedData.allLists['seniority']
        } else {

          this[x] = this.receivedData.allLists[x]

          // const keysToRemove = new Set(this.receivedData.allLists.contactSelectedList.map(item => item.key));

          // this.receivedData.allLists.contactsAvailableArray = this.receivedData.allLists.contactsAvailableArray.filter(item => !keysToRemove.has(item.key));
        }

        if (x == 'changedjobs') {
          this.changedJobStatus = this.receivedData.allLists[x];
          this.filterDataHandlerService.setChangedJobFilter(this.receivedData.allLists[x]);
        }

        if (x == 'changedjobsstartdurationinmonths') {
          this.changedJobStartDuration = this.receivedData.allLists[x];
        }
        if (x == 'changedjobsenddurationinmonths') {
          this.changedJobEndDuration = this.receivedData.allLists[x];
          this.changedJobDuration = this.receivedData.allLists[x];
        }
        if (x == 'changedjobs' && this.receivedData.allLists[x] == 'yes') {
          this.isChangedJobsSelected = true;
        }
        if (x == 'filterLikelyToMoveIn') {
          this.candidateslikelytomove = this.receivedData.allLists[x];
        }
        if(x == 'nlsearchquery') {
          this.nlSearchQuery = this.receivedData.allLists[x];
          localstorageservice.setItem('nlSearchKeyword', this.nlSearchQuery);
        }
        if(x == 'locationcontinents') {
          this.similarLocationContinents = this.receivedData.allLists[x];
              if(this.isComingFromJD || this.isComingNLSearch || this.isCalledFromSimilar) {
                this.similarobject.data.locationContinentName = this.similarLocationContinents
              }
        }
      })
      setTimeout(() => this.getPersonSearchRecommendedCandidates(this.receivedData.requestObject, true));
    }

    this.isGenderSelected = this.gender && this.gender != 'All' ? true : false;
    this.isCompanySizeSelected = this.companysize && this.companysize.length > 0 ? true : false
    // this.filterAppliedOnYearsOfExperience = this.yearsofexperienceFrom.value && this.yearsofexperienceTo.value ? true : false
    let yearFrom = this.yearsofexperienceFrom.value
    let yearTo = this.yearsofexperienceTo.value
    if (yearFrom != null && yearTo != null) {
      this.filterAppliedOnYearsOfExperience = yearFrom.toString() && yearTo.toString() ? true : false
    }


    let yearFromCurrent = this.currentfromyearsofexperience.value
    let yearToCurrent = this.currenttoyearsofexperience.value
    if (yearFromCurrent != null && yearToCurrent != null) {
      this.filterAppliedOnCurrentYearsOfExperience = yearFromCurrent.toString() && yearToCurrent.toString() ? true : false
    }


    this.linkedInUrlFromSimilarCandidates = this.route.snapshot.queryParams['linkedinurl'];
    if (this.linkedInUrlFromSimilarCandidates) {
      this.similarCandidateService.setListingCalledFromSimilarCandidate(true);
      this.isCalledFromSimilar = true;
    }
    this.filterAppliedOnYearsOfGraduation = (this.fromgraduationyear.value || this.tograduationyear.value) ? true : false
    if (this.isCalledFromHistory == false) {
      const ss = this.route.snapshot.queryParams;
      this.searchKeyword = ss['keyword'];
      this.searchedfrom = ss['type'];
      const source = this.route.snapshot.queryParams['redirectSource'];
      this.redirectSource = source;
      this.filterType = this.route.snapshot.queryParams['filtertype'];
      if (this.searchedfrom == 'similar-candidate-from-linkedinurl' || this.searchedfrom == 'view-similar-candidate' || this.searchedfrom == 'similar-candidate-resume-upload' && this.searchedfrom !== GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION && this.searchedfrom !== GeneralConstants.REDIRECT_SOURCES.NL_SEARCH) {
        this.isSimilarCanidate = true;
        this.isCalledFromSimilar = true;
        this.similarCandidateService.setListingCalledFromSimilarCandidate(true);
        this.similarobject = JSON.parse(this.localstorageservice.getItem('similar-candidates-additional-filters'));

        this.similarCandidateService.setSimilarCandidatesData(this.similarobject);
        this.getsimilarcandidatetooltiptext();
      }

    }



  }

  subscriptions: Subscription[] = [];

  ngOnInit(): void {
    

    this.checkAegisIntegrationConnected();

    this.showregion = this.localstorageservice.getItem('region');
    this.personSearchService.getGeoIpLocationOfUser.subscribe((response: any) => {
      this.showregion = this.localstorageservice.getItem('region') ? this.localstorageservice.getItem('region') : response.continent ? response.continent.toLowerCase() : 'asia';
      this.localstorageservice.setItem('region', this.showregion);
    });

    this.route.queryParams.subscribe(params => {
      const searchSource = params['searchSource'];
      if (searchSource == "history-component") {
        this.searchHistoryRegion = this.sessionStorageService.getItem("historyRegion")
      } else {
        this.searchHistoryRegion = null;
      }
    });

    this.getAllScreenAIJobs();
    /**
    * This handles search with debouncing for screenai jobs
    */
    this.job_input.valueChanges
    .pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap((query: string) => {
        const q = (query || '').trim();
        return this.atsResumeScreenService.getAllScreenAIJobsBySource(q, 'create');
      }),
      takeUntil(this.destroy$)  // prevent memory leak
    )
    .subscribe((res: any) => {
      // Handle both the empty array shortcut and API response
      if (Array.isArray(res)) {
        this.jobList = res;
        return;
      }
      if (res.status === 'success') {
        this.jobList = res.data || [];
      }
    });

    // this.insightsDataService.setInsightsActive(false);

    this.unifiedService.getUserUnifiedIntegrations('', true).subscribe((integrations) => {
      if (integrations.status == 'success') {
        this.availableIntegrations = integrations.data.map(i => ({ ...i, processing: false }));
      }
    });

    const statsUpdateSub = this.aggregationService.statsUpdateEvent.subscribe(res => this.setMatrixStats(res));
    const changeJobSub = this.aggregationService.changedJobStatsEvent.subscribe(res => this.setChangeJobStats(res));
    this.aggregationService.setResetChangedJob.subscribe(res => {
      this.changedJobEndDuration = 12,
        this.changedJobStartDuration = 0;
      this.changedJobDuration = 12;
      this.changedJobStatus = 'all';
      this.isChangedJobsSelected = false;
      this.isChangedJobsSelected = false;
    })
    this.subscriptions.push(changeJobSub);
    this.subscriptions.push(statsUpdateSub);

    // If recommended candidate API is called from other component/service this event will be emitted
    const recCandidateDataSub = this.aggregationService.recCandidateDataEvent.subscribe(data => this.handleGetPersonSearchAPI(data));
    this.subscriptions.push(recCandidateDataSub);

    // If the stats matrix is updateed through filter component this event will be emitted
    const filterMatrixSub = this.statsMatrixHandlerService.filterMatrixEvent.subscribe(matrixFilter => this.handleMatrixUpdateEvent(matrixFilter));
    this.subscriptions.push(filterMatrixSub);

    // This event makes sure that pagination and similar properties are reset as per changes in filter
    const filterMethodSub = this.filterDataHandlerService.filterMethodEvent.subscribe(filterObj => {
      this.showLocationDisplayCard = false;
      const excludeFromAITitles = [];
      const collectiveSearchTerm = [];
      const filterData = this.filterDataHandlerService.fetchFilterData;

      if (filterData.companySelectedList && filterData.companySelectedList.length) this.showCompanyDisplayCard = false;
      this.topSuggestedLocations = [];


      if (filterData.locationSelectedList.length && filterData.locationSelectedList.filter(l => !l.isSuggested).length && filterObj && (filterObj.methodName == 'addToSelectedList' || filterObj.methodName == 'selectedItem' || filterObj.methodName == 'removeChip') && !filterData.companySelectedList.length) {
        const userSelectedLocation = filterData.locationSelectedList.filter(l => !l.isSuggested && !l.key.includes('.iplocation')).map(i => i.key.replace('.aisearch', '').replace('.searchastext', ''));
        const countries = userSelectedLocation.filter(l => l.split(',').length == 3).map(l => l.split(',')[2].trim()).filter(Boolean);
        countries && countries.length && this.getLocationAggs(countries);
      }

      if (filterData.jobTitleSelectedList.length) {
        const userSelectedTitle = filterData.jobTitleSelectedList.filter(i => !i.isSuggested).map(i => i.chipkey);
        // @ts-ignore
        collectiveSearchTerm.push(...userSelectedTitle);
        excludeFromAITitles.push(...userSelectedTitle);
      }

      if (filterData.skillsSelectedList.length) {
        const userSelectedSkills = filterData.skillsSelectedList.filter(i => !i.isSuggested).map(i => i.chipkey);
        collectiveSearchTerm.push(...userSelectedSkills);
        excludeFromAITitles.push(...userSelectedSkills);
      }

      const collectiveSearchTermString = collectiveSearchTerm.filter(Boolean).join(" OR ");
      this.queryForAI = collectiveSearchTermString.trim();
      this.excludeFromAI = excludeFromAITitles.filter(Boolean);

      this.resetDataForFilter(filterObj)
    });
    this.subscriptions.push(filterMethodSub);

    const filterData = this.filterDataHandlerService.fetchFilterData;

    const updateTitleSuggestions = filterData.jobTitleSelectedList.filter(jt => jt.isSuggested).map<SuggestedTitle>(js => ({ name: js.chipkey, selected: true, type: 'title', key: this.getSafeKey(js.chipkey) }));
    const updateSkillSuggestions = filterData.skillsSelectedList.filter(jt => jt.isSuggested).map<SuggestedTitle>(js => ({ name: js.chipkey, selected: true, type: 'skill', key: this.getSafeKey(js.chipkey) }));

    const aiDataToUpdate = updateTitleSuggestions.concat(updateSkillSuggestions);
    this.selectedTitles = aiDataToUpdate;

    this.updateChips.emit(aiDataToUpdate);

    const aiSuggestionSubscription = this.filterDataHandlerService.fetchAISuggestionData.subscribe(chips => this.updateChipSelection(chips));
    this.subscriptions.push(aiSuggestionSubscription);

    const loaderSub = this.loaderEventService.loaderEvent.subscribe(event => this.setLoaders(event));
    this.subscriptions.push(loaderSub);

    const source = this.route.snapshot.queryParams['redirectSource'];
    this.redirectSource = source;
    // this.redirectData = this.localstorageservice.getItem('talentfilters') ? JSON.parse(this.localstorageservice.getItem('talentfilters')) : null;
    this.redirectSource = this.route.snapshot.queryParams['redirectSource'];
    this.redirectData = this.redirectSource == 'talent-insights' && this.localstorageservice.getItem('talentfilters') ? JSON.parse(this.localstorageservice.getItem('talentfilters')) : this.redirectSource == 'company-insights' && this.localstorageservice.getItem('companyinsightsdetails') ? JSON.parse(this.localstorageservice.getItem('companyinsightsdetails')) : null;
    const redirectDataV2 = this.aggregationService.getTalentInsightsRedirectDataV2();
    this.redirectDataV2 = redirectDataV2;
    const redirectDataMandatory = this.aggregationService.getTalentInsightsMandatoryData();
    if (source === 'talent-insights' && redirectDataV2 && !_.isEmpty(redirectDataV2) && redirectDataMandatory?.additionalFilters) {
      this.redirectData = redirectDataMandatory;
      this.talentInsightsContinent = this.redirectDataV2.continentstobeincluded;
      this.locationContinents = this.redirectDataV2.continentstobeincluded;
      if(this.receivedData?.nlsearchquery) {
        this.localstorageservice.setItem('nlSearchKeyword', this.receivedData?.nlSearchKeyword);
      }
      this.setTalentInsightsRedirectData(redirectDataV2);
      this.checkGenderSelectionFromInsights(redirectDataV2);
      return;
    }

    const companyredirectDataV2 = this.aggregationService.getCompanyInsightsRedirectDataV2();
    companyredirectDataV2 && (companyredirectDataV2.continentstobeincluded = []);
    this.companyredirectData = companyredirectDataV2;
    const companyRedirectMandatory = this.aggregationService.getCompanyInsightsMandatoryData();

    if (source === 'company-insights' && companyredirectDataV2 && !_.isEmpty(companyredirectDataV2) && companyRedirectMandatory.additionalFilters) {
      this.redirectData = companyRedirectMandatory;
      this.setTalentInsightsRedirectData(companyredirectDataV2);
      this.hasEuAccess = this.localstorageservice.getItem('hasEUPersonSearchAccess');

      return;
    }


    if (this.redirectSource == 'talent-insights' && this.redirectData.additionalFilters) {

      this.redirectJobTitleFilters = this.redirectData.jobtitle && this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatoryjobtitles ? _.uniq(this.redirectData.jobtitle.concat(this.redirectData.additionalFilters.mandatoryjobtitles).map(i => i.replace(/\.searchastext/g, ''))) : this.redirectData.jobtitle ? _.uniq(this.redirectData.jobtitle.map(i => i.replace(/\.searchastext/g, ''))) : this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatoryjobtitle ? _.uniq(this.redirectData.additionalFilters.mandatoryjobtitle.map(i => i.replace(/\.searchastext/g, ''))) : [];

      this.redirectSkillsFilters = this.redirectData.skills && this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatoryskills ? _.uniq(this.redirectData.skills.concat(this.redirectData.additionalFilters.mandatoryskills).map(i => i.replace(/\.searchastext/g, ''))) : this.redirectData.skills ? _.uniq(this.redirectData.skills.map(i => i.replace(/\.searchastext/g, ''))) : this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatoryskills ? _.uniq(this.redirectData.additionalFilters.mandatoryskills.map(i => i.replace(/\.searchastext/g, ''))) : [];

      this.redirectLocationFilters = this.redirectData.location && this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatorylocations ? _.uniq(this.redirectData.location.concat(this.redirectData.additionalFilters.mandatorylocations).map(i => i.replace(/\.searchastext/g, ''))) : this.redirectData.location ? _.uniq(this.redirectData.location.map(i => i.replace(/\.searchastext/g, ''))) : this.redirectData.additionalFilters && this.redirectData.additionalFilters.mandatorylocations ? _.uniq(this.redirectData.additionalFilters.mandatorylocations.map(i => i.replace(/\.searchastext/g, ''))) : [];

      Object.keys(this.redirectData.additionalFilters).forEach(filter => {
        Object.assign(this.redirectData, { [filter]: this.redirectData.additionalFilters[filter] })
      });
      this.redirectFilters = _.uniq(Object.keys(this.redirectData).filter(key => key != 'additionalFilters' && key != 'totalcount' && key != 'jobtitle' && key != 'location' && key != 'skills' && key != 'mandatoryjobtitles' && key != 'mandatorylocations' && key != 'mandatoryskills' && key != 'recentgraduatesonly' && key != 'recentcompanyhires' && key != 'recentcompanyattrition')
        .reduce((acc, curr) => {
          if (Array.isArray(this.redirectData[curr]) && this.redirectData[curr].length) {
            acc = acc.concat(this.redirectData[curr]);
          } else if (this.redirectData[curr] && !Array.isArray(this.redirectData[curr])) {
            acc = acc.concat(this.redirectData[curr] + ' yrs');
          }
          return acc;
        }, []).map(i => i.replace(/\.searchastext/g, '')));

      this.getPersonSearchRecommendedCandidates(null, true);
      return;
    }

    this.linkedInUrlFromSimilarCandidates = this.route.snapshot.queryParams['linkedinurl'];
    if (this.linkedInUrlFromSimilarCandidates) {
      this.isCalledFromSimilar = true;
      this.isSimilarCanidate = true;

      this.similarCandidateService.setListingCalledFromSimilarCandidate(true);
      this.getdetailsFromLinkedin();
      return;
    }

    const ss = this.route.snapshot.queryParams;
    this.searchKeyword = ss['keyword'];
    this.searchType = ss['searchtype']
    this.filterValue = ss['filtervalue']

    this.sourceRedirectRef = ss['source'];
    this.bucketName = ss['bucketName'];
    this.bucketId = ss['bucketId']
    this.searchSource = ss['searchSource']
    if (this.isCalledFromSimilar == false) {
      this.searchedfrom = ss['type']
    }


    this.route.queryParams.pipe(skip(1)).subscribe(params => {
      this.searchKeyword = params['keyword'];
      this.searchType = params['searchtype']

      this.sourceRedirectRef = params['source'];
      this.bucketName = params['bucketName'];
      this.bucketId = params['bucketId']
      this.searchSource = params['searchSource']
      if (this.isCalledFromSimilar == false) {
        this.searchedfrom = params['type']
      }
      if (this.searchKeyword) {
        if (this.isCalledFromSimilar === false) {
          // this.getPersonSearchRecommendedCandidates(null, true);
        }
      }

    });

    this.yearsofexperienceFrom.valueChanges.subscribe(value => {
      // Perform the validation check here
      this.validateYearsOfExperience(value);
    });


    this.yearsofexperienceTo.valueChanges.subscribe(value => {
      // Perform the validation check here
      this.validateYearsOfExperience(value);
    });

    this.currentfromyearsofexperience.valueChanges.subscribe(value => {
      // Perform the validation check here
      this.validateCurrentYearsOfExperience(value);
    });


    this.currenttoyearsofexperience.valueChanges.subscribe(value => {
      // Perform the validation check here
      this.validateCurrentYearsOfExperience(value);
    });

    if (this.candidateslikelytomove === 'Yes') {
      this.isLikelyToMoveInFilterSelected = true;
    }
    if (this.changedJobStatus === 'yes') {
      this.isChangedJobsSelected = true;
    }
    if (this.gender === 'Male') {
      this.isMaleMatrixSelected = true;
    }
    if (this.gender === 'Female') {
      this.isFemaleMatrixSelected = true;
    }

    if((this.isComingFromJD || this.isComingNLSearch) && !this.onRefreshAvoidApiCall) {
    const jdsubscription = this.jdDataService.jdDataForRedirect.subscribe(response => {
      if (response) {
        this.openSimilarCandidateFilters(response, true);
    this.jdDataService.clearjdData();
      } else {
         const jdDataFromSession = this.jdDataService.jdDataFromSession;
      jdDataFromSession && this.getPersonSearchRecommendedCandidates();

      }
    });
        this.subscriptions.push(jdsubscription);

  }
  if(!this.onRefreshAvoidApiCall && this.isCalledFromSimilar && !this.isCalledFromHistory) {
    const comingFrom = this.route.snapshot.queryParams.redirectFrom;
    if(comingFrom && comingFrom == 'candidate-card') {
        this.similarobject = this.localstorageservice.getItem('candidate');
  this.similarCandidateService.setSimilarCandidatesData(this.similarobject);
      this.redirectOpenSimilarCandidate(this.similarobject);
    } else {
    const scLoadSub = this.similarCandidateService.similarCandidateObs.subscribe(response => {
      if(response) {
      this.similarobject = response;
      this.similarCandidateService.setSimilarCandidatesData(this.similarobject);
      this.redirectOpenSimilarCandidate(this.similarobject);
      }


    });
    this.subscriptions.push(scLoadSub);
  }
  }
  }

  /**
   * Checks if the Aegis integration is connected by calling the Aegis integration service.
   */
  checkAegisIntegrationConnected() {
    this.aegisIntegrationService.checkAegisIntegrationConnected().subscribe((response: any) => {
      if (response && response.body && response.body?.success) {
        this.isAegisConnected = true;
      } else {
        this.isAegisConnected = false;
      }
    }, (error) => {
      this.isAegisConnected = false;
    });
  };

  /**
   * Attach unified integration to job modal and input for job search
   * Always open the modal with the integration selected. DO NOT open the modal directly.
   * Otherwise, you will only see empty modal.
   * @param integration
   */
  attachUnifiedIntegrationToJobModal(integration: IUnifiedIntegration & { user: null | { enabled: boolean, connection_id: string }, processing: boolean }): SubscriptionLike {
    this.selectedIntegration = Object.assign({}, integration);
    const valueChangeSubscription = this.unifiedJobInput.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter((value) => {
        this.unifiedJobList = [];
        if (typeof value !== 'string') {
          return false;
        }
        const si: any = this.selectedIntegration;
        if (si) {
          delete si.job; // Remove the job id if the user is typing
        }
        return !!value;
      }),
      switchMap((value) => this.unifiedService.queryJobs(integration.id, value))
    ).subscribe((response) => {
          if (response.status === 'success') {
            this.unifiedJobList = response.data;
          } else {
            this.unifiedJobList = [];
          }
    });
    return valueChangeSubscription;
  }

  /**
   * Select job from the list of jobs for the selected integration
   * @param event
   */
  onJobSelected(event: MatAutocompleteSelectedEvent) {
    const job = event.option.value as AtsJob;
    this.unifiedJobInput.setValue(job.name, { emitEvent: false });
    // Do NOT Remove the below lines. This is to avoid type error. (This might look like unnecessary code, but it is necessary)
    const si: any = this.selectedIntegration;
    if (si) {
      si.job = job.id; // Set the job id to send to API
    }
  }

  /**
   * Create unified application for the selected integration
   * This will create a candidate and attach the candidate to the job
   * This will also close the modal and reset the selected integration
   */
  createUnifiedApplication() {
    // Do NOT Remove the below lines. This is to avoid type error. (This might look like unnecessary code, but it is necessary)
    const si = this.selectedIntegration as any;
    // Check if the selected integration has candidate and job
    if (si && si.candidate && si.job) {
      this.isLoadingJobApi = true;
      this.unifiedJobInput.disable();
      this.unifiedService.createApplication(si.id, si.job, { candidate_id: si.candidate }).subscribe((response) => {
        if (response.status === 'success') {
          this.toastmessage("Candidate added successfully", 'success');
        } else {
          this.toastmessage("Something went wrong", 'error');
        }
        this.closeAllModals();
        this.isLoadingJobApi = false;
        this.unifiedJobInput.enable();
        this.unifiedJobInput.setValue('');
        this.selectedIntegration = null;
      });
    }
  }

  /**
   * Add candidate to ATS
   * @param integration
   */
  async addCandidateToIntegration(integration: IUnifiedIntegration & { user: null | { enabled: boolean, connection_id: string }, processing: boolean }, candidate: any, opts: { force?: boolean, candidatenumber?: string } = { force: false }) {
    if (opts.force) {
      this.closeAllModals(); // Close all modals before opening the new one. This is to avoid multiple modals open at the same time.
    }
    this.selectedIntegration = Object.assign({}, integration);
    this.selectedIntegration.processing = true;
    this.unifiedJobInput.setValue(null);

    this.modalService.open(this.addCandidateToIntegrationTemplate, { centered: true, keyboard: false, backdrop: 'static' });

    if (!candidate.candidatenumber) {
      // migrate candidate
      const resp = await this.emailCampaignService.migrateCandidates({
        elasticid: [candidate.id]
      }).toPromise();
      if (resp.status === 'success' && resp.data.length) {
        opts.candidatenumber = resp.data[0].candidatenumber // Set the candidate number to send to API
      }
    } else if (candidate.candidatenumber) {
      opts.candidatenumber = candidate.candidatenumber // Set the candidate number to send to API
    }

    this.unifiedService.createCandidate(this.selectedIntegration.id, this.transformToUnifiedCandidate(candidate), opts).subscribe((response) => {
      this.selectedIntegration.processing = false;
      if (response.status == 'success') {
        const data = response.data;
        // Do NOT Remove the below lines. This is to avoid type error. (This might look like unnecessary code, but it is necessary)
        const s: any = this.selectedIntegration;
        if (data.duplicate === true) {
          // Set the candidate number to display in the modal
          s.duplicate = true;
          s.candidate = candidate;
          s.count = data.count;
          s.processing = false;
          return; // Do not close the modal
        } else {
          // open the job modal
          s.candidate = data.id;
          const valChangeSub = this.attachUnifiedIntegrationToJobModal(this.selectedIntegration);
          const modalRef = this.modalService.open(this.tagToAtsJobTemplate, { centered: true, keyboard: false, backdrop: 'static' });
          modalRef.result.catch(() => {
            this.toastmessage("Candidate added successfully", 'success');
          }).finally(() => {
            if (valChangeSub) {
              valChangeSub.unsubscribe(); // This is to avoid memory leak
            }
            this.unifiedJobList = [];
            this.selectedIntegration = null;
          });
        }
      } else {
        this.toastmessage("Something went wrong", 'error');
        this.dismissAddCandidateToIntegrationModal();
      }
    }, (error) => {
      this.toastmessage("Something went wrong", 'error');
      this.dismissAddCandidateToIntegrationModal();
    });
  }

  /**
   * Transform candidate to unified candidate
   * @param candidate
   * @returns
   */
  private transformToUnifiedCandidate(candidate: any): AtsCandidate {
    const unifiedCandidate: AtsCandidate = {};
    unifiedCandidate.origin = 'SOURCED';
    unifiedCandidate.name = GlobalService.titleCase(candidate.full_name);
    unifiedCandidate.companyName = GlobalService.titleCase(candidate.job_company_name);
    unifiedCandidate.title = GlobalService.titleCase(candidate.job_title);
    unifiedCandidate.address = {
      country: candidate.location_country || '',
      region: candidate.location_region || '',
      city: candidate.location_locality || candidate.location_metro || ''
    }
    unifiedCandidate.sources = ['Webbtree'];
    if (candidate.linkedin_url) {
      unifiedCandidate.linkUrls = [
        candidate.linkedin_url.startsWith('http') ? candidate.linkedin_url : `https://${candidate.linkedin_url}`
      ];
    }
    unifiedCandidate.emails = [];
    if (candidate.existingContactDetails && candidate.existingContactDetails.length) {
      candidate.existingContactDetails.filter((c: any) => c.type === 'email').forEach((contact: any) => {
        unifiedCandidate.emails.push({
          email: contact.contactdetail,
          type: contact.contactdetailcategory === 'professional' ? 'WORK' : 'HOME'
        });
      });
    }
    if (candidate.existingContactDetails && candidate.existingContactDetails.length) {
      candidate.existingContactDetails.filter((c: any) => c.type === 'contactnumber').forEach((contact: any) => {
        unifiedCandidate.telephones = [{
          telephone: contact.contactdetail,
          type: contact.contactdetailcategory === 'professional' ? 'WORK' : 'MOBILE'
        }];
      });
    }
    return unifiedCandidate;
  }

  dismissAddCandidateToIntegrationModal() {
    this.selectedIntegration = null;
    this.closeAllModals();
  }

  /**
   * Used to change number of profiles on each page
   */
  updatePagePreference() {
    const data = {
      preference_type: 'page-size',
      preference_value: this.profilesPerPage,
      listing_type: 'person-search'
    }

    try {
      this.personSearchService.updatePagePreference(data);
      this.setPage(1);
    } catch {
      this.toastmessage("Something went wrong", 'error');
    }
  }

  get isComingFromJD() {
    return this.jdDataService.isComingFromJobDescription;
  }

  get isComingNLSearch() {
    return this.jdDataService.isComingFromNLSearch;
  }

  /**
   *
   * This method is specifically used for jd search and on first load or page refresh
   */
  private openSimilarCandidateFilters(jdResponse: any, firstLoad = false) {
        const uniqueHash = this.route.snapshot.queryParamMap.get(GeneralConstants.LS_KEYS.UNIQUE_HASH);
        this.similarobject = jdResponse ? jdResponse: new SimilarCandidateDetails();

        if(this.similarobject) {

        this.jdDataService.setSessionData(uniqueHash, this.similarobject);
        this.similarCandidateService.setSimilarCandidatesData(this.similarobject);
        this.getsimilarcandidatetooltiptext();
        if(this.isComingNLSearch) {
           this.resetMustAndGoodFilters();
        this.setFilterDataInLocalStorage();
        } else {
          this.jdSearchActivity(this.similarobject);

        }
        } else {
   const jdDataFromSession = this.jdDataService.jdDataFromSession;
      jdDataFromSession && this.getPersonSearchRecommendedCandidates();
        }


        this.jdDataService.jdFilterUpdateEventEmit();
    }



  private checkGenderSelectionFromInsights(redirectDataTI: FilterParams) {
    // TODO : May need to handle same for company insights as well later
    if (this.redirectSource === 'talent-insights' && ["male", "female"].includes(redirectDataTI.gender?.toLowerCase())) {
      this.gender = redirectDataTI.gender;
      this.isGenderSelected = true;
      this.isGenderSelectionDisabled = true;
      if (redirectDataTI.gender.toLowerCase() === 'male') {
        this.isMaleMatrixSelected = true;
        this.isFemaleMatrixSelected = false;
      }
      else if (redirectDataTI.gender.toLowerCase() === 'female') {
        this.isFemaleMatrixSelected = true;
        this.isMaleMatrixSelected = false;
      }
    }
  }

  private setTalentInsightsRedirectData(redirectDataV2: FilterParams) {
    this.redirectJobTitleFilters = this.getSanitizedJobTitles(redirectDataV2);
    this.redirectPastJobTitleFilters = this.getSanitizedPastJobTitles(redirectDataV2);
    this.redirectSkillsFilters = this.getSanitizedSkills(redirectDataV2);
    this.redirectLocationFilters = this.getSanitizedLocations(redirectDataV2);
    const appliedFilters = this.redirectSource == 'talent-insights' ? this.getAppliedFilters(redirectDataV2) : this.getCompanyInsightsFilters(redirectDataV2);
    const mandatoryFilters = this.redirectSource == 'talent-insights' ? this.getMandatoryFields() : this.getCompanyInsightsFields();
    // Combine and deduplicate the arrays based on name and value
    const combinedFilters = appliedFilters.concat(mandatoryFilters);
    const uniqueFilters = combinedFilters.reduce((acc, current) => {
      const exists = acc.some(item => item.value === current.value);
      // const exists = acc.some(item => item.name === current.name && item.value === current.value);
      if (!exists) {
        acc.push(current);
      }
      return acc;
    }, []);

    // Filter out elements with name or value equal to "all"
    this.redirectFilters = uniqueFilters
      .filter(el => el?.value?.trim().toLowerCase() !== "all");
    this.excludeFilters = this.getExcludeFilters(redirectDataV2);
    if(!this.onRefreshAvoidApiCall) {
      this.getPersonSearchRecommendedCandidates(null, true);
    }
  }

  private getMandatoryFields() {
    Object.keys(this.redirectData.additionalFilters).forEach(filter => {
      Object.assign(this.redirectData, { [filter]: this.redirectData.additionalFilters[filter] });
    });

    //When redirect from Talent insights and via jd search
    if(this.redirectData.additionalFilters['job_description_keys']){
      const data = {
        job_description_keys: this.redirectData.additionalFilters['job_description_keys']
      }
      const temp = this.jdDataService.getSimilarObjFromHistory(data);
      this.getsimilarcandidatetooltiptextTIRedirect({data: temp});
    }
    const excludedKeys = new Set([
      'additionalFilters', 'totalcount', 'mandatoryjobtitles', 'mandatorylocations', 'mandatoryskills',
      'recentgraduatesonly', 'recentcompanyhires', 'recentcompanyattrition', 'winningtalent', 'loosingtalent', 'job_description_keys', 'continentstobeincluded', 'nlsearchquery'
    ]);
    const mandatoryFilters = _.uniq(
      Object.keys(this.redirectData)
        .filter(key => !excludedKeys.has(key))
        .reduce((acc, curr) => {
          if (Array.isArray(this.redirectData[curr]) && this.redirectData[curr].length) {
            this.redirectData[curr].forEach(el => {
              let obj = { name: GeneralConstants.HOVER_MANDATORY_FILTER_NAME_MAP[curr], value: el };
              if(curr == "mandatoryfunctions"){
                obj['metaData'] = {
                  tooltipText: `Selecting ${GlobalService.titleCase(el.replaceAll('_', ' '))} includes all its specializations.`
                }
              }
              acc = acc.concat(obj);
            });
          } else if (this.redirectData[curr] && !Array.isArray(this.redirectData[curr])) {
            acc = acc.concat({ name: GeneralConstants.HOVER_MANDATORY_FILTER_NAME_MAP[curr], value: this.redirectData[curr] + ' yrs' });
          }
          return acc;
        }, []).map(obj => ({ name: obj?.name?.replace(/\.searchastext/g, ''), value: obj?.value, metaData: obj?.metaData || {} }))
    );
    return mandatoryFilters;
  }

  private getAppliedFilters(redirectDataV2: FilterParams) {

    const filterNameKey = new Set([
      'companySelectedList', 'companysize', 'industrySelectedList', 'functionSelectedList',
      'seniority', 'yearsofexperienceFrom', 'currentfromyearsofexperience',
      'gender', 'educationSelectedList', 'schoolSelectedList', 'fieldOfStudySelectedList', 'keywordSelectedList', 'tograduationyear'
    ]);

    const appliedFilters = [];
    filterNameKey.forEach(key => {
      let filterText;
      //Valid of yearsofexperiencefrom is zero
      if (key === 'yearsofexperienceFrom' && typeof (redirectDataV2?.yearsofexperienceFrom) == 'number' && typeof (redirectDataV2?.yearsofexperienceTo) == 'number') {
        filterText = redirectDataV2?.yearsofexperienceFrom + ' to ' + redirectDataV2?.yearsofexperienceTo + ' yrs.';
      } else if (key === 'gender') {
        filterText = redirectDataV2?.isGenderSelected ? redirectDataV2[key] : "";
      } else if (key === 'currentfromyearsofexperience' && typeof (redirectDataV2?.currentfromyearsofexperience) == 'number' && typeof (redirectDataV2?.currenttoyearsofexperience) == 'number') {
        filterText = redirectDataV2?.currentfromyearsofexperience + ' to ' + redirectDataV2?.currenttoyearsofexperience + ' yrs.';
      } else if (Array.isArray(redirectDataV2[key])) {
        redirectDataV2[key].forEach(el => {
          if (typeof el === "object" && !el?.isExcluded) appliedFilters.push({ name: [GeneralConstants.HOVER_FILTER_NAME_MAP[key]], value: el?.chipkey, metaData: {tooltipText: el.tooltipText} });
          else if (typeof el === "string") appliedFilters.push({ name: [GeneralConstants.HOVER_FILTER_NAME_MAP[key]], value: el });
        });
      } else if(key == 'tograduationyear' && redirectDataV2.tograduationyear){
        filterText = redirectDataV2?.fromgraduationyear + ' to ' + redirectDataV2?.tograduationyear;
      }
      else {
        filterText = redirectDataV2[key];
      }
      typeof filterText === "string" && filterText.length && appliedFilters.push({ name: [GeneralConstants.HOVER_FILTER_NAME_MAP[key]], value: filterText });
      appliedFilters.push({ name: ['Company'], value: this.redirectData.name })
    });
    return appliedFilters?.filter(el => !!el?.value);
  }

  private getSanitizedPastJobTitles(redirectDataV2: FilterParams) {
    const pastJobTitles = redirectDataV2.pastJobTitleSelectedList?.filter(el => !el.isExcluded)?.map(el => el?.chipkey) || [];
    const sanitizedPastJobTitles = _.uniq(
      pastJobTitles.map(i => i.replace(/\.searchastext/g, ''))
    );
    return sanitizedPastJobTitles;
  }

  private getCompanyInsightsFilters(redirectDataV2: FilterParams) {
    const filterNameKey = new Set([
      'companySelectedList', 'companysize', 'industrySelectedList', 'functionSelectedList',
      'seniority', 'yearsofexperienceFrom', 'currentfromyearsofexperience',
      'gender', 'educationSelectedList', 'schoolSelectedList', 'fieldOfStudySelectedList', 'keywordSelectedList',
      'recentcompanyhires', 'recentcompanyattrition', 'winningtalent', 'loosingtalent', 'continentstobeincluded', 'tograduationyear'
    ]);
    const appliedFilters = [];
    filterNameKey.forEach(key => {
      let filterText;
      if (key === 'yearsofexperienceFrom' && redirectDataV2?.yearsofexperienceFrom && redirectDataV2?.yearsofexperienceTo) {
        filterText = redirectDataV2?.yearsofexperienceFrom + ' to ' + redirectDataV2?.yearsofexperienceTo + ' yrs.';
      } else if (key === 'gender') {
        filterText = redirectDataV2?.isGenderSelected ? redirectDataV2[key] : "";
      } else if (key === 'currentfromyearsofexperience' && redirectDataV2?.currentfromyearsofexperience && redirectDataV2?.currenttoyearsofexperience) {
        filterText = redirectDataV2?.currentfromyearsofexperience + ' to ' + redirectDataV2?.currenttoyearsofexperience + ' yrs.';
      } else if (Array.isArray(redirectDataV2[key])) {
        redirectDataV2[key].forEach(el => {
          if (typeof el === "object" && !el?.isExcluded) appliedFilters.push({ name: [GeneralConstants.HOVER_FILTER_NAME_MAP[key]], value: el?.chipkey });
          else if (typeof el === "string") appliedFilters.push({ name: [GeneralConstants.HOVER_FILTER_NAME_MAP[key]], value: el });
        });
       } else if(key == 'tograduationyear' && redirectDataV2.tograduationyear){
        filterText = redirectDataV2?.fromgraduationyear + ' to ' + redirectDataV2?.tograduationyear;
      }
      else {
        filterText = redirectDataV2[key];
      }
      typeof filterText === "string" && filterText.length && appliedFilters.push({ name: [GeneralConstants.HOVER_FILTER_NAME_MAP[key]], value: filterText });
      appliedFilters.push({ name: ['Company'], value: this.redirectData.name })
    });
    return appliedFilters?.filter(el => !!el?.value);
  }

  private getSanitizedLocations(redirectDataV2: FilterParams) {
    const baseLocations = redirectDataV2.locationSelectedList?.filter(el => !el.isExcluded)?.map(el => el?.chipkey) || [];
    const additionalLocations = this.redirectData?.additionalFilters?.mandatorylocations
      ? this.redirectData.additionalFilters.mandatorylocations
      : this.redirectData?.additionalFilters?.mandatorylocation
        ? this.redirectData.additionalFilters.mandatorylocation
        : [];
    const sanitizedLocations = _.uniq(
      baseLocations?.concat(additionalLocations)
        .map(location => location?.replace(/\.searchastext/g, ''))
    );
    return sanitizedLocations?.filter(Boolean);
  }

  private getSanitizedSkills(redirectDataV2: FilterParams) {
    const baseSkills = redirectDataV2.skillsSelectedList?.filter(el => !el.isExcluded) || [];
    const additionalSkillsRaw = this.redirectData?.additionalFilters?.mandatoryskills
      ? this.redirectData.additionalFilters.mandatoryskills
      : this.redirectData?.additionalFilters?.mandatoryskill
        ? this.redirectData.additionalFilters.mandatoryskill
        : [];

  const additionalSkills = additionalSkillsRaw.map(skill =>
    typeof skill === 'string'
      ? { key: skill, chipkey: skill, isMandatory: true }
      : { ...skill, isMandatory: true }
  );

  const allSkills = baseSkills.concat(additionalSkills);

  // ✅ Preserve all properties like isMandatory, but sanitize chipkey
  const sanitizedSkills = __.uniqBy(
    allSkills.map(skill => ({
      ...skill,
      chipkey: skill?.chipkey?.replace(/\.searchastext/g, '') || skill?.key?.replace(/\.searchastext/g, ''),
    })),
    'chipkey' // deduplicate by chipkey
  );
    return sanitizedSkills;
  }

  private getSanitizedJobTitles(redirectDataV2: FilterParams) {
    const jobTitles = redirectDataV2.jobTitleSelectedList?.filter(el => !el.isExcluded)?.map(el => el?.chipkey) || [];
    const additionalJobTitles = this.redirectData?.additionalFilters?.mandatoryjobtitles
      ? this.redirectData.additionalFilters.mandatoryjobtitles
      : this.redirectData?.additionalFilters?.mandatoryjobtitle
        ? this.redirectData.additionalFilters.mandatoryjobtitle
        : [];
    const sanitizedJobTitles = _.uniq(
      jobTitles.concat(additionalJobTitles)
        .map(i => i.replace(/\.searchastext/g, ''))
    );
    return sanitizedJobTitles;
  }

  private getCompanyInsightsFields() {
    Object.keys(this.redirectData.additionalFilters).forEach(filter => {
      Object.assign(this.redirectData, { [filter]: this.redirectData.additionalFilters[filter] });
    });
    const excludedKeys = new Set([
      'additionalFilters', 'totalcount', 'mandatoryjobtitles', 'mandatorylocations', 'mandatoryskills',
      'recentgraduatesonly', 'recentcompanyhires', 'recentcompanyattrition', 'name', 'alternative_names', 'alternative_company_id', 'lastjobcompanyids', 'companyids', 'durationinmonths'
    ]);
    const mandatoryFilters = _.uniq(
      Object.keys(this.redirectData)
        .filter(key => !excludedKeys.has(key))
        .reduce((acc, curr) => {
          if (Array.isArray(this.redirectData[curr]) && this.redirectData[curr].length) {
            this.redirectData[curr].forEach(el => {
              acc = acc.concat({ name: GeneralConstants.HOVER_MANDATORY_COMPANYFILTER_NAME_MAP[curr], value: el });
            });
          } else if (this.redirectData[curr] && !Array.isArray(this.redirectData[curr])) {
            acc = acc.concat({ name: GeneralConstants.HOVER_MANDATORY_COMPANYFILTER_NAME_MAP[curr], value: this.redirectData[curr] + ' yrs' });
          }
          return acc;
        }, []).map(obj => ({ name: obj.name.replace(/\.searchastext/g, ''), value: obj.value }))
    );
    return mandatoryFilters;
  }

  ngOnDestroy(): void {
    for (let sub of this.subscriptions) { sub.unsubscribe(); }
    this.subscriptionsLike.forEach(sub => sub.unsubscribe());
    this.similarCandidateService.setListingCalledFromSimilarCandidate(false);
    this.aggReqObjectHandlerService.setShareRequestObject({});
    this.closeAllModals();
    this.localstorageservice.setItem('talentdiscoveryhistoryid', null);
    this.destroy$.next(undefined as any);
    this.destroy$.complete();
  }

  private handleGetPersonSearchAPI(data: PersonSearchResponse) {
    this.euAccessMessage = '';
    this.isSearchSaved = false;
    this.showregion = this.localstorageservice.getItem('region');
    this.personSearchService.getGeoIpLocationOfUser.subscribe((response: any) => {
      this.showregion = this.localstorageservice.getItem('region') ? this.localstorageservice.getItem('region') : response.continent ? response.continent.toLowerCase() : 'asia';
      this.localstorageservice.setItem('region', this.showregion);
    });
    const hasEuAccess = this.localstorageservice.getItem('hasEUPersonSearchAccess');
    if (hasEuAccess == 1 && this.showregion == 'europe') {
      const euData = this.localstorageservice.getItem('euConscent');
      const now = new Date().getTime();

      if (euData) {
        const parsedData = JSON.parse(euData);
        if (!parsedData.lastShown || now - parseInt(parsedData.lastShown, 10) > 24 * 60 * 60 * 1000) {
          const modalRef = this.modalService.open(EuropeAccessModalComponent, { windowClass: 'euAccessModal', centered: true, backdrop: 'static', keyboard: false });
          modalRef.result.then((res) => {
            if (res.action == "success") {
              this.talentdiscoveryhistoryid = data.talentdiscoveryhistoryid;
              this.filterDataHandlerService.setTalentDiscoveryHistoryID(data.talentdiscoveryhistoryid);
         //     this.getSavedSearchDetails();
              if (!this.isFilteredFromInsights) { this.previousTotalCandidateCount = data.totalresultscount; }
              this.totalCandidatesCount = data.totalresultscount;
              this.statsMatrixHandlerService.setMatrixStaticData({ totalCandidatesCount: this.totalCandidatesCount });
              this.totalCandidatesCountAvailable = true;
              if (this.totalCandidatesCount < Number(this.profilesPerPage)) { this.end = this.totalCandidatesCount; }

              this.candidateList = data.candidateList;
              this.aggregationService.getStatsAggs();
              this.isInsightsActive && this.aggregationService.getTotalAggs();
              if (data.booleanquery) { this.bucketbooleanquery = data.booleanquery; }
              this.showLoaderbeforeDataLoad = false;
              this.selected = false;
            }
          })
        } else {
          if(data.message && data.message == 'Continent(s) access denied') {
            this.euAccessMessage = "Europe Continent Access Denied";
            this.showLoaderbeforeDataLoad = false;
            this.candidateList = [];
            this.totalCandidatesCount = 0;
            this.totalCandidatesCountAvailable = true;
            this.aggregationService.getStatsAggs();


          } else {
          this.talentdiscoveryhistoryid = data.talentdiscoveryhistoryid;
          this.filterDataHandlerService.setTalentDiscoveryHistoryID(data.talentdiscoveryhistoryid);
        //  this.getSavedSearchDetails();
          if (!this.isFilteredFromInsights) { this.previousTotalCandidateCount = data.totalresultscount; }
          this.totalCandidatesCount = data.totalresultscount;
          this.statsMatrixHandlerService.setMatrixStaticData({ totalCandidatesCount: this.totalCandidatesCount });
          this.totalCandidatesCountAvailable = true;
          if (this.totalCandidatesCount < Number(this.profilesPerPage)) { this.end = this.totalCandidatesCount; }

          this.candidateList = data.candidateList;
          this.aggregationService.getStatsAggs();
          this.isInsightsActive && this.aggregationService.getTotalAggs();
          if (data.booleanquery) { this.bucketbooleanquery = data.booleanquery; }
          this.showLoaderbeforeDataLoad = false;
          this.selected = false;
          }
        }
      } else {
        if(data.message && data.message == 'Continent(s) access denied') {
          this.euAccessMessage = "Europe Continent Access Denied";
          this.showLoaderbeforeDataLoad = false;
          this.candidateList = [];
          this.totalCandidatesCount = 0;
          this.totalCandidatesCountAvailable = true;
          this.aggregationService.getStatsAggs();


        } else {
          this.talentdiscoveryhistoryid = data.talentdiscoveryhistoryid;
          this.filterDataHandlerService.setTalentDiscoveryHistoryID(data.talentdiscoveryhistoryid);
        //  this.getSavedSearchDetails();
          if (!this.isFilteredFromInsights) { this.previousTotalCandidateCount = data.totalresultscount; }
          this.totalCandidatesCount = data.totalresultscount;
          this.statsMatrixHandlerService.setMatrixStaticData({ totalCandidatesCount: this.totalCandidatesCount });
          this.totalCandidatesCountAvailable = true;
          if (this.totalCandidatesCount < Number(this.profilesPerPage)) { this.end = this.totalCandidatesCount; }

          this.candidateList = data.candidateList;

          this.aggregationService.getStatsAggs();
          this.isInsightsActive && this.aggregationService.getTotalAggs();
          if (data.booleanquery) { this.bucketbooleanquery = data.booleanquery; }
          this.showLoaderbeforeDataLoad = false;
          this.selected = false;
        }

      }
    } else {
      this.talentdiscoveryhistoryid = data.talentdiscoveryhistoryid;
          this.filterDataHandlerService.setTalentDiscoveryHistoryID(data.talentdiscoveryhistoryid);
          this.getSavedSearchDetails();
          if (!this.isFilteredFromInsights) { this.previousTotalCandidateCount = data.totalresultscount; }
          this.totalCandidatesCount = data.totalresultscount;
          this.statsMatrixHandlerService.setMatrixStaticData({ totalCandidatesCount: this.totalCandidatesCount });
          this.totalCandidatesCountAvailable = true;
          if (this.totalCandidatesCount < Number(this.profilesPerPage)) { this.end = this.totalCandidatesCount; }

          this.candidateList = data.candidateList;


          this.aggregationService.getStatsAggs();
          this.isInsightsActive && this.aggregationService.getTotalAggs();
          if (data.booleanquery) { this.bucketbooleanquery = data.booleanquery; }
          this.showLoaderbeforeDataLoad = false;
          this.selected = false;
    }
  }

  private setLoaders(event: LoaderType) {
    if (event === LoaderType.RECOMMENDED_CANDIDATE) {
      this.totalCandidatesCountAvailable = false;
      this.showLoaderbeforeDataLoad = true;
      this.turnOnLoaders();
    } else if (event === LoaderType.STATS) {
      this.turnOnLoaders();
    }
  }

  private resetDataForFilter(filterObj: { methodName: string }) {
    if (
      [
        "clearfilters", "selectedItem", "filterByStatus",
        "addToSelectedList", "removeChip", "applyFilter", "mandatoryFilterItem", "excludeFilterItem", "changeContinent", "searchInput"
      ].map(el => el.toLowerCase()).includes(filterObj.methodName?.trim().toLowerCase())
    ) {
      this.resetPagination();
    }
    if (
      [
        "selectedItem", "filterByStatus", "excludeFilterItem",
        "addToSelectedList", "removeChip", "mandatoryFilterItem", "changeContinent", "searchInput"
      ].map(el => el.toLowerCase()).includes(filterObj.methodName?.trim().toLowerCase())
    ) {
      this.isFilteredFromInsights = false;
      this.contactsAvailabilitySelectedFromInsights = false;
    }
    if (
      [
        "removeChip"
      ].map(el => el.toLowerCase()).includes(filterObj.methodName?.trim().toLowerCase())
    ) {
      this.candidateslikelytomove = null;
    }
    this.aggReqObjectHandlerService.setStartIndex(0);
  }

  private handleMatrixUpdateEvent(matrixFilter: MatrixFilter) {
    if (matrixFilter.type === 'gender' && matrixFilter.event?.target?.value === "All") {
      this.isMaleMatrixSelected = false;
      this.isFemaleMatrixSelected = false;
    }
    else if (matrixFilter.type === 'gender' && matrixFilter.event?.target?.value === "Male") {
      this.isMaleMatrixSelected = true;
      this.isFemaleMatrixSelected = false;
    }
    else if (matrixFilter.type === 'gender' && matrixFilter.event?.target?.value === "Female") {
      this.isFemaleMatrixSelected = true;
      this.isMaleMatrixSelected = false;
    }
    else if (matrixFilter.type === 'likelytomovein') {
      this.isLikelyToMoveInFilterSelected = matrixFilter?.event?.target?.value === "Yes";
    }
    // No need to work on this since we don't have this option in filters
    // else if (matrixFilter.type === 'changedJobs') {
    //   this.isChangedJobsSelected = !this.isChangedJobsSelected;
    // }
  }

  private setCountAvailableAll() {
    this.likelyToMoveInCountAvailable = true;
    this.medianTenureInCountAvailable = true;
    this.genderDataAvailable = true;
    this.changedJobsCountAvailable = true;
  }

  getdetailsFromLinkedin() {
    this.personSearchService.getdetailsfromlinkedin(this.linkedInUrlFromSimilarCandidates).subscribe((res: any) => {
      if (res.status == "success") {
        if (res.data) {
          const pastindustries = _.pluck(res.data.experience, 'company')
          const degrees = _.uniq(_.flatten(_.map(res.data.education, 'degrees')));
          const schools = _.pluck(res.data.education, 'school')
          const fieldOfStudy = _.uniq(
            _.flatten(
              _.map(res.data.education, "majors").concat(
                _.map(res.data.education, "minors")
              )
            )
          );

          const locations = []
          const locParts = [];

          res.data.location_locality && locParts.push(res.data.location_locality);
          res.data.location_region && locParts.push(res.data.location_region);
          res.data.location_country && locParts.push(res.data.location_country);

          if (locParts.length) {
            locations.push(locParts.join(', '));
          }

          const totalTenure = res.data.totaltenure || 0;
          let fromYrsOfExperience = 0;
            let toYrsOfExperinece = 0;

            if (!isNaN(totalTenure) && totalTenure >= 0) {
              if (totalTenure > 2) {
                fromYrsOfExperience = Math.floor(totalTenure - 2);
                toYrsOfExperinece = Math.ceil(totalTenure + 2);
              } else {
                fromYrsOfExperience = 0;
                toYrsOfExperinece = Math.ceil(totalTenure + 2);
              }
            }
          this.similarobject = {
            data: {
              jobtitle: res.data.job_title ? [{ key: res.data.job_title, isMandatory: true }] : [],
              jobcompanyname: res.data.job_company_name ? [{ key: res.data.job_company_name, isMandatory: false }] : [],
              jobindustryname: res.data.job_company_industry ? [{ key: res.data.job_company_industry, isMandatory: true }] : [],
              pastindustries: _.pluck(pastindustries, 'industry'),
              degrees: degrees && degrees.length ? degrees.map(d => ({ key: d, isMandatory: false })) : [],
              fieldOfStudy: fieldOfStudy && fieldOfStudy.length ? fieldOfStudy.map(f => ({ key: f, isMandatory: false })) : [],
              schools: schools && schools.length ? _.pluck(schools, 'name').map(el => ({key: el, isMandatory: false}) ) : [],
              currentlocation: _.uniq(locations).map(l => ({ key: l, isMandatory: false })),
              skills: res.data.skills ? res.data.skills.map(s => ({ key: s, isMandatory: false })) : [],
              elasticid: res.data.id,
              companysize: res.data.job_company_size ? [{ key: res.data.job_company_size, isMandatory: false }] : [],
              fullname: res.data.full_name,
              linkedinurl: this.linkedInUrlFromSimilarCandidates,
              isUploadedFromResume: false,
              locationregion: res.data.location_region,
              locationcontinent: res.data.location_continent,
              totaltenure: totalTenure,
              fromYrsOfExperience,
              toYrsOfExperinece,
              calledfrom: "similar"
            }

          }
          this.getsimilarcandidatetooltiptext();
          this.personSearchService.passsimilarcandidatesdata({ ...this.similarobject })
          this.similarCandidateService.setSimilarCandidatesData(this.similarobject);
          this.getPersonSearchRecommendedCandidates(null, true);
        } else if (res.message == 'Person not found') {
          // this.linkedinerrormsg = 'Sorry, for some reason we were unable to find this LinkedIn profile.'
        }
      }
    })

  }

  viewmoredetails(type, data) {
    if (type == 'viewmore' && data == 'currentcompany') {
      document.getElementById('top1').style.display = 'none'
      document.getElementById('top2').style.display = 'block'
      document.getElementById('viewmore1').style.display = 'none'
      document.getElementById('viewless2').style.display = 'block'
    } else if (type == 'viewless' && data == 'currentcompany') {
      document.getElementById('top1').style.display = 'block'
      document.getElementById('top2').style.display = 'none'
      document.getElementById('viewmore1').style.display = 'block'
      document.getElementById('viewless2').style.display = 'none'
    }
    if (type == 'viewmore' && data == 'currentIndustry') {
      document.getElementById('top3').style.display = 'none'
      document.getElementById('top4').style.display = 'block'
      document.getElementById('viewmore3').style.display = 'none'
      document.getElementById('viewless4').style.display = 'block'
    } else if (type == 'viewless' && data == 'currentIndustry') {
      document.getElementById('top3').style.display = 'block'
      document.getElementById('top4').style.display = 'none'
      document.getElementById('viewmore3').style.display = 'block'
      document.getElementById('viewless4').style.display = 'none'
    }
    if (type == 'viewMore' && data == 'similar-candidate') {
      document.getElementById('similarCandidate-viewMore').style.display = 'none';
      document.getElementById('similarCandidate-viewLess').style.display = 'block';
    } else if (type == 'viewLess' && data == 'similar-candidate') {
      document.getElementById('similarCandidate-viewMore').style.display = 'block';
      document.getElementById('similarCandidate-viewLess').style.display = 'none';
    }

    if (type == 'viewMore' && data == 'similar-candidate-must-have') {
      document.getElementById('similarCandidate-viewMore-must-have').style.display = 'none';
      document.getElementById('similarCandidate-viewLess-must-have').style.display = 'block';
    } else if (type == 'viewLess' && data == 'similar-candidate-must-have') {
      document.getElementById('similarCandidate-viewMore-must-have').style.display = 'block';
      document.getElementById('similarCandidate-viewLess-must-have').style.display = 'none';
    }

    if (type == 'viewMore' && data == 'modal-ms') {
      document.getElementById('modal-viewMore').style.display = 'none';
      document.getElementById('modal-viewLess').style.display = 'block';
    } else if (type == 'viewLess' && data == 'modal-ms') {
      document.getElementById('modal-viewMore').style.display = 'block';
      document.getElementById('modal-viewLess').style.display = 'none';
    }

    if (data === 'talent-insights-filters' && type === 'viewMore') {
      document.getElementById('TIViewMore').style.setProperty('display', 'flex', 'important');
      document.getElementById('TIViewLess').style.setProperty('display', 'none', 'important');
    } else if (data === 'talent-insights-filters' && type === 'viewLess') {
      document.getElementById('TIViewMore').style.setProperty('display', 'none', 'important');
      document.getElementById('TIViewLess').style.setProperty('display', 'flex', 'important');
    }

    if (data === 'talent-insights-jd-filters' && type === 'viewMore') {
      document.getElementById('TIJDViewMore').style.setProperty('display', 'flex', 'important');
      document.getElementById('TIJDViewLess').style.setProperty('display', 'none', 'important');
    } else if (data === 'talent-insights-jd-filters' && type === 'viewLess') {
      document.getElementById('TIJDViewMore').style.setProperty('display', 'none', 'important');
      document.getElementById('TIJDViewLess').style.setProperty('display', 'flex', 'important');
    }

      if (data === 'talent-insights-filters-exclude' && type === 'viewMore') {
      document.getElementById('TIExcludeViewMore').style.setProperty('display', 'flex', 'important');
      document.getElementById('TIExcludeViewLess').style.setProperty('display', 'none', 'important');
    } else if (data === 'talent-insights-filters-exclude' && type === 'viewLess') {
      document.getElementById('TIExcludeViewMore').style.setProperty('display', 'none', 'important');
      document.getElementById('TIExcludeViewLess').style.setProperty('display', 'flex', 'important');
    }

  }

  viewMoreSimilarCandidate(type) {

  }

  private getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }


  returnSpanTag(text) {
    let spanTag = document.createElement("span");
    spanTag.className = 'median-tenure-text-size';
    spanTag.innerHTML = text
    return spanTag;
  }

  getFormattedTenureForMatrix(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (tenure == null) {
      return 0;
    } else if (totalYears > 0 && totalMonths > 0) {
      if (totalMonths == 12) {
        return `${totalYears + 1} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
      } else {
        return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()} ${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
      }
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      if (totalMonths == 12) {
        return `${totalYears + 1} ${this.returnSpanTag('Yr').outerHTML.toString()}`;
      } else
        return `${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
    } else {
      return '';
    }
  }

  validateYearsOfExperience(value: number | string) {
    const fromExperience = parseInt(this.yearsofexperienceFrom.value, 10);
    const toExperience = parseInt(this.yearsofexperienceTo.value, 10);

    if (Number.isInteger(fromExperience) && Number.isInteger(toExperience)) {
      if (fromExperience >= toExperience && this.yearsofexperienceTo.value != null && this.yearsofexperienceFrom.value != null) {
        this.yearsofexperienceFrom.setErrors({ 'invalidYears': true });
      } else if (toExperience > 40) {
        this.yearsofexperienceFrom.setErrors({ 'toohigh': true });
      } else if (fromExperience < 1) {
        this.yearsofexperienceFrom.setErrors({ 'toolow': true });
      } else {
        this.yearsofexperienceFrom.setErrors(null);
      }
    }
  }

  validateCurrentYearsOfExperience(value: number | string) {
    const fromExperience = parseInt(this.currentfromyearsofexperience.value, 10);
    const toExperience = parseInt(this.currenttoyearsofexperience.value, 10);

    if (Number.isInteger(fromExperience) && Number.isInteger(toExperience)) {
      if (fromExperience >= toExperience && this.currenttoyearsofexperience.value != null && this.currentfromyearsofexperience.value != null) {
        this.currentfromyearsofexperience.setErrors({ 'invalidYears': true });
      } else if (toExperience > 40) {
        this.currentfromyearsofexperience.setErrors({ 'toohigh': true });
      } else if (fromExperience < 1) {
        this.currentfromyearsofexperience.setErrors({ 'toolow': true });
      } else {
        this.currentfromyearsofexperience.setErrors(null);
      }
    }

  }


  /**
    * Handles child events and accordingly calls specified function
    * @param event childevent
    */
  eventHandler(event) {
    setTimeout(() => {
      if (event && event.data && event.data.currentIndex >= 0) {
        event.data.lastseencount = 1;
        this.candidateList[event.data.currentIndex].lastseencount = 1
      }
    }, 1000)

    var val = event.data.idinindex
    this.candidateList.find(function (item, i) {
      if (item.idinindex === val) {
        index = i;
        return i;
      }
    });

    var index = -1;

    if (event.action == 'append-data' && event.data != undefined && typeof event.data == 'object') {
      // this.candidateList[event.data.currentIndex] = event.data

      var val = event.data.idinindex
      this.candidateList.find(function (item, i) {
        if (item.idinindex === val) {
          index = i;
          return i;
        }
      });

      if (event.data && event.data.existingContactDetails) {
        this.candidateList[index]['existingContactDetails'] = event.data.existingContactDetails;
        this.candidateList[index]['candidatenumber'] = event.data.candidatenumber;
        this.candidateList[index] = Object.assign([], this.candidateList[index]);

      }
      if (event.data && event.data.iswebbtreeverified) {
        this.candidateList[index]['iswebbtreeverified'] = 1;
      }

      if (event.data && event.data.usedWebbtreeIntroduction) {
        this.candidateList[index]['usedWebbtreeIntroduction'] = 1;
      }
      if (event.data && event.data.revealContactAttempted) {
        this.candidateList[index]['revealContactAttempted'] = 1;
      }
      if(event.data && Reflect.has(event.data,'isRevealRetryAvailable')){
        this.candidateList[index]['isRevealRetryAvailable'] = event.data.isRevealRetryAvailable;
      }

    }

    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');

    if (event.action == 'openNav') {
      //loadn[0].style.display = 'none'
      if (event.type == 'show-contact') {
        this.tabType = 'contactTab'
      } else if (event.type == 'show-activity') {
        this.tabType = 'activityTab'
      } else if (event.type == 'show-skills') {
        this.tabType = 'profileTab'
        this.viewMoreSkills = true;
      }
      else {
        this.tabType = 'profileTab'
      }

      if (event.data && event.data.experience && event.data.experience.length && event.data.experience[0].company ) {
        const companyObjects = _.pluck(event.data.experience, 'company');
        const payload = companyObjects.map(item => {
          if(item?.id || item?.name){
            return {
              ...(item?.id && { id: item?.id }),
              ...(item?.name && { name: item?.name })
            }
          }
        }).filter(Boolean);

        this.personSearchService.getCompanyLogoV2(payload).subscribe((res: any) => {
          if (res && res.status == "success") {
            const resultName = res.data
            resultName.forEach(obj => {
              const matchingObj = event.data.experience.filter((item) => ((obj.searchedVia === 'id' && obj.key === item.id) || (obj.searchedVia === 'name' && obj.key === item.name)));
              if (matchingObj && matchingObj.length) {
                let companyLogo = obj.companylogo
                matchingObj.forEach(x => {
                  x.companylogo = companyLogo;
                })

              }
            });

            this.openCandidateSlider(index == -1 ? event.data : this.candidateList[index], event.currentIndex)
          } else {
            this.openCandidateSlider(index == -1 ? event.data : this.candidateList[index], event.currentIndex)
          }
        });
      } else {
        this.openCandidateSlider(index == -1 ? event.data : this.candidateList[index], event.currentIndex)
        //loadn[0].style.display = 'none'
      }



    } else if (event.action == 'closeNav') {
      this.closeNav();
    }

    this.getLastActivity(event.data.idinindex)
  }

  openCandidateSlider(data, currentIndex) {
    this.currentCandidate = data;
    this.currentIndex = currentIndex
    this.showCandidate = true;
    document.getElementById("quickView").style.width = "55%";
    document.getElementById("quickView").style.right = "0";
    document.getElementById("overlay").style.display = "block";
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
  }

  closeNav() {
    this.viewMoreSkills = false;
    this.showCandidate = false
    document.getElementById("quickView").style.width = "0";
    document.getElementById("overlay").style.display = "none";
    document.getElementById("quickView").style.right = "-50px";
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
     this.candidateList = this.candidateList.map(candidate => {
          candidate.contactRevealStatus = 'reveal-contact-notrevealed';

        return candidate;
      })
    //loadn[0].style.display = 'block'
  }

  convertToHTML(data: string) {
    if (!data) return '';
    // replace boolean string AND OR NOT with html tags
    data = data.replace(/AND/g, '<span class="text-webbtree-green">AND</span>');
    data = data.replace(/OR/g, '<span class="text-webbtree-green">OR</span>');
    data = data.replace(/NOT/g, '<span class="text-webbtree-green">NOT</span>');
    return data;
  }

  copySearchQuery() {
    let dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = this.searchKeyword;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    this.success_message = "Boolean string copied succesfully"
    setTimeout(() => this.success_message = '', 5000);
  }

  search() {
    if (this.searchKeyword) {
      // if(this.searchSource && this.searchSource == 'history-component') {
      //   this.getPersonSearchRecommendedCandidates(null, true)
      // } else {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          bucketName: null,
          source: null,
          keyword: this.searchKeyword
        },
        queryParamsHandling: 'merge',
      });
      this.bucketName = null;
      this.sourceRedirectRef = null;
      this.bucketbooleanquery = null;
      this.resetPagination();
    }
    //}
  }

  private resetPagination() {
    this.start = 0;
    this.currentPage = 1;
    this.end = Number(this.profilesPerPage);
  }

  /**Get "booleanquery" key for  "getPersonSearchRecommendedCandidates" request body*/
  getBooleanQuery() {
      const filterData = this.filterDataHandlerService.fetchFilterData;
    if (this.redirectSource == 'talent-insights' && this.redirectDataV2?.booleanquery) {
      return this.redirectDataV2.booleanquery;
    } else if(this.redirectSource == 'company-insights' && this.companyredirectData?.booleanquery){
      return this.companyredirectData.booleanquery;
    } else if(filterData.booleanquery){
      return filterData.booleanquery;
    } else if (this.bucketbooleanquery) {
      return this.bucketbooleanquery
    } else if (this.sourceRedirectRef && this.sourceRedirectRef == 'bucket') {
      return "*";

    } else if (this.searchKeyword == "") {
      return "*"
    }  else{
      return this.searchKeyword;

    }
   }


  /**Get "genders" key for  "getPersonSearchRecommendedCandidates" request body*/
  getGenderInfo(filterData) {
    if (this.redirectSource == 'company-insights') {
      return [this.companyredirectData.gender];
    } else if (filterData?.gender != '') {
      return filterData?.gender?.length ? [filterData.gender] : []
    } else return [];
  }

  /**Get "mandatorylocations" key for "getPersonSearchRecommendedCandidates" request body  */
  getMandatoryLocations() {
    if (this.redirectSource == 'talent-insights' && this.redirectData?.mandatorylocations?.length) {
      return this.redirectData.mandatorylocations
    } else if (this.redirectSource == 'company-insights') {
      return this.redirectData.mandatorylocations
    } else return [];
  }

  /**Get "fromyearsofexperience", "toyearsofexperience", "currentfromyearsofexperience", "currenttoyearsofexperience" key for "getPersonSearchRecommendedCandidates" reuest body  */
  getExperienceWithKeys(key, filterData) {
    if (key === "fromyearsofexperience") {
      if ((this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectDataV2?.yearsofexperienceFrom && !filterData?.yearsofexperienceFrom) {
        return [this.redirectDataV2?.yearsofexperienceFrom];
      }
      else if (!!filterData?.yearsofexperienceFrom) {
        return [filterData.yearsofexperienceFrom]
      }
      else return [];
    }
    else if (key === "toyearsofexperience") {
      if ((this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectDataV2?.yearsofexperienceTo && !filterData?.yearsofexperienceTo) {
        return [this.redirectDataV2?.yearsofexperienceTo]
      }
      else if (!!filterData?.yearsofexperienceTo) {
        return [filterData.yearsofexperienceTo];
      }
      else return [];
    }
    else if (key === "currentfromyearsofexperience") {
      if ((this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectDataV2?.currentfromyearsofexperience && !filterData?.currentfromyearsofexperience) {
        return [this.redirectDataV2?.currentfromyearsofexperience]
      }
      else if (!!filterData?.currentfromyearsofexperience) {
        return [filterData.currentfromyearsofexperience];
      }
      else return [];
    }
    else if (key === 'currenttoyearsofexperience') {
      if ((this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectDataV2?.currenttoyearsofexperience && !filterData?.currenttoyearsofexperience) {
        return [this.redirectDataV2?.currenttoyearsofexperience];
      } else if (!!filterData?.currenttoyearsofexperience) {
        return [filterData?.currenttoyearsofexperience];
      } else return [];
    }
  }

  getYearsOfGraduationKeys(key, filterData) {
    if (key == 'tograduationyear') {
      if (this.redirectSource == 'talent-insights') {
        return this.redirectDataV2?.tograduationyear;
      } else if(this.redirectSource == 'company-insights'){
        return this.companyredirectData?.tograduationyear;
      }
      return filterData.tograduationyear;
    } else if (key == 'fromgraduationyear') {
      if (this.redirectSource == 'company-insights') {
        return this.companyredirectData?.fromgraduationyear;
      } else if(this.redirectSource == 'talent-insights'){
        return this.redirectDataV2?.fromgraduationyear;
      }
      return filterData.fromgraduationyear;
    }
    return null
  }

  /**
   * Get Company related data
   * @param key
   * @param filterData
   */
  getCompanyData(key:string, filterData: any){
    if(key == 'companytype'){
      if(this.redirectSource == 'company-insights' && this.redirectData.recentAttrtion){
        return 'past';
      }
      return filterData.companyStatus == 'Current or Past' ? 'All' : filterData.companyStatus
    }
    return [];
  }

  /**
   * Get Value of insight keys required for "getPersonSearchRecommendedCandidates" request body
   * @param key required key for data, which have to pass in request object
   * @param filterData
   */
  getInsightsObjectKeyValue(key) {
    if (key === "insightslocations") {
      if (this.redirectSource == 'talent-insights') {
        return this.redirectData.location;
      } else if (this.redirectSource == 'company-insights' && this.companyredirectData.locationSelectedList.length) {
        return this.companyredirectData.locationSelectedList?.filter(l => l.isExcluded == false).map(el => el.key);
      } else return [];
    }
    else if (key === 'insightscompanyids') {
      /**If redirected from company insights ( talent to) then   */
      if(this.redirectSource == 'company-insights' && this.redirectData.losingtalent){
        return [];
      } else if (this.redirectSource === 'company-insights' && this.redirectData.alternative_company_id) {
        return this.redirectData.alternative_company_id;
      } else return [];
    }
    else if (key === "insightscompanies") {
      if (this.redirectSource === 'talent-insights') {
        return this.redirectData.company;
      } else if (this.redirectSource === 'company-insights' && this.redirectData.losingtalent) {
        return this.redirectData.losingtalent;
      } else if (this.redirectSource === 'company-insights' && this.redirectData.alternative_names) {
        return this.redirectData.alternative_names.concat(this.redirectData.name);
      } else if (this.redirectSource === 'company-insights' && !this.redirectData.alternative_names) {
        return [this.redirectData.name];
      } else {
        return [];
      }
    }
    else if (key === "insightsindustries") {
      if (this.redirectSource == 'talent-insights') {
        return this.redirectData.industry;
      } else if (this.redirectSource == 'company-insights') {
        return this.companyredirectData.industrySelectedList?.map(el => el.key);
      }
      else return [];
    }
    else if (key === "insightsschools") {
      if (this.redirectSource == 'talent-insights') {
        return this.redirectData.school;
      }
      else if (this.redirectSource == 'company-insights') {
        return this.companyredirectData.schoolSelectedList?.map(el => el.key);
      }
      else return [];
    }
    else if (key === "insightseducationalmajors") {
      if (this.redirectSource == 'talent-insights') {
        return this.redirectData.fieldofstudy;
      } else if (this.redirectSource == 'company-insights') {
        return this.companyredirectData.fieldOfStudySelectedList?.map(el => el.key);
      } else return [];
    }
    else if (key === "insightsjobtitles") {
      if (this.redirectSource == 'talent-insights') {
        return this.redirectData.jobtitle;
      } else if (this.redirectSource == 'company-insights') {
        return this.companyredirectData.jobTitleSelectedList?.filter(l => l.isExcluded == false)?.map(el => el.key);
      }
      else return [];
    }
    else if (key === "insightsfunctions") {
      if (this.redirectSource == 'talent-insights' && this.redirectData.function) {
        return this.redirectData.function.filter(Boolean);
      }
      else if (this.redirectSource == 'company-insights') {
        return this.companyredirectData.functionSelectedList.map(el => el.key);
      } else return [];
    }
    else if (key === "lastjobcompanies") {
      if (this.redirectSource == 'company-insights' && this.redirectData.winningtalent) {
        return this.redirectData.winningtalent;
      }
      else if (this.redirectSource == 'company-insights' && this.redirectData.losingtalent && this.redirectData.alternative_names) {
        return this.redirectData.alternative_names.concat(this.redirectData.name);
      } else if (this.redirectSource == 'company-insights' && this.redirectData.losingtalent && !this.redirectData.alternative_names) {
        return [this.redirectData.name];
      } else return [];
    }
    else if (key === "lastjobcompanyids") {
     if(this.redirectSource == 'company-insights' && this.redirectData.losingtalent && this.redirectData.alternative_company_id){
      return this.redirectData.alternative_company_id;
     } else if(this.redirectSource == 'company-insights' && this.redirectData.recentAttrtion && this.redirectData.lastjobcompanyids){
      return this.redirectData.lastjobcompanyids
     } else{
      return [];
     }
    }
    else if (key === "insightseducationaldegrees") {
      if (this.redirectSource == 'talent-insights') {
        return this.redirectData.degree;
      } else if (this.redirectSource == 'company-insights') {
        return this.companyredirectData.educationSelectedList?.map(el => el.key);
      }
      else return [];
    }
    else if (key === 'insightspreferredskills') {
      if (this.redirectSource === 'talent-insights') {
        return this.redirectData.skills;
      } else if (this.redirectSource === 'company-insights') {
        return this.companyredirectData.skillsSelectedList
          .filter(s => s.isMandatory === false)
          .map(el => el.key);
      } else {
        return [];
      }
    }
    else if (key === "insightsseniority") {
      if (this.redirectSource == 'talent-insights') {
        return this.redirectData.seniority;
      } else if (this.redirectSource == 'company-insights') {
        return this.companyredirectData.seniority
      } else return [];
    }
    else if(key === "durationinmonths"){
      if (this.redirectSource == 'company-insights'){
        return this.redirectData.durationinmonths;
      }
      return null
    }
  }

  /**
   *
   * @param object -
   * @param firstcall - Pass this as true if we need to send aggregate call for only stats matrix (likely to move in, gender, changed jobs)
   *
   */

  getPersonSearchRecommendedCandidates(object: any = null, firstcall = false) {
    this.loaderEventService.emitLoaderObject(LoaderType.RECOMMENDED_CANDIDATE);
    this.personSearchSub && this.personSearchSub.unsubscribe();
    this.euAccessTIMessage = '';
    if (this.jdDataService.isComingFromJobDescription) {

    }

    const filterData = this.filterDataHandlerService.fetchFilterData;
    // this.searchKeyword = this.route.snapshot.queryParams.keyword;
    if (this.isInsightsActive == true) {
      const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
      //loadn[0].style.display = 'none'
    }

    this.requestObject = {
      startindex: this.start,
      resultsize: this.profilesPerPage,
      searchviaboolean: true,
      // TODO : Use redirect data here set from local storage
      booleanquery: this.getBooleanQuery(),
      jobtitles: _.uniq(filterData.jobTitleSelectedList.filter(jobTitle => jobTitle.isExcluded == false).map(j => j.key)),
      pastjobtitles: _.uniq(filterData.pastJobTitleSelectedList.filter(jobTitle => !jobTitle.isExcluded).map(j => j.key)),
      exclude_pastjobtitles: _.uniq(filterData.pastJobTitleSelectedList.filter(jobTitle => !!jobTitle.isExcluded).map(j => j.key)),
      preferredskills: filterData.skillsSelectedList.filter(s => s.isMandatory == false).map(s => s.key),
      mandatoryskills: this.getMandatorySkills,
      locations: filterData.locationSelectedList && filterData.locationSelectedList.length ? filterData.locationSelectedList.filter(l => l.isExcluded == false).map(l => l.key) : (this.geoIpLocation && filterData.continentstobeincluded && filterData.continentstobeincluded.length && this.geoIpLocation.continent == filterData.continentstobeincluded[0] && !this.isComingNLSearch && !this.similarCandidateService.isListingCalledFromSimilarCandidate && !this.jdDataService.isComingFromJobDescription ) ? [`${this.geoIpLocation.location}.iplocation`] : [],
      companies: filterData.companySelectedList.filter(company => company.isExcluded == false).map(j => j.key),
      companyids: this.getCompanyData('companyids', filterData),
      industries: filterData.industrySelectedList.filter(industry => industry.isExcluded == false).map(i => i.key),
      exclusionlist: [],
      genders: this.getGenderInfo(filterData),
      // TODO : Test properly
      seniority: filterData.seniority ? _.flatten(filterData.seniority) : [],
      schools: filterData.schoolSelectedList.map(s => s.key),
      schooltypes: [],
      schoollocation: _.uniq(filterData.schoolLocationSelectedList?.filter(sl => !sl.isExcluded).map(j => j.key)),
      educationaldegrees: filterData.educationSelectedList.map(e => e.key),
      educationalmajors: filterData.fieldOfStudySelectedList.map(fs => fs.key),
      candidateshavingemails: false,
      candidateshavingcontactnumbers: false,
      minexperience: null,
      maxexperience: null,
      minexperienceinccurrentcompany: null,
      zipcodes: this.zipCodeSelectedList.map(z => z.key),
      companysizes: filterData.companysize ? _.flatten(filterData.companysize) : [],
      candidateshavingcontacts: this.contactsAvailabilitySelectedFromInsights ? true : this.contacts != 'All' ? true : false,
      workregions: this.currentWorkCitySelectedList.map(wc => wc.key),
      workcountries: this.currentWorkCountrySelectedList.map(wc => wc.key),
      worklocalities: this.currentWorkLocalitySelectedList.map(c => c.key),
      spokenlanguages: this.languageSelectedList.map(l => l.key),
      contacts: this.contacts ? [this.contacts] : [],
      candidateshavingmobilenumber: this.contactSelectedList.find(c => c.key.toLowerCase() == 'mobile number') ? true : false,
      candidateshavingpersonalemail: this.contactSelectedList.find(c => c.key.toLowerCase() == 'personal email') ? true : false,
      candidateshavingprofessionalemail: this.contactSelectedList.find(c => c.key.toLowerCase() == 'current professional email') ? true : false,
      candidateshavingsocialprofiles: this.contactSelectedList.find(c => c.key.toLowerCase() == 'social profiles') ? true : false,
      exclude_jobtitles: this.redirectSource == 'company-insights' ? this.companyredirectData.jobTitleSelectedList.filter(j => j.isExcluded == true).map(j => j.key) : filterData.jobTitleSelectedList.filter(j => j.isExcluded == true).map(j => j.key),
      exclude_companies: this.redirectSource == 'company-insights' ? this.companyredirectData.companySelectedList.filter(j => j.isExcluded == true).map(j => j.key) : filterData.companySelectedList.filter(j => j.isExcluded == true).map(j => j.key),
      exclude_locations: this.redirectSource == 'company-insights' ? this.companyredirectData.locationSelectedList.filter(j => j.isExcluded == true).map(j => j.key) : filterData.locationSelectedList.filter(j => j.isExcluded == true).map(j => j.key),
      exclude_schoollocation: _.uniq(filterData.schoolLocationSelectedList.filter(sl => !!sl.isExcluded).map(j => j.key)),
      companytype: this.getCompanyData('companytype', filterData),
      jobtitletype: filterData.jobTitleStatus == 'Current or Past' ? 'All' : filterData.jobTitleStatus,
      industrytype: filterData.industryStatus == 'Current or Past' ? 'All' : filterData.industryStatus,
      functiontype: (this.redirectSource == 'company-insights' || this.redirectSource == 'talent-insights') ? 'Current' : 'All',
      // fromyearsofexperience: (this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectData.fromyearsofexperience && !filterData.yearsofexperienceFrom ? [this.redirectData.fromyearsofexperience] : !!filterData.yearsofexperienceFrom ? [filterData.yearsofexperienceFrom] : [],
      // toyearsofexperience: (this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectData.toyearsofexperience && !filterData.yearsofexperienceTo ? [this.redirectData.toyearsofexperience] : !!filterData.yearsofexperienceTo ? [filterData.yearsofexperienceTo] : [],
      experiencetype: filterData.yearsofexperience,
      likelytomovetype: filterData.candidateslikelytomove,
      salaries: this.salary ? [this.salary] : [],
      salaryranges: this.salary ? [this.salary] : [],
      talentdiscoveryhistoryid: this.talentdiscoveryhistoryid,
      savehistory: this.savehistory,
      calledfrom: 'listing',
      mandatoryjobtitles: this.redirectData?.mandatoryjobtitles?.length ? this.redirectData.mandatoryjobtitles : [],
      mandatorylocations: this.getMandatoryLocations(),
      mandatorycompanies: this.redirectData?.mandatorycompanies?.length ? this.redirectData.mandatorycompanies : [],
      mandatoryindustries: this.redirectData?.mandatoryindustries?.length ? this.redirectData.mandatoryindustries : [],
      mandatoryschools: this.redirectData?.mandatoryschools?.length ? this.redirectData.mandatoryschools : [],
      mandatoryfunctions: this.redirectData?.mandatoryfunctions?.length ? this.redirectData.mandatoryfunctions : [],
      mandatoryeducationalmajors: this.redirectData?.mandatoryeducationalmajors?.length ? this.redirectData.mandatoryeducationalmajors : [],
      continentstobeincluded: this.selectedContinent,

      functions: filterData.functionSelectedList.map(l => l.key),
      fullnames: filterData?.fullNameSelectedList?.length ? filterData.fullNameSelectedList.map(f => f.key) : [],
      searchedfrom: this.searchedfrom,

      //  zone: this.localstorageservice.getItem('region')
      ...((this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectData && { recentgraduatesonly: this.redirectData.recentgraduatesonly }),
      ...((this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectData && { recentcompanyhires: this.redirectData.recentcompanyhires }),
      ...((this.redirectSource == 'talent-insights' || this.redirectSource == 'company-insights') && this.redirectData && { recentcompanyattrition: this.redirectData.recentcompanyattrition }),
      changedjobs: filterData.changedJobStatus,
      // currentfromyearsofexperience: this.currentfromyearsofexperience.value != null ? [this.currentfromyearsofexperience.value] : [],
      // currenttoyearsofexperience: this.currenttoyearsofexperience.value != null ? [this.currenttoyearsofexperience.value] : [],
      insightslocations: this.getInsightsObjectKeyValue("insightslocations"),
      insightscompaniesid: this.getInsightsObjectKeyValue('insightscompanyids'),
      insightscompanies: this.getInsightsObjectKeyValue("insightscompanies"),
      insightsindustries: this.getInsightsObjectKeyValue("insightsindustries"),
      insightsschools: this.getInsightsObjectKeyValue("insightsschools"),
      insightseducationalmajors: this.getInsightsObjectKeyValue("insightseducationalmajors"),
      insightsjobtitles: this.getInsightsObjectKeyValue("insightsjobtitles"),
      insightspreferredskills: this.getInsightsObjectKeyValue("insightspreferredskills"),
      insightsfunctions: this.getInsightsObjectKeyValue("insightsfunctions"),
      lastjobcompanies: this.getInsightsObjectKeyValue("lastjobcompanies"),
      lastjobcompanyids: this.getInsightsObjectKeyValue("lastjobcompanyids"),
      insightseducationaldegrees: this.getInsightsObjectKeyValue("insightseducationaldegrees"),
      insightsseniority: this.getInsightsObjectKeyValue("insightsseniority"),
      needcuratedtalentpooltags: true,
      fromyearsofexperience: this.getExperienceWithKeys("fromyearsofexperience", filterData),
      toyearsofexperience: this.getExperienceWithKeys("toyearsofexperience", filterData),
      currentfromyearsofexperience: this.getExperienceWithKeys("currentfromyearsofexperience", filterData),
      currenttoyearsofexperience: this.getExperienceWithKeys("currenttoyearsofexperience", filterData),
      fromgraduationyear: this.getYearsOfGraduationKeys('fromgraduationyear', filterData) || this.fromgraduationyear.value,
      tograduationyear: this.getYearsOfGraduationKeys('tograduationyear', filterData) || this.tograduationyear.value,
      exclude_industries: filterData.industrySelectedList.filter(i => i.isExcluded == true).map(i => i.key),
      distancefromselectedlocations: filterData?.distancefromselectedlocations,
      distancefromselectedlocationsmeasurementunit: filterData?.distancefromselectedlocationsmeasurementunit,
      profilehighlights: filterData?.profilehighlights,
      positionhierarchies: filterData?.positionhierarchy,
      exclude_preferredskills:  this.redirectSource == 'company-insights' ? this.companyredirectData.skillsSelectedList.filter(j => (j.isExcluded == true && j.isMandatory== false)).map(j => j.key) : filterData.skillsSelectedList.filter(j => (j.isExcluded == true && j.isMandatory== false)).map(j => j.key),
      exclude_mandatoryskills:  this.redirectSource == 'company-insights' ? this.companyredirectData.skillsSelectedList.filter(j => (j.isExcluded == true && j.isMandatory== true)).map(j => j.key) : filterData.skillsSelectedList.filter(j => (j.isExcluded == true && j.isMandatory== true)).map(j => j.key),
      exclude_functions:  this.redirectSource == 'company-insights' ? this.companyredirectData.functionSelectedList.filter(j => (j.isExcluded == true)).map(j => j.key) : filterData.functionSelectedList.filter(j => (j.isExcluded == true)).map(j => j.key),

      include_persons: filterData?.includePersons?.length ? filterData?.includePersons : [],
      durationinmonths: this.getInsightsObjectKeyValue('durationinmonths')
    };

    this.requestObject.toyearsofexperience = _.flatten(this.requestObject?.toyearsofexperience);
    this.requestObject.fromyearsofexperience = _.flatten(this.requestObject?.fromyearsofexperience);
    this.requestObject.currenttoyearsofexperience = _.flatten(this.requestObject?.currenttoyearsofexperience);
    this.requestObject.currentfromyearsofexperience = _.flatten(this.requestObject?.currentfromyearsofexperience);

    if (!(this.requestObject?.toyearsofexperience?.length && this.requestObject?.fromyearsofexperience?.length) &&
      (this.requestObject?.toyearsofexperience?.length || this.requestObject?.fromyearsofexperience?.length)) {
      if (!this.requestObject?.toyearsofexperience?.length) {
        this.requestObject.toyearsofexperience = [40];
      } else if (!this.requestObject?.fromyearsofexperience?.length) {
        this.requestObject.fromyearsofexperience = [0];
      }
    }

    if (!(this.requestObject?.currenttoyearsofexperience?.length && this.requestObject?.currentfromyearsofexperience?.length) &&
      (this.requestObject?.currenttoyearsofexperience?.length || this.requestObject?.currentfromyearsofexperience?.length)) {
      if (!this.requestObject?.currenttoyearsofexperience?.length) {
        this.requestObject.currenttoyearsofexperience = [40];
      } else if (!this.requestObject?.currentfromyearsofexperience?.length) {
        this.requestObject.currentfromyearsofexperience = [0];
      }
    }

    //When redirect from company insights
    if (this.redirectSource === 'company-insights' && firstcall) {
      this.requestObject.distancefromselectedlocationsmeasurementunit = this.companyredirectData?.distancefromselectedlocationsmeasurementunit;
      this.requestObject.distancefromselectedlocations = this.companyredirectData?.distancefromselectedlocations;
    }

    this.aggReqObjectHandlerService.setShareRequestObject(this.requestObject);
    this.filterDataHandlerService.setBooleanQuery(this.requestObject?.booleanquery);
    if (this.filterDataHandlerService.isRedirectFromTalentInsightsPage || this.jdDataService.isComingFromJobDescription) {
      this.requestObject = this.aggregationService.getRequestWithFilters();
      this.requestObject['booleanquery'] = object?.booleanquery || this.requestObject['booleanquery'];
      let filterData = this.filterDataHandlerService.fetchFilterData;
      filterData.booleanquery = this.requestObject.booleanquery;
      this.filterDataHandlerService.setFilterData(filterData);
    this.filterDataHandlerService.setBooleanQuery(this.requestObject?.booleanquery);
    }
    // If redirected from talent insights via jd search
    if(this.filterDataHandlerService.isRedirectFromTalentInsightsPage && this.redirectData?.additionalFilters?.job_description_keys){
      this.requestObject['job_description_keys'] = this.redirectData?.additionalFilters?.job_description_keys;
      if(this.redirectData?.nlsearchquery)
      this.requestObject.nlsearchquery = this.redirectData.nlsearchquery;
      if(this.redirectData?.continentstobeincluded)
        this.requestObject.continentstobeincluded = this.redirectData?.continentstobeincluded;
    }
    // TODO : Handle all the filters related data in a helper method
    if (object != null && typeof object === 'object' && this.searchedfrom !== GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION) {
      this.requestObject = object;
      this.filterDataHandlerService.setBooleanQuery(this.requestObject?.booleanquery);
      if (!this.filterDataHandlerService.isRedirectFromTalentInsightsPage) this.requestObject['calledfrom'] = 'listing';
    }

    if (this.bucketId && this.sourceRedirectRef && this.sourceRedirectRef == 'bucket') {
      this.requestObject['talentpoolbucketid'] = this.bucketId
      this.requestObject['talentpoolbucketname'] = this.bucketName
    } else {
      this.requestObject['talentpoolbucketname'] = this.bucketName
    }

    if (this.similarobject && this.similarobject.data && this.searchedfrom !== GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION && this.searchedfrom !== GeneralConstants.REDIRECT_SOURCES.NL_SEARCH) {
      const fromyrsofexperience = this.similarobject.data.fromYrsOfExperience;
      const toyrsofexperinece = this.similarobject.data.toYrsOfExperinece;

      this.requestObject['similarcandidates_industries'] = !Array.isArray(this.similarobject.data.jobindustryname) ? [this.similarobject.data.jobindustryname] : this.similarobject.data.jobindustryname
      this.requestObject['similarcandidates_locations'] = this.similarobject.data.currentlocation
      this.requestObject['similarcandidates_skills'] = this.similarobject.data.skills
      this.requestObject['similarcandidates_companysizes'] = this.similarobject.data.companysize != null ? this.similarobject.data.companysize : []
      this.requestObject['similarcandidates_fromyearsofexperience'] = fromyrsofexperience != null ? [fromyrsofexperience] : []
      this.requestObject['similarcandidates_toyearsofexperience'] = toyrsofexperinece != null ? [toyrsofexperinece] : []
      this.requestObject['similarcandidates_toyearsofexperience'] = toyrsofexperinece != null ? [toyrsofexperinece] : []
      this.requestObject['similarcandidates_totaltenure'] = this.similarobject.data.totaltenure
      this.requestObject['similarcandidates_jobtitles'] = this.similarobject.data.jobtitle || [];
      this.requestObject['similarcandidates_companies'] = this.similarobject.data.jobcompanyname || [];
      this.requestObject['similarcandidates_degrees'] = this.similarobject.data.degrees || [];
      this.requestObject['similarcandidates_schools'] = this.similarobject.data.schools || [];
      this.requestObject['similarcandidates_fieldofstudy'] = this.similarobject.data.fieldOfStudy || [];
      this.requestObject['similarcandidates_excludefirstname'] = this.similarobject.data.firstname || null;
      this.requestObject['similarcandidates_excludelastname'] = this.similarobject.data.lastname || null;

      // extra information for history
      this.requestObject['linkedinurl'] = this.similarobject.data.linkedinurl
      this.requestObject['isUploadedFromResume'] = this.similarobject.data.isUploadedFromResume
      this.requestObject['fullname'] = this.similarobject.data.fullname
      this.requestObject.continentstobeincluded = Array.isArray(this.similarobject?.data?.locationcontinent) ? this.similarobject.data.locationcontinent : this.similarobject?.data?.locationcontinent ? [this.similarobject.data.locationcontinent] : [];
      if(this.similarobject?.data?.currentlocation?.length > 0) {
        this.similarobject.data.locationContinentName = this.similarobject.data.locationContinentName?.length ? this.similarobject.data.locationContinentName : [{key: this.similarobject.data.currentlocation[0]?.key, continent: this.similarobject.data.locationcontinent, calledFrom: 'jd'}];
      }
      this.aggReqObjectHandlerService.setShareRequestObject(this.requestObject);

      if (this.similarobject.data.elasticid) {
        this.requestObject['exclude_persons'] = [this.similarobject.data.elasticid]
      }
    }
    this.showLoaderbeforeDataLoad = true;
    // if (this.similarCandidateService.isListingCalledFromSimilarCandidate) {
    //   this.requestObject.continentstobeincluded = this.similarobject?.data?.locationcontinent ? [this.similarobject.data.locationcontinent] : [];
    // }
    if (this.similarCandidateService.isListingCalledFromSimilarCandidate || this.jdDataService.isComingFromJobDescription || this.jdDataService.isComingFromNLSearch) {
        delete this.requestObject?.distancefromselectedlocations;
      delete this.requestObject?.distancefromselectedlocationsmeasurementunit;
      this.parsedjdkeys = this.requestObject?.job_description_keys ;
    }

    if(this.isComingNLSearch) {
      this.requestObject = this.aggregationService.getRequestWithFilters();
      this.requestObject.nlsearchquery = this.localstorageservice.getItem('nlSearchKeyword');
      this.requestObject.searchedfrom = GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION;
      this.requestObject.locationcontinents = this.similarobject?.data?.locationContinentName?.length > 0 ? this.similarobject.data.locationContinentName : [];
 const continent = this.similarobject?.data?.locationContinentName?.length ? _.pluck(this.similarobject?.data?.locationContinentName, 'continent'): this.searchSource == 'history-component' ? this.locationContinents?.length ? this.locationContinents: []: [this.localstorageservice.getItem('defaultContinent')]
      this.locationContinents = continent;
      this.requestObject.continentstobeincluded = this.locationContinents;
      this.requestObject.continentstobeincluded = _.uniq(_.flatten(this.requestObject.continentstobeincluded));
      if(this.searchSource == 'history-component') {
        if(this.requestObject.locationcontinents?.length > 0)
            this.similarLocationContinents = this.requestObject.locationcontinents;
        else this.similarLocationContinents = [];

        this.requestObject.locationcontinents = this.similarLocationContinents?.length ? this.similarLocationContinents:[];
         const continent = this.requestObject.locationcontinents?.length ? _.pluck(this.requestObject.locationcontinents, 'continent'): this.locationContinents?.length > 0 ? this.locationContinents: []
      this.locationContinents = continent;
      this.requestObject.continentstobeincluded = this.locationContinents;
      }
    }
    this.aggReqObjectHandlerService.setShareRequestObject(this.requestObject);
    this.turnOnLoaders(false);

    if (
      this.filterDataHandlerService.isRedirectFromCompanyInsightsPage &&
      this.requestObject?.calledfrom
    ) {
      delete this.requestObject.calledfrom;
    }

    this.requestObject['resultsize'] = this.profilesPerPage;

    this.hasEuAccess = this.localstorageservice.getItem('hasEUPersonSearchAccess');
    if(this.jdDataService.isComingFromJobDescription) {

      this.requestObject['jdsearchhistoryid'] = this.localstorageservice.getItem('jdinsightshistoryid');
    }
    if(this.requestObject?.continentstobeincluded.length > 0) {
      if(this.requestObject?.continentstobeincluded[0] == '') {
        this.requestObject.continentstobeincluded = [];
      }
    }

    if(this.requestObject?.continentstobeincluded == '') {
      this.requestObject.continentstobeincluded = [];
    }
    if(this.jdDataService.isComingFromJobDescription || this.similarCandidateService.isListingCalledFromSimilarCandidate) {
      delete this.requestObject.nlsearchquery;
      const continent = this.similarobject?.data?.locationContinentName?.length ? _.pluck(this.similarobject?.data?.locationContinentName, 'continent'): [this.localstorageservice.getItem('defaultContinent')]
      this.locationContinents = continent;
      this.requestObject.continentstobeincluded = this.locationContinents;
      this.requestObject.continentstobeincluded = _.uniq(_.flatten(this.requestObject.continentstobeincluded));
      this.requestObject.locationcontinents = this.similarobject?.data?.locationContinentName?.length > 0 ? this.similarobject.data.locationContinentName : [];
      if(this.requestObject?.job_description_keys?.locations?.length == 0 && this.requestObject?.job_description_keys?.mandatory_locations?.length == 0){
        this.requestObject.job_description_keys.locations = [this.localstorageservice.getItem('defaultContinent')]
      }
      if(this.searchSource == 'history-component'){
        if(this.requestObject.locationcontinents?.length > 0)
            this.similarLocationContinents = this.requestObject.locationcontinents;
        else this.similarLocationContinents = [];
        this.requestObject.locationcontinents = this.similarLocationContinents?.length ? this.similarLocationContinents: [];
        this.locationContinents = this.requestObject?.locationcontinents?.length ? _.pluck(this.requestObject?.locationcontinents, 'continent'):[]

      }
      this.aggReqObjectHandlerService.setShareRequestObject(this.requestObject);
    }
    if(this.searchedfrom == 'advanced-search' || this.searchSource == 'history-component') {
      this.requestObject.continentstobeincluded = this.locationContinents ? this.locationContinents : this.requestObject.continentstobeincluded ? this.requestObject.continentstobeincluded : this.searchedfrom == 'advanced-search' ? [this.localstorageservice.getItem('defaultContinent')] : [];
      this.requestObject.continentstobeincluded = this.requestObject?.continentstobeincluded?.filter(x => x!= 'null' && x!= null && x!= "");
      this.requestObject.continentstobeincluded = _.uniq(_.flatten(this.requestObject.continentstobeincluded));
      this.aggReqObjectHandlerService.setShareRequestObject(this.requestObject);

    }

    if(this.redirectSource == 'talent-insights') {
      this.requestObject.continentstobeincluded = this.talentInsightsContinent
    }
    this.requestObject.module = 'personsearch';
    if(this.redirectSource == 'company-insights') {
      this.requestObject.continentstobeincluded = [];
    }
    filterData.locationcontinents = this.requestObject.locationcontinents;
    filterData.continentstobeincluded = this.requestObject.continentstobeincluded;
    this.filterDataHandlerService.setFilterData(filterData);
    this.personSearchSub = this.personSearchService.getPersonSearchRecommendCandidates(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        if(response?.message && response?.message == 'Continent(s) access denied') {
          this.euAccessMessage = 'Europe Continent Access Denied';
          this.showLoaderbeforeDataLoad = false;
          this.aggregationService.getStatsAggs();

        } else if(response?.data?.results?.length == 0 && this.requestObject.continentstobeincluded[0] == 'europe' && !this.hasEuAccess){
          this.euAccessTIMessage = 'Europe Continent Access Denied';
          this.showLoaderbeforeDataLoad = false;
          this.aggregationService.getStatsAggs();

        }
        else{
          response.data.candidateList = response?.data?.results?.length ? response.data.results.map(c => ({ ...c, selected: false })) : [];
          this.showLoaderbeforeDataLoad = false;
          if (this.generateAIMOdalLoader == true) {
            this.modalService.dismissAll();
          }
          //  this.handleGetPersonSearchAPI(response?.data);
          const candidateObject = new PersonSearchResponse();
          candidateObject.candidateList = response?.data?.results?.length ? response.data.results.map(c => ({ ...c, selected: false })) : [];
          candidateObject.totalCandidatesCount = response.data?.totalresultscount;
          candidateObject.talentdiscoveryhistoryid = response?.data?.talentdiscoveryhistoryid;
          candidateObject.totalresultscount = response?.data?.totalresultscount;
          candidateObject.booleanquery = response?.data?.booleanquery;
          candidateObject.message = response?.data?.message;
          this.aggregationService.emitRecCandidateObject(candidateObject);

          const filterData = this.filterDataHandlerService.fetchFilterData;
          const locationFilterData = filterData.locationSelectedList;
          const companyFilterData = filterData.companySelectedList
          if (locationFilterData && locationFilterData.length && locationFilterData.filter(l => !l.isSuggested).length && !companyFilterData.length) {
            this.topSuggestedLocations = [];
            const userSelectedLocation = locationFilterData?.filter(l => !l?.isSuggested && !l?.key?.includes('.iplocation')).map(i => i?.chipkey?.replace('.aisearch', '').replace('.searchastext', ''));
            const countries = userSelectedLocation?.filter(l => l?.split(',').length == 3).map(l => l?.split(',')[2].trim()).filter(Boolean);
            countries && countries.length && this.getLocationAggs(_.uniq(countries));
          }
        }

      }
      this.totalCandidatesCountAvailable = true;
      this.onRefreshAvoidApiCall = false;
    });
  }

  createFilterCharts(filterName: 'years_of_exp' | 'years_of_grad' = null) {

    // if no filter or years_of_exp filter provided
    if (!filterName || (filterName && filterName === 'years_of_exp')) {
      let CharForYearsOfExperience = [];

      if (this.yearsofexperience == 'Current') {
        this.reportsAggs && this.reportsAggs.currentyearsofexperience && this.reportsAggs.currentyearsofexperience.forEach(x => {
          let dataObj = {
            label: `${x.key}`,
            value: x.doc_count,
            tooltext: `${x.key} <br> Talent count: ${x.doc_count}`
          }
          CharForYearsOfExperience.push(dataObj)
        })
        this.dataSourceYearsOfExperience = {
          dataFormat: "json",
          height: 14,
          width: 14,
          chart: {
            renderAt: "chart-container",
            "paletteColors": "#F4AB33",
            "captionFontColor": "#F4AB33",
            "showPercentValues": "1",
            "yAxisNameFontColor": '#F4AB33',
            legendPosition: "right",
            legendAllowDrag: "1",
            theme: "fusion",
            "labelFont": "Poppins",
            legendItemFont: "Poppins",
            "baseFont": "Poppins",
            "baseFontSize": "11",
            drawanchors: "0",
            showToolTip: "1",
            showValues: "0",
            showYAxisValues: "0",
          },
          "data": CharForYearsOfExperience
        };
      } else if (this.yearsofexperience == 'Total') {
        this.reportsAggs && this.reportsAggs.totalyearsofexperience && this.reportsAggs.totalyearsofexperience.forEach(x => {
          let dataObj = {
            label: `${x.key}`,
            value: x.doc_count,
            tooltext: `${x.key} <br> Talent count: ${x.doc_count}`
          }
          CharForYearsOfExperience.push(dataObj)
        })
        this.dataSourceYearsOfExperience = {
          dataFormat: "json",
          height: 14,
          width: 14,
          chart: {
            renderAt: "chart-container",
            "paletteColors": "#F4AB33",
            "captionFontColor": "#F4AB33",
            "showPercentValues": "1",
            "yAxisNameFontColor": '#F4AB33',
            legendPosition: "right",
            legendAllowDrag: "1",
            theme: "fusion",
            "labelFont": "Poppins",
            legendItemFont: "Poppins",
            "baseFont": "Poppins",
            "baseFontSize": "11",
            drawanchors: "0",
            showToolTip: "1",
            showValues: "0",
            showYAxisValues: "0",
          },
          "data": CharForYearsOfExperience
        };
      } else if (this.yearsofexperience == 'Average') {
        this.reportsAggs && this.reportsAggs.averageyearsofexperience && this.reportsAggs.averageyearsofexperience.forEach(x => {
          let dataObj = {
            label: `${x.key}`,
            value: x.doc_count,
            tooltext: `${x.key} <br> Talent count: ${x.doc_count}`
          }
          CharForYearsOfExperience.push(dataObj)
        })

        this.dataSourceYearsOfExperience = {
          dataFormat: "json",
          height: 14,
          width: 14,
          chart: {
            renderAt: "chart-container",
            "paletteColors": "#F4AB33",
            "captionFontColor": "#F4AB33",
            "showPercentValues": "1",
            "yAxisNameFontColor": '#F4AB33',
            legendPosition: "right",
            legendAllowDrag: "1",
            theme: "fusion",
            "labelFont": "Poppins",
            legendItemFont: "Poppins",
            "baseFont": "Poppins",
            "baseFontSize": "11",
            drawanchors: "0",
            showToolTip: "1",
            showValues: "0",
            showYAxisValues: "0",
          },
          "data": CharForYearsOfExperience
        };
      }

    }
  }

  changeJobTitleStatus(status: string) {
    this.jobTitleStatus = status;
    this.getPersonSearchRecommendedCandidates();
  }


  setPage(index: number) {
    if (this.onRefreshAvoidApiCall) return

    this.candidatetoBeGrabbed = []
    this.totalCandidateforTalentpool = []
    this.selected = false;

    let start = (index - 1) * Number(this.profilesPerPage)
    this.start = start;
    this.end = this.start + Number(this.profilesPerPage);
    if (index == 1) this.currentPage = 1;
    if (this.totalCandidatesCount != 0 && this.end > this.totalCandidatesCount) {
      this.end = this.totalCandidatesCount
    }

    if(this.route.snapshot.queryParams.type !== 'similar-candidate-resume-upload' &&
      this.route.snapshot.queryParams.type !== 'similar-candidate-from-linkedinurl' &&
      this.route.snapshot.queryParams.type !== 'job-description'
    ) {
      this.setFilterDataInLocalStorage();
    }
    if(this.route.snapshot.queryParams.type == 'advanced-search') {
      const filterData = this.filterDataHandlerService.fetchFilterData;
      this.locationContinents = filterData?.continentstobeincluded ? filterData.continentstobeincluded : [];
      this.filterDataHandlerService.setFilterData(filterData);
    }
    this.getPersonSearchRecommendedCandidates(null, true);

    this.document.documentElement.scrollTop = 0;
  }

  onTabChange(tab) {
    if (tab == 'insight') {
      // reports tab
      this.isInsightsActive = true;
      this.isListingActive = false;
      if (this.requestObject) {
        this.requestObject['talentdiscoveryhistoryid'] = this.talentdiscoveryhistoryid
        this.requestObject['isinsightsviewed'] = 1
      }
      this.filterData.isInsightsActive = true;
      this.filterData.isListingActive = false;
      this.insightsDataService.setInsightsActive(true);
           /**
           * Search Insights CT event
           */
            const jdParams = {
              "User ID": this.localstorageservice.getItem('userdata').userid,
              "Search Type": this.isComingFromJD ? "JD Search" : this.receivedData?.calledFrom == 'advance' ? 'Advance Search': this.isCalledFromSimilar ? 'Similar Candidate': 'Keyword/Boolean',
              "Insights Viewed": "Yes"
            }
            clevertap.event.push('Search Insights', jdParams);
    } else {
      // profiles tab
      this.isListingActive = true;
      this.isInsightsActive = false;
      this.filterData.isInsightsActive = false;
      this.filterData.isListingActive = true;
      this.insightsDataService.setInsightsActive(false);
    }
    if (!this.insightsEvent) {
      this.setFilterDataInLocalStorage();
    }
  }

  getUpdatedCountForSelectedFilters() {
    this.contactsAvailableArray = this.contactsAvailableArray.map(x => {
      let mobilenumber = this.aggregations.mobilenumber && this.aggregations.mobilenumber.doc_count ? this.aggregations.mobilenumber.doc_count : 0;
      let personalemail = this.aggregations.personalemail && this.aggregations.personalemail.doc_count ? this.aggregations.personalemail.doc_count : 0;
      let professionalemail = this.aggregations.professionalemail && this.aggregations.professionalemail.doc_count ? this.aggregations.professionalemail.doc_count : 0;
      let socialprofiles = this.aggregations.socialprofiles && this.aggregations.socialprofiles.doc_count ? this.aggregations.socialprofiles.doc_count : 0;

      if (x.key.toLowerCase() == 'mobile number') {
        x.doc_count = mobilenumber;
      } else if (x.key.toLowerCase() == 'personal email') {
        x.doc_count = personalemail;
      } else if (x.key.toLowerCase() == 'current professional email') {
        x.doc_count = professionalemail;
      } else if (x.key.toLowerCase() == 'social profiles') {
        x.doc_count = socialprofiles;
      }
      return x;
    });

    if (this.jobTitleSelectedList.length) {
      this.jobTitleSelectedList = this.jobTitleSelectedList.map(x => {
        let jobTitleObj = this.jobTitleStatus == 'All' ? this.aggregations.jobtitle.find(y => y.key.toLowerCase() == x.key.toLowerCase()) : this.aggregations.current_jobtitle.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (jobTitleObj) {
          x.doc_count = jobTitleObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.currentWorkCitySelectedList.length) {
      this.currentWorkCitySelectedList = this.currentWorkCitySelectedList.map(x => {
        let currentWorkCityObj = this.jobTitleStatus == 'All' ? this.aggregations.workregion.find(y => y.key.toLowerCase() == x.key.toLowerCase()) : this.aggregations.current_workregion.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (currentWorkCityObj) {
          x.doc_count = currentWorkCityObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.currentWorkCountrySelectedList.length) {
      this.currentWorkCountrySelectedList = this.currentWorkCountrySelectedList.map(x => {
        let currentWorkCountryObj = this.jobTitleStatus == 'All' ? this.aggregations.workcountry.find(y => y.key.toLowerCase() == x.key.toLowerCase()) : this.aggregations.current_workcountry.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (currentWorkCountryObj) {
          x.doc_count = currentWorkCountryObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.currentWorkLocalitySelectedList.length) {
      this.currentWorkLocalitySelectedList = this.currentWorkLocalitySelectedList.map(x => {
        let currentWorkLocalityObj = this.jobTitleStatus == 'All' ? this.aggregations.worklocality.find(y => y.key.toLowerCase() == x.key.toLowerCase()) : this.aggregations.current_worklocality.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (currentWorkLocalityObj) {
          x.doc_count = currentWorkLocalityObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.skillsSelectedList.length) {
      this.skillsSelectedList = this.skillsSelectedList.map(x => {
        let skillsObj = this.aggregations.skills.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (skillsObj) {
          x.doc_count = skillsObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.companySelectedList.length) {
      this.companySelectedList = this.companySelectedList.map(x => {
        let companyObj = this.jobTitleStatus == 'All' ? this.aggregations.company.find(y => y.key.toLowerCase() == x.key.toLowerCase()) : this.aggregations.current_company.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (companyObj) {
          x.doc_count = companyObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.industrySelectedList.length) {
      this.industrySelectedList = this.industrySelectedList.map(x => {
        let industryObj = this.jobTitleStatus == 'All' ? this.aggregations.industry.find(y => y.key.toLowerCase() == x.key.toLowerCase()) : this.aggregations.current_industry.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (industryObj) {
          x.doc_count = industryObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.fieldOfStudySelectedList.length) {
      this.fieldOfStudySelectedList = this.fieldOfStudySelectedList.map(x => {
        let fieldOfStudyObj = this.aggregations.fieldofstudy.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (fieldOfStudyObj) {
          x.doc_count = fieldOfStudyObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.educationSelectedList.length) {
      this.educationSelectedList = this.educationSelectedList.map(x => {
        let educationObj = this.aggregations.education.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (educationObj) {
          x.doc_count = educationObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.zipCodeSelectedList.length) {
      this.zipCodeSelectedList = this.zipCodeSelectedList.map(x => {
        let zipCodeObj = this.aggregations.zipcodes.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (zipCodeObj) {
          x.doc_count = zipCodeObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.schoolSelectedList.length) {
      this.schoolSelectedList = this.schoolSelectedList.map(x => {
        let schoolObj = this.aggregations.school.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (schoolObj) {
          x.doc_count = schoolObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.companySizeSelectedList.length) {
      this.companySizeSelectedList = this.companySizeSelectedList.map(x => {
        let companySizeObj = this.jobTitleStatus == 'All' ? this.aggregations.companysizes.find(y => y.key.toLowerCase() == x.key.toLowerCase()) : this.aggregations.current_companysizes.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (companySizeObj) {
          x.doc_count = companySizeObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.graduationYearSelectedList.length) {
      this.graduationYearSelectedList = this.graduationYearSelectedList.map(x => {
        let graduationYearObj = this.aggregations.graduationyear.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (graduationYearObj) {
          x.doc_count = graduationYearObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.locationSelectedList.length) {
      this.locationSelectedList = this.locationSelectedList.map(x => {
        let locationObj = this.aggregations.location.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (locationObj) {
          x.doc_count = locationObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.languageSelectedList.length) {
      this.languageSelectedList = this.languageSelectedList.map(x => {
        let languageObj = this.aggregations.language.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (languageObj) {
          x.doc_count = languageObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }

    if (this.functionSelectedList.length) {
      this.functionSelectedList = this.functionSelectedList.map(x => {
        let functionObj = this.aggregations.function.find(y => y.key.toLowerCase() == x.key.toLowerCase());
        if (functionObj) {
          x.doc_count = functionObj.doc_count;
        } else {
          x.doc_count = 0;
        }
        return x;
      });
    }
  }

  selectCandidate(e, data) {
    if ((e && e.target && e.target.checked) || e == 'selected') {
      if (this.candidatetoBeGrabbed && this.candidatetoBeGrabbed.length < 100) {
        if (this.candidatetoBeGrabbed && this.candidatetoBeGrabbed.length) {
          if (!this.candidatetoBeGrabbed.some(candidate => candidate.idinindex == data.idinindex)) {
            this.candidatetoBeGrabbed.push(data)
          }
        } else {
          this.candidatetoBeGrabbed.push(data)
        }
        data.selected = true
        if (this.candidateList && this.candidatetoBeGrabbed && (this.candidateList.length == this.candidatetoBeGrabbed.length)) {
          this.selected = true;
        }
      } else {
        data.selected = false
        e.target.checked = false;
      }
    } else {
      this.selected = false
      data.selected = false
      e.target.checked = false;
      this.candidatetoBeGrabbed = this.candidatetoBeGrabbed.filter(x => x['idinindex'] != data.idinindex)
    }
  }

  selectAll(e) {
    if (e.target.checked && this.candidatetoBeGrabbed.length < 100) {
      this.candidateList.forEach((x: any) => {
        let event = {
          target: {
            checked: true
          }
        }
        this.selectCandidate(event, x);
      })
    } else {
      this.totalCandidateforTalentpool = []
      this.candidatetoBeGrabbed = []
      this.selected = false
      e.target.checked = false;
      this.candidateList.forEach((x: any) => {
        let event = {
          target: {
            checked: false
          }
        }
        this.selectCandidate(event, x);
      })
    }
  }

  extractCandidate(candidateData: any) {
    this.resetTPMssgParams();
    this.candidateName = candidateData?.full_name ? candidateData.full_name : "Full name not available";
    this.profileurlsarray = []
    this.profileurlsarray.push(candidateData.idinindex)
    this.profileurlsarray = this.profileurlsarray.filter((item,
      index) => this.profileurlsarray.indexOf(item) === index);
    this.disablebutton = true;
    const modalRef = this.modalService.open(this.extractToTalentpool, { windowClass: "modalExtract", centered: true });
    modalRef.result.then((data) => {
    },
      (error) => {
        if (error != 'isGrabbed') {
          this.modalDismissed = true;
        }
      });
  }

  saveDataToTalentpool(talentpoolData = null) {
    const profileurlsarray = {
      profileurlsarray: talentpoolData
    }
    let talentpoolProfileAndData = {}
    if (this.talentpoolAndCandidateData && this.talentpoolAndCandidateData.profileurlsarray && this.talentpoolAndCandidateData.profileurlsarray.length) {
      talentpoolProfileAndData = {
        talentpoolname: this.talentpoolAndCandidateData.talentpoolname,
        talentpoolnumber: this.talentpoolAndCandidateData.talentpoolnumber,
        elasticid: this.talentpoolAndCandidateData.profileurlsarray,
        grabbedpage: this.currentPage,
        source: 'person-search'
      }
    } else {
      console.error('UNABLE TO FIND ELASTIC ID')
    }
    this.addToTalentpoolSpinner = true;
    this.talentpoolNumber = this.talentpoolAndCandidateData?.talentpoolId;

    this.personSearchService.addToTanentpool(talentpoolProfileAndData).subscribe((result: any) => {
      this.disablebutton = true;
      this.showTalentPoolInput = false;
      if (result.status == 'success') {
        // this.modalService.dismissAll('isGrabbed')
        this.addTalentPoolSuccess = true;
        this.candidatetoBeGrabbed = [];
        this.candidateList = this.candidateList.map(x => ({ ...x, selected: false }));
        this.selected = false;

        const len = this.talentpoolAndCandidateData?.profileurlsarray?.length || 0;
        if (len == 1) {
          this.talentPoolMessage = `${this.candidateName ? this.candidateName.split(" ").map(el => this.capitalizeFirstLetter(el)).join(" ") : ""} has successfully been added to the ${this.talentpoolAndCandidateData.talentpoolname} talentpool.`;
        } else if (result?.isPartial) {
          this.talentPoolMessage = `${result.newCandidateCount} candidates have successfully been added to the ${this.talentpoolAndCandidateData.talentpoolname} talentpool. There were ${result.duplicateCount} candidates which were already part of ${this.talentpoolAndCandidateData.talentpoolname} talentpool.`;
        } else {
          this.talentPoolMessage = `${len} candidates have successfully been added to the ${this.talentpoolAndCandidateData.talentpoolname} talentpool.`;
        }

        this.getCandidateActivityInBulk(this.talentpoolAndCandidateData.profileurlsarray, 'talentpool')


        this.candidateList.forEach(item => {
          if (this.talentpoolAndCandidateData.profileurlsarray.includes(item.id)) {
            if (item.talentpoolcount) {
              item.talentpoolcount = item.talentpoolcount + 1;
            } else {
              item.talentpoolcount = 1
            }
          }
        });
           /**
           * Add to talentpool
           */
            const talentpoolParams = {
              "User ID": this.localstorageservice.getItem('userdata').userid,
              "Candidate ID": this.talentpoolAndCandidateData.profileurlsarray.toString(),
              "Talentpool Name": this.talentpoolAndCandidateData.talentpoolname
            }
            clevertap.event.push('Add Candidate to Talentpool', talentpoolParams);

        // this.modalService.open(this.extractingProfile,  { windowClass: "modalExtract", centered: true })
        // this.toastmessage('Profile added to talentpool', 'success')
      } else if (result.status == 'failure') {
        if (result.message == 'User not on paid plan') {
          this.modalService.dismissAll()
          this.modalService.open(this.premiumUserError, { windowClass: "modalExtract", centered: true })
        }
        else if (result.bulkextractioninprogress) {
          // this.toastmessage('Profile extraction already in progress. Please try again after sometime', 'error')
          this.talentPoolMessage = 'Profile extraction already in progress. Please try again after sometime';
        } else if (result.message == 'already-added') {
          // this.modalService.dismissAll()
          // this.toastmessage('Candidate has already been added to this talentpool', 'error')
          this.talentPoolMessage = 'Candidate has already been added to this talentpool';
        } else if (result?.message == 'TALENT_POOL_LIMIT_EXCEEDED') {
          this.talentPoolMessage = 'You can only add up to 2500 candidates.';
        }
        else {
          // this.toastmessage('Something went Wrong', 'error')
          this.talentPoolMessage = 'Something went Wrong';
        }
      }
    }, () => {

    }, () => {
      this.addToTalentpoolSpinner = false;
    });
  }

  private capitalizeFirstLetter(string) {
    if (typeof string !== 'string' || string.length === 0) {
      return '';
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error') {
      this.errorMessage = message;
      setTimeout(() => this.errorMessage = '', 5000);
    }
  }


  talentPoolandCandidateDataEvent(event) {
    if (event.talentpoolname == '') {
      this.disablebutton = true;
      this.talentpoolAndCandidateData = null;
      return;
    }
    if (event) {
      this.disablebutton = false;
      this.talentpoolAndCandidateData = event
    }
  }

  sendEmailAndGrabCandidate() {
    this.resetTPMssgParams();
    this.profileurlsarray = []
    this.profileurlsarray = this.candidatetoBeGrabbed.map(x => x.idinindex)
    this.profileurlsarray = this.profileurlsarray.filter((item,
      index) => this.profileurlsarray.indexOf(item) === index);
    this.disablebutton = true;
    const modalRef = this.modalService.open(this.extractToTalentpool, { windowClass: "modalExtract", centered: true });
    modalRef.result.then((data) => {
      // on close
    },
      (error) => {
        if (error != 'isGrabbed') {
          this.modalDismissed = true;
        }
      });

  }

  /**
   * Resets all the parameters related to adding showing messages after adding candidate to talent pool
   */
  private resetTPMssgParams() {
    this.showTalentPoolInput = true;
    this.talentPoolMessage = null;
    this.candidateName = null;
    this.addTalentPoolSuccess = false;
    this.talentpoolNumber = null;
  }

  closeAllModals() {
    this.modalService.dismissAll();
  }

  redirectToTalentPool() {
    this.modalService.dismissAll();
    this.router.navigate([`/talentpool/details/${this.talentpoolNumber}`]);
  }

  // not in an indian format
  formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }

  // Can't find usage here
  getLikelyToMoveInAggs() {
    Object.assign(this.requestObject, { 'resultsize': 1, 'aggregatetype': 'likelytomove' });
    delete this.requestObject['calledfrom'];
    delete this.requestObject['input'];
    delete this.requestObject['typeahead'];
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.likelyToMoveIn = response.data && response.data.aggregations && response.data.aggregations.likelytomove && response.data.aggregations.likelytomove.filter(l => l.key == 1)[0] && response.data.aggregations.likelytomove.filter(l => l.key == 1)[0].doc_count || 0;
      }
    });
  }


  getGenderAggs() {
    Object.assign(this.requestObject, { 'resultsize': 1, 'aggregatetype': 'gender' });
    delete this.requestObject['calledfrom'];
    delete this.requestObject['input'];
    delete this.requestObject['typeahead'];
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        const maleCount = response.data && response.data.aggregations && response.data.aggregations.gender && response.data.aggregations.gender.filter(g => g.key == 'male')[0] && response.data.aggregations.gender.filter(g => g.key == 'male')[0].doc_count || 0;
        const femaleCount = response.data && response.data.aggregations && response.data.aggregations.gender && response.data.aggregations.gender.filter(g => g.key == 'female')[0] && response.data.aggregations.gender.filter(g => g.key == 'female')[0].doc_count || 0;
        this.malePercent = maleCount ? ((maleCount / (maleCount + femaleCount)) * 100).toFixed(0) : 0;
        this.femalePercent = femaleCount ? ((femaleCount / (maleCount + femaleCount)) * 100).toFixed(0) : 0;
        this.statsMatrixHandlerService.setMatrixStaticData({ malePercent: this.malePercent, femalePercent: this.femalePercent });
      }
    });
  }

  getContactsAvailability() {
    this.requestObject['aggregatetype'] = 'contactsavailability';
    delete this.requestObject['input'];
    delete this.requestObject['typeahead'];
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.contactsAvailability = response.data && response.data.aggregations && response.data.aggregations.contactsavailability && response.data.aggregations.contactsavailability.doc_count;
      }
    });
  }

  private turnOnLoaders(excludeTotalCandidatesCountAvailable = true) {
    if (!excludeTotalCandidatesCountAvailable)
      this.totalCandidatesCountAvailable = false;
    this.likelyToMoveInCountAvailable = false;
    this.medianTenureInCountAvailable = false;
    this.genderDataAvailable = false;
    this.contactsAvailabilityCountAvailable = false;
    this.changedJobsCountAvailable = false;
  }

  getJobtitleReport() {
    this.requestObject['aggregatetype'] = 'jobtitle';
    delete this.requestObject['input'];
    delete this.requestObject['typeahead'];
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.jobTitleTable = this.jobTitleStatus == 'Current or Past' ? new MatTableDataSource(response.data.aggregations.jobtitle) : this.jobTitleStatus == 'Current' ? new MatTableDataSource(response.data.aggregations.current_jobtitle) : new MatTableDataSource(response.data.aggregations.pastjobtitle);
      }
    });
  }


  getSkillsReport() {
    this.requestObject['aggregatetype'] = 'skills';
    delete this.requestObject['input'];
    delete this.requestObject['typeahead'];
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.skillsTable = new MatTableDataSource(response.data.aggregations.skills);
      }
    });
  }

  getEducationReport() {
    this.requestObject['aggregatetype'] = 'education';
    delete this.requestObject['input'];
    delete this.requestObject['typeahead'];
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.educationTable = new MatTableDataSource(response.data.aggregations.education);
      }
    });
  }


  getFieldOfStudyReport() {
    this.requestObject['aggregatetype'] = 'fieldofstudy';
    delete this.requestObject['input'];
    delete this.requestObject['typeahead'];
    this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.fieldOfStudyTable = new MatTableDataSource(response.data.aggregations.fieldofstudy);
      }
    });
  }



  getLocationAggs(countries: string[] = []) {
    this.showLocationDisplayCard = false;
    this.topSuggestedLocations = [];
    const payload = this.aggregationService.getRequestWithFilters();
    payload['aggregatetype'] = 'location';
    payload['locations'] = _.uniq(countries);
    delete payload['input'];
    delete payload['typeahead'];
    this.personSearchService.getTotalAggs(payload).subscribe(response => {
      if (response.status == 'success') {
        setTimeout(() => {
          const filterData = this.filterDataHandlerService.fetchFilterData;
          const locationFilterData = filterData.locationSelectedList;
          const topList = this.aggregationService.getLocationTopList();
          const locationData = response.data.aggregations.location.filter(l => !locationFilterData.find(ld => ld.key.replace('.searchastext', '').replace('.iplocation', '').replace('.aisearch', '').toLowerCase() == l.key.toLowerCase()) && l.key.split(",").length == 3).filter(l => !topList.find(tl => tl.key.toLowerCase() == l.key.replace('.searchastext', '').replace('.iplocation', '').replace('.aisearch', '').toLowerCase())).slice(0, 5).map(l => ({ ...l, displayName: l.key.replace('.searchastext', '').replace('.iplocation', '').replace('.aisearch', '').split(',')[0], isSuggested: true }));

          this.topSuggestedLocations = locationData;
          this.topSuggestedLocations && this.topSuggestedLocations.length && (this.showLocationDisplayCard = true);
        }, 1000);
      }
    });
  }

  private setMatrixStats(res: [any, any, any]) {
    let response = res.find(el => !!el?.data?.aggregations?.gender);
    const maleCount = response?.data && response?.data?.aggregations && response?.data?.aggregations?.gender && response?.data?.aggregations?.gender.filter(g => g.key == 'male')[0] && response.data.aggregations.gender.filter(g => g.key == 'male')[0].doc_count || 0;
    const femaleCount = response?.data && response?.data?.aggregations && response?.data?.aggregations?.gender && response?.data?.aggregations?.gender.filter(g => g.key == 'female')[0] && response.data.aggregations.gender.filter(g => g.key == 'female')[0].doc_count || 0;
    this.malePercent = maleCount ? ((maleCount / (maleCount + femaleCount)) * 100).toFixed(0) : 0;
    this.femalePercent = femaleCount ? ((femaleCount / (maleCount + femaleCount)) * 100).toFixed(0) : 0;
    const euTalentAccess = this.localstorageservice.getItem('hasEUTalentInsightsAccess');
    if(euTalentAccess)
    this.totalCandidatesCount = response?.data?.totalresultscount;
    this.statsMatrixHandlerService.setMatrixStaticData({ malePercent: this.malePercent, femalePercent: this.femalePercent });

    const filterData = this.filterDataHandlerService.fetchFilterData;
    const companyData = filterData.companySelectedList;
    this.showCompanyDisplayCard = false;
    this.topSuggestedCompanies = [];
    if (!companyData.length && this.totalCandidatesCount >= 1000 && (this.malePercent < 25 || this.femalePercent < 30)) {
      this.getDiversityCompanies();
    }
    response = res.find(el => !!el.data.aggregations.changedjobs);
    this.changedJobs = response?.data && response?.data?.aggregations && response?.data?.aggregations?.changedjobs && response?.data?.aggregations?.changedjobs?.doc_count;
    this.statsMatrixHandlerService.setMatrixStaticData({ changedJobs: this.changedJobs });

    response = res.find(el => !!el.data.aggregations.total_tenure_median);
    this.totalMedianTanureCount = response?.data && response?.data?.aggregations && response?.data?.aggregations?.total_tenure_median && response?.data?.aggregations?.total_tenure_median?.value;
    this.statsMatrixHandlerService.setMatrixStaticData({ totalMedianTanureCount: this.totalMedianTanureCount });

    this.ngZone.run(() => {
      this.setCountAvailableAll();
    })
  }

  setChangeJobStats(response) {
    this.changedJobs = response.data && response.data.aggregations && response.data.aggregations.changedjobs && response.data.aggregations.changedjobs.doc_count;
    this.statsMatrixHandlerService.setMatrixStaticData({ changedJobs: this.changedJobs });
    this.changedJobsCountAvailable = true;
  }

  getTableByStatus() {
    switch (this.jobTitleStatus) {
      case 'Current or Past':
        return 'jobtitle';
      case 'Past':
        return 'pastjobtitle'
      default:
        return 'current_jobtitle';
    }
  }

  /**
   * Check if current search (via historyid) is saved
   */
  getSavedSearchDetails() {
    this.isSearchSaved = false;
    this.personSearchService.getSaveSearchHistory(0, this.talentdiscoveryhistoryid).subscribe((res: any) => {
      if (res && res.status === 'success') {
        if (res.message && (Array.isArray(res.message) && res.message?.length)) {
          this.savedSearchDetails = res.message[0];
          this.savedSearchDetails && (this.isSearchSaved = true);
        }
        if (this.isInsightsActive == true) {
          const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
          //loadn[0].style.display = 'block'
        }
      }
    });
  }

  saveSearch() {
    const modalRef = this.modalService.open(SaveSearchModalComponent, { windowClass: "modalExtract", centered: true, keyboard: false, backdrop: 'static' });
    modalRef.componentInstance.talentdiscoveryhistoryid = this.talentdiscoveryhistoryid;
    this.savedSearchDetails && (modalRef.componentInstance.searchName = this.savedSearchDetails?.talentdiscoveryname);
    modalRef.result
      .then((message: any) => {
        if (message && message === 'Saved successfully') {
          this.isSearchSaved = true;
          this.localstorageservice.setItem('talentdiscoveryhistoryid', true);
          this.successMessage = 'Search saved successfully';
        }
      })
      .catch((err: any) => {
        this.errorMessage = 'Something went wrong';
      })
      .finally(() => {
        this.getSavedSearchDetails();
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      })
  }

  getCompanyInfo(type: string, data: any, event) {

    let pastCompanyData = data

    this.currentCompanyInformation['name'] = pastCompanyData?.name
    this.currentCompanyInformation['industry'] = pastCompanyData?.industry
    this.currentCompanyInformation['linkedin_url'] = pastCompanyData?.linkedin_url
    this.currentCompanyInformation['location'] = pastCompanyData?.location?.name
    this.currentCompanyInformation['size'] = pastCompanyData?.size
    this.currentCompanyInformation['website'] = pastCompanyData?.website
    this.currentCompanyInformation['companylogo'] = pastCompanyData.companylogo
    this.currentCompanyInformation['tags'] = pastCompanyData.tags

  }

  openUrl(link, type) {
    if (type == 'website') {
      link = "https://www." + link;
    }
    window.open(link, "_blank")
  }
  //Add candidate to email campaign
  openAddToEmailCampaign(data) {
    if (data && data.id) {
      const candidateData = this.candidateList.filter(x => x.id === data.id)
      this.campaignCandidatesArray = candidateData;
    }
    else {
      this.campaignCandidatesArray = this.candidatetoBeGrabbed;
    }
    const modalRef = this.modalService.open(this.addCandidateToEmailCampaign, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  /**
   * Opens the AddCandidateAegisModalComponent modal and passes the selected candidates to it.
   * @param data The data of the candidate to be added to Aegis.
   */
  addToAegis(data: any) {
    if (data && data.id) {
      const candidateData = this.candidateList.filter(x => x.id === data.id)
      this.tagToAegisCandidate = candidateData;
    }
    else {
      this.tagToAegisCandidate = this.candidatetoBeGrabbed;
    }

    const modalRef = this.modalService.open(AddCandidateAegisModalComponent, { size: 'lg' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.candidates = this.tagToAegisCandidate;
    modalRef.componentInstance.calledfrom = 'person-search';
    modalRef.componentInstance.update.subscribe((result: { status: 'success' | 'error', message: string, data: any }) => {
      if (result.status === 'success') {
        this.isAddToAegisAvailable = false;
        const res = result.data?.createdCandidate ? result.data.createdCandidate : result.data;
        const successCount = res?.successful || 0;
        const duplicateCount = res?.duplicate || 0;
        const failedCount = res?.unsuccessful || 0;
        const totalCount = successCount + duplicateCount + failedCount;
        if (totalCount > 0) {
          if (successCount > 0 && duplicateCount > 0 && failedCount > 0) {
            this.successMessage = `Processed ${totalCount} candidate(s): ${successCount} added successfully, ${duplicateCount} skipped as duplicates, and ${failedCount} could not be added due to insufficient information.`;
          } else if (successCount && duplicateCount > 0 && !failedCount) {
            this.successMessage = `Processed ${totalCount} candidate(s): ${successCount} added successfully, ${duplicateCount} skipped as duplicates.`;
          } else if (successCount && !duplicateCount && !failedCount) {
            this.successMessage = `${successCount} Candidate Tagged Successfully`;
          } else if (!successCount && duplicateCount && !failedCount) {
            this.errorMessage = `${duplicateCount} Candidate duplicate found in Aegis`;
          } else if (!successCount && !duplicateCount && failedCount) {
            this.errorMessage = `${failedCount} Candidate could not be added due to insufficient information.`;
          } else {
            this.errorMessage = `No candidates were tagged to Aegis. Please try again.`;
          }
        } else {
          this.successMessage = `No candidates were tagged to Aegis.`;
        }

      } else if (result.status === 'error') {
        const res = result.data?.createdCandidate ? result.data.createdCandidate : result.data;
        const successCount = res?.successful || 0;
        const duplicateCount = res?.duplicate || 0;
        const failedCount = res?.unsuccessful || 0;
        const totalCount = successCount + duplicateCount + failedCount;
        if (totalCount > 0) {
          if (successCount > 0 && duplicateCount > 0 && failedCount > 0) {
            this.successMessage = `Processed ${totalCount} candidate(s): ${successCount} added successfully, ${duplicateCount} skipped as duplicates, and ${failedCount} could not be added due to insufficient information.`;
          } else if (successCount && duplicateCount > 0 && !failedCount) {
            this.successMessage = `Processed ${totalCount} candidate(s): ${successCount} added successfully, ${duplicateCount} skipped as duplicates.`;
          } else if (successCount && !duplicateCount && !failedCount) {
            this.successMessage = `${successCount} Candidate Tagged Successfully`;
          } else if (!successCount && duplicateCount && !failedCount) {
            this.errorMessage = `${duplicateCount} Candidate duplicate found in Aegis`;
          } else if (!successCount && !duplicateCount && failedCount) {
            this.errorMessage = `${failedCount} Candidate could not be added due to insufficient information.`;
          } else {
            this.errorMessage = `No candidates were tagged to Aegis. Please try again.`;
          }
        } else {
          this.errorMessage = `Failed to tag candidates to mandate. Please try again.`;
        }
      } else if (result.status === 'unauthorized') {
        this.errorMessage = result.message;
      }
      this.tagToAegisCandidate = [];
      this.candidatetoBeGrabbed = [];
      this.candidateList = this.candidateList.map(x => ({ ...x, selected: false }));
      this.selected = false;
      this.modalService.dismissAll();
      this.checkAegisIntegrationConnected();
      this.aegisIntegrationService.emitAegisTagCandidateEvent(result.data);
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 5000);
    });
  };

  /**
   * Receives the candidate data from the AddCandidateAegisModalComponent modal and assigns it to the tagToAegisCandidate variable.
   * @param $event The candidate data emitted from the AddCandidateAegisModalComponent modal.
   */
  aegisCandidateData($event: any) {
    this.isAddToAegisAvailable = $event ? false : true;
  };


  onClickMatrix(type) {
    // If redirected from insights and gender was already selected we do not want it to be editable
    if ((type === "Male" || type === "Female") && this.isGenderSelectionDisabled) return;

    let event = {};
    let matrixType;
    if (type === 'likelytomovein') {
      this.isLikelyToMoveInFilterSelected = !this.isLikelyToMoveInFilterSelected;
      this.candidateslikelytomove = this.isLikelyToMoveInFilterSelected ? 'Yes' : 'All'
      event = {
        "target": {
          "value": this.isLikelyToMoveInFilterSelected ? 'Yes' : 'All'
        }
      }
      matrixType = "likelytomovein";
    }
    else if (type?.trim()?.toLowerCase() === 'male') {
      this.isMaleMatrixSelected = !this.isMaleMatrixSelected;
      this.isFemaleMatrixSelected = false;
      event = {
        "target": {
          "value": this.isMaleMatrixSelected ? 'Male' : 'All'
        }
      };
      matrixType = "gender";
    }
    else if (type === 'Female') {
      this.isMaleMatrixSelected = false;
      this.isFemaleMatrixSelected = !this.isFemaleMatrixSelected;
      event = {
        "target": {
          "value": this.isFemaleMatrixSelected ? 'Female' : 'All'
        }
      };
      matrixType = "gender";
    }
    else if (type === 'changedJobs') {
      this.isChangedJobsSelected = !this.isChangedJobsSelected;
      this.changedJobStatus = this.isChangedJobsSelected ? 'yes' : 'all';
      event = {
        "target": {
          "value": this.changedJobStatus,
          "endDuration": this.changedJobDuration
        }
      };
      matrixType = "changedJobs";
    }
    this.statsMatrixHandlerService.emitMatrixSelectionObject(new MatrixFilter(matrixType, event));
  }
  onTypeAheadSearchCampaign(event: any): void {
    const query = event.target.value;
    this.emailCampaignService.getCampaigns({ campaign_name: query, created_by: this.localstorageservice.getItem('userdata').userid, 'status[]': [1, 2] }).subscribe((data) => {
      this.campaignList = data['data'];
    });
  }

  changedJobAgg(event) {
    if (this.isChangedJobsSelected) {
      this.changedJobStatus = 'yes';
      event = {
        "target": {
          "value": this.changedJobStatus,
          "endDuration": parseInt(event?.target?.value)
        }
      };
      let matrixType = "changedJobs";
      this.statsMatrixHandlerService.emitMatrixSelectionObject(new MatrixFilter(matrixType, event));
    }
    else {

      this.changedJobDuration = parseInt(event?.target?.value);
      this.changedJobEndDuration = this.changedJobDuration;
      // this.changedJobStartDuration = 0;
      this.aggregationService.getChangedJobStats(this.changedJobStartDuration, this.changedJobEndDuration, 'yes');
    }
  }

  exportToPDF() {
    this.personSearchService.exportCandidateProfileToPDF({ elasticid: this.currentCandidate.id }).subscribe((res: any) => {
      if (res) {
        if (res.status === 'failure') {
          this.errorMessage = 'Error occured while exporting to PDF';
        } else {
          const blobFile = new Blob([res], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blobFile);
          const downloadLink = document.createElement("a");
          downloadLink.style.display = "none";
          document.body.appendChild(downloadLink);
          downloadLink.setAttribute("href", blobUrl);
          downloadLink.setAttribute("download", `${this.currentCandidate.full_name.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())}.pdf`);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          this.successMessage = 'Exported to PDF successfully'
        }
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      }
    });
  }

  getsimilarcandidatetooltiptext() {
    this.generateAIMOdalLoader = false;
    if (this.isComingFromJD || this.isComingNLSearch) {
      this.similarobject = { data: this.jdDataService.jdDataFromSession };
    }

    if (this.similarobject?.data?.jobtitle) {
      this.similarobject?.data?.jobtitle.forEach(jt => {
        jt.isMandatory ? this.mustHaveSimilarCandidate.push({ field: jt.key.replace(/\.searchastext/g, ''), tooltipText: "Priority Job Title", isMandatory: true }) : this.goodToHaveFilters.push({ field: jt.key.replace(/\.searchastext/g, ''), tooltipText: "Job Title", isMandatory: false });
      });
    }

    if (this.similarobject?.data?.jobindustryname) {
      this.similarobject?.data?.jobindustryname.forEach(ji => {
        ji.isMandatory ? this.mustHaveSimilarCandidate.push({ field: ji.key.replace(/\.searchastext/g, ''), tooltipText: "Priority Industry", isMandatory: true }) : this.goodToHaveFilters.push({ field: ji.key.replace(/\.searchastext/g, ''), tooltipText: "Industry", isMandatory: false });
      });
    }

    if (this.similarobject?.data?.jobcompanyname) {
      this.similarobject?.data?.jobcompanyname.forEach(jc => {
        jc.isMandatory ? this.mustHaveSimilarCandidate.push({ field: jc.key.replace(/\.searchastext/g, ''), tooltipText: "Priority Company", isMandatory: true }) : this.goodToHaveFilters.push({ field: jc.key.replace(/\.searchastext/g, ''), tooltipText: "Company", isMandatory: false });
      });
    }

    if (this.similarobject?.data?.companysize && Array.isArray(this.similarobject?.data?.companysize) && this.similarobject?.data?.companysize?.length && this.similarobject?.data?.companysize[0] != null) {
      this.similarobject?.data?.companysize.forEach(cs => {
        cs.isMandatory ? this.mustHaveSimilarCandidate.push({ field: cs.key.replace(/\.searchastext/g, ''), tooltipText: "Priority Company Size", isMandatory: true }) : this.goodToHaveFilters.push({ field: cs.key.replace(/\.searchastext/g, ''), tooltipText: "Company Size", isMandatory: false });
      });
    }

    // if (this.similarobject?.data?.fromYrsOfExperience) {
    //   this.goodToHaveFilters.push({ field: this.similarobject?.data?.fromYrsOfExperience, tooltipText: "Total Tenure" });
    // }

    // if (this.similarobject?.data?.toYrsOfExperinece) {
    //   this.goodToHaveFilters.push({ field: this.similarobject?.data?.toYrsOfExperinece, tooltipText: "Total Tenure" });
    // }

    if (this.similarobject?.data?.currentlocation && Array.isArray(this.similarobject?.data?.currentlocation) && this.similarobject?.data?.currentlocation?.length && this.similarobject?.data?.currentlocation[0] != null && this.similarobject?.data?.currentlocation[0] != '') {
      this.similarobject?.data?.currentlocation.forEach(cl => {
        cl.isMandatory ? this.mustHaveSimilarCandidate.push({ field: cl.key.replace(/\.searchastext/g, ''), tooltipText: "Priority Location", isMandatory: true }) : this.goodToHaveFilters.push({ field: cl.key.replace(/\.searchastext/g, ''), tooltipText: "Location", isMandatory: false });
      });
    }

    if (this.similarobject && this.similarobject.data && Array.isArray(this.similarobject?.data?.skills) && this.similarobject.data.skills.length && this.similarobject?.data?.skills[0] != null) {
      this.similarobject?.data?.skills.forEach(skill => {
        skill.isMandatory ? this.mustHaveSimilarCandidate.push({ field: skill.key.replace(/\.searchastext/g, ''), tooltipText: "Priority  Skill", isMandatory: true }) : this.goodToHaveFilters.push({ field: skill.key.replace(/\.searchastext/g, ''), tooltipText: "Skill", isMandatory: false });
      });
    }

    if (
      this.similarobject &&
      this.similarobject.data &&
      this.similarobject.data.fromYrsOfExperience !== null &&
      this.similarobject.data.fromYrsOfExperience !== undefined &&
      this.similarobject.data.toYrsOfExperinece !== null &&
      this.similarobject.data.toYrsOfExperinece !== undefined
    )  {
      const fromYrsOfExperience = this.similarobject?.data?.fromYrsOfExperience;
      const toYrsOfExperinece = this.similarobject?.data?.toYrsOfExperinece;
      const rangeOfExperience = fromYrsOfExperience + "-" + toYrsOfExperinece;
      this.mustHaveSimilarCandidate.push({ field: rangeOfExperience, tooltipText: "Years of Experience" });
    }

    if (this.isArrayWithElements(this.similarobject?.data?.degrees)) {
      this.similarobject.data.degrees = this.similarobject.data.degrees.filter(Boolean);
      this.similarobject.data.degrees.forEach(degree => this.pushToAptFilterList(degree.key, "Degree", degree.isMandatory));
    }

    if (this.isArrayWithElements(this.similarobject?.data?.schools)) {
      this.similarobject.data.schools = this.similarobject.data.schools.filter(Boolean);
      this.similarobject.data.schools.forEach(school => this.pushToAptFilterList(school.key, "School", school.isMandatory));
    }

    if (this.isArrayWithElements(this.similarobject?.data?.fieldOfStudy)) {
      this.similarobject.data.fieldOfStudy = this.similarobject.data.fieldOfStudy.filter(Boolean);
      this.similarobject.data.fieldOfStudy.forEach(fos => this.pushToAptFilterList(fos.key, "Field of study", fos.isMandatory));
    }
    // if(this.jdDataService.isComingFromJobDescription) {
    //   const modalRef = this.modalService.open(GenAiJdSearchComponent,{windowClass: 'genAimodal',centered: true, backdrop: 'static', keyboard: false });
    //   modalRef.componentInstance.genAIEvent.subscribe(res=>{
    //     if(res.action == 'close') {
    //       this.generateAIMOdalLoader = true;
    //       if(this.showLoaderbeforeDataLoad == false){
    //         modalRef.dismiss();
    //       }
    //     }
    //   })
    // }
    this.modalFilters = this.mustHaveSimilarCandidate.concat(this.goodToHaveFilters);
    this.similarCandidateService.setSimilarCandidatesData(this.similarobject);
    this.nlSearchQuery = this.localstorageservice.getItem('nlSearchKeyword');
  }

  /**
   * Used when redirected from talent insights and also has jd filters
   * It converts jd key in similar candidate format, to shows chips of jd filters in person search listing
   * @param similarobject
   */
  getsimilarcandidatetooltiptextTIRedirect(similarobject) {
    if (similarobject?.data?.jobtitle) {
      similarobject?.data?.jobtitle.forEach(jt => {
        jt.isMandatory ? this.mustHaveSimilarCandidate.push({ field: jt.key.replace(/\.searchastext/g, ''), tooltipText: "Priority Job Title", isMandatory: true }) : this.goodToHaveFilters.push({ field: jt.key.replace(/\.searchastext/g, ''), tooltipText: "Job Title", isMandatory: false });
      });
    }

    if (similarobject?.data?.jobindustryname && Array.isArray(similarobject.data.jobindustryname) && similarobject.data.jobindustryname.length) {
      similarobject?.data?.jobindustryname.forEach(ji => {
        ji.isMandatory ? this.mustHaveSimilarCandidate.push({ field: ji.key.replace(/\.searchastext/g, ''), tooltipText: "Priority Industry", isMandatory: true }) : this.goodToHaveFilters.push({ field: ji.key.replace(/\.searchastext/g, ''), tooltipText: "Industry", isMandatory: false });
      });
    }

    if (similarobject?.data?.jobcompanyname && Array.isArray(similarobject.data.jobcompanyname) && similarobject.data.jobcompanyname) {
      similarobject?.data?.jobcompanyname.forEach(jc => {
        jc.isMandatory ? this.mustHaveSimilarCandidate.push({ field: jc.key.replace(/\.searchastext/g, ''), tooltipText: "Priority Company", isMandatory: true }) : this.goodToHaveFilters.push({ field: jc.key.replace(/\.searchastext/g, ''), tooltipText: "Company", isMandatory: false });
      });
    }

    if (similarobject?.data?.companysize && Array.isArray(similarobject.data.companysize) && similarobject.data.companysize.length) {
      similarobject?.data?.companysize.forEach(cs => {
        cs.isMandatory ? this.mustHaveSimilarCandidate.push({ field: cs.key.replace(/\.searchastext/g, ''), tooltipText: "Priority Company Size", isMandatory: true }) : this.goodToHaveFilters.push({ field: cs.key.replace(/\.searchastext/g, ''), tooltipText: "Company Size", isMandatory: false });
      });
    }

    if (similarobject?.data?.currentlocation && Array.isArray(similarobject.data.currentlocation) && similarobject.data.currentlocation.length) {
      similarobject?.data?.currentlocation.forEach(cl => {
        cl.isMandatory ? this.mustHaveSimilarCandidate.push({ field: cl.key.replace(/\.searchastext/g, ''), tooltipText: "Priority Location", isMandatory: true }) : this.goodToHaveFilters.push({ field: cl.key.replace(/\.searchastext/g, ''), tooltipText: "Location", isMandatory: false });
      });
    }

    if (similarobject && similarobject.data && Array.isArray(similarobject?.data?.skills) && similarobject.data.skills.length && similarobject?.data?.skills[0] != null) {
      similarobject?.data?.skills.forEach(skill => {
        skill.isMandatory ? this.mustHaveSimilarCandidate.push({ field: skill.key.replace(/\.searchastext/g, ''), tooltipText: "Priority  Skill", isMandatory: true }) : this.goodToHaveFilters.push({ field: skill.key.replace(/\.searchastext/g, ''), tooltipText: "Skill", isMandatory: false });
      });
    }

    if (this.isArrayWithElements(similarobject?.data?.degrees)) {
      similarobject.data.degrees = similarobject.data.degrees.filter(Boolean);
      similarobject.data.degrees.forEach(degree => this.pushToAptFilterList(degree.key, "Degree", degree.isMandatory));
    }

    if (this.isArrayWithElements(similarobject?.data?.schools)) {
      similarobject.data.schools = similarobject.data.schools.filter(Boolean);
      similarobject.data.schools.forEach(school => this.pushToAptFilterList(school.key, "School", school.isMandatory));
    }

    if (this.isArrayWithElements(similarobject?.data?.fieldOfStudy)) {
      similarobject.data.fieldOfStudy = similarobject.data.fieldOfStudy.filter(Boolean);
      similarobject.data.fieldOfStudy.forEach(fos => this.pushToAptFilterList(fos.key, "Field of study", fos.isMandatory));
    }

    this.modalFilters = this.mustHaveSimilarCandidate.concat(this.goodToHaveFilters);
  }

  private isArrayWithElements(arr) {
    return (
      !!arr && Array.isArray(arr) && arr.length > 0
    );
  }

  private pushToAptFilterList(value: string, tooltipText: string, isMandatory: boolean) {
    if (isMandatory)
      value?.trim()?.length && this.mustHaveSimilarCandidate.push({ field: value.replace(/\.searchastext/g, ''), tooltipText: "Priority " + tooltipText, isMandatory: true });
    else
      value?.trim()?.length && this.goodToHaveFilters.push({ field: value.replace(/\.searchastext/g, ''), tooltipText, isMandatory: false });
  }

  isEmptyOrUndefined(object: any): boolean {
    return _.isEmpty(object);
  }


  cleanCompanyName(companyName: string): string {
    return companyName.replace(/_/g, ' ');
  }

  selectRegion(region) {
    this.searchHistoryRegion = null;
    this.showregion = region;
    this.localstorageservice.setItem('region', region)
    this.sessionStorageService.setItem("historyRegion", null)
    this.filterDataHandlerService.setUpdatedContinent(true)

    if (this.isInsightsActive) {
      const extraInfo = {
        redirectSource: this.redirectSource,
        redirectData: this.redirectData,
      }

      const statusMap = {
        jobTitleStatus: this.jobTitleStatus,
        companyStatus: this.companyStatus,
        industryStatus: this.industryStatus,
        yearsOfExperienceType: this.yearsofexperience
      };
      this.aggregationService.getPersonSearchRecommendedCandidates(extraInfo)
    } else {
      this.getPersonSearchRecommendedCandidates()
    }
  }
  insightsEventHandler(event) {
    const action = event.action;
    switch (action) {
      case 'redirect': {
        this.insightsEvent = true;
        this.ngZone.run(() => this.onTabChange('listing'));
        break;
      }
      case 'aidata': {
        this.insightsaidata = event.data;
        this.insightsSubject.next(this.insightsaidata);
        break;
      }
    }
  }
  // Add this function to handle the selection from the typeahead
  onCampaignSelected(value): void {
    this.selectedCampaign = value;
    this.campaign_input.setValue(value.campaign_name);
  }

  async addToEmailCampaign() {
    this.campaign_input.markAllAsTouched();

    this.isLoadingEmailCampaignApi = true;
    let totalTarget = 0;
    let unsubscribedCandidateCount = 0;
    if (this.campaign_input.valid && this.selectedCampaign) {
      const campaign_id = this.selectedCampaign.campaign_id;
      let payloadArray = this.campaignCandidatesArray?.length && this.campaignCandidatesArray.map(x => {
        totalTarget++;
        if (x?.is_unsubscribed) {
          unsubscribedCandidateCount++;
          return
        }
        return {
          firstname: x.first_name,
          target_name: x.full_name,
          target_id: null,
          target_meta: JSON.stringify({
            "candidatenumber": x.candidatenumber && x.candidatenumber.length ? x.candidatenumber : null,
            "elastic_id": x.id,
            "title": x.job_title,
          }),

          //elastic || else send 0
          target_email: x.existingContactDetails && x.existingContactDetails.length ?
            this.extractPreferredEmail(x.existingContactDetails) : null,
          is_active: true,
          created_on: new Date().toISOString(),
          updated_on: new Date().toISOString()
        };
      }).filter(Boolean);
      const updatedPayloadArray = (payloadArray?.length) ? payloadArray.filter(x => x) : [];
      this.emailFoundCount = 0;
      updatedPayloadArray.forEach(element => {
        if (element.target_email)
          this.emailFoundCount++;
      }
      );
      const payloadWithCandidateNumber = updatedPayloadArray.filter(
        (x) => JSON.parse(x.target_meta || '{}')?.candidatenumber
      );
      const payloadWithoutCandidateNumber = updatedPayloadArray.filter(
        (x) => !JSON.parse(x.target_meta || '{}')?.candidatenumber
      );
      let finalPayload = payloadWithCandidateNumber;
      if (
        payloadWithCandidateNumber &&
        payloadWithCandidateNumber.length > 0 &&
        payloadWithoutCandidateNumber &&
        payloadWithoutCandidateNumber.length === 0
      ) {
      } else if (
        payloadWithoutCandidateNumber &&
        payloadWithoutCandidateNumber.length > 0
      ) {
        const elasticid = payloadWithoutCandidateNumber.map(
          (x) => JSON.parse(x.target_meta).elastic_id
        );
        const res = await this.emailCampaignService.migrateCandidates({ elasticid }).toPromise();
        payloadWithoutCandidateNumber.forEach((x) => {
          const parsedElasticId = JSON.parse(x.target_meta).elastic_id;
          if (res && res.data && res.data.length) {
            res.data.map((item) => {
              if (item.elasticId === parsedElasticId) {
                let tempMeta = JSON.parse(x.target_meta);
                tempMeta.candidatenumber = item.candidatenumber;
                x.target_meta = JSON.stringify(tempMeta);
              }
              x.target_id = null;
            });
          }
        });
        finalPayload = finalPayload.concat(payloadWithoutCandidateNumber);
      }
      finalPayload = finalPayload.filter(x => (JSON.parse(x?.target_meta)?.candidatenumber));

      if (!finalPayload.length) {
        this.isLoadingEmailCampaignApi = false;
        this.closeActiveModal();
        this.toastmessage("No valid email found for the candidate based on the selected campaign's email preference", 'error');
        return;
      }

      const elasticid = finalPayload.map(
        (x) => JSON.parse(x.target_meta).elastic_id
      );

      //If final payload has length 0, and we have list of unbubscribed candidates then show toast,
      // No candidades were added to email campaign
      if (unsubscribedCandidateCount > 0 && finalPayload.length === 0) {
        this.closeActiveModal();
        this.toastmessage("Unsubscribed from Email Campaign", 'error');
        return;
      }
      finalPayload?.length > 0 && this.emailCampaignService.createTarget(campaign_id, finalPayload).subscribe((res: any) => {
        if (res.status == 'success') {
          this.isLoadingEmailCampaignApi = false;
          if (res.data && res.data.length) {
            this.getCandidateActivityInBulk(elasticid, 'email-campaign');
                        this.closeActiveModal()

             const modalRef = this.modalService.open(this.addToEmailCampaignWithViewCampaign, { windowClass:'modalastoastmessage', size: 'xs' as 'lg', centered: false, backdrop: false, keyboard: false } )
              setTimeout(() => {
                modalRef.close();
              }, 5000);
                /**
               * add email campaign
               */
                 const emailCampaignParams = {
                  "User ID": this.localstorageservice.getItem('userdata').userid,
                  "Candidate ID": _.pluck(this.campaignCandidatesArray, 'id').toString(),
                  "Campaign Name": this.campaign_input.value
                }
                clevertap.event.push('Add Candidate to Email Campaign', emailCampaignParams);
            if (this.emailFoundCount !== finalPayload.length) {

              // new payload for openDetail modal that contains mapping of candidate number elastic_id and campaign_targe_id for bulk reveal
              const bulkRevealPayLoad = {
                enrichedFrom: "person-search-listing",
                candidates: [],
                campaign_id: campaign_id
              }

              res.data.map((arr) => {
                if (!arr?.target_email) {
                  bulkRevealPayLoad.candidates.push(
                    {
                      elastic_id: JSON.parse(arr?.target_meta || '{}')?.elastic_id,
                      // candidatenumber: JSON.parse(arr?.target_meta || '{}')?.candidatenumber,
                      campaign_target_id: arr.campaign_target_id
                    }
                  );
                }
              })

              this.openDetailsModal(campaign_id, bulkRevealPayLoad, this.emailFoundCount, totalTarget, unsubscribedCandidateCount);
            }
            else {
              this.closeActiveModal()
              if (unsubscribedCandidateCount) {
                this.toastmessage("Unsubscribed from Email Campaign", 'error');
              }
              else this.toastmessage("Candidate already present in selected campaign", 'error')
            }

            this.candidatetoBeGrabbed = [];
            this.campaignCandidatesArray = [];
            this.candidateList = this.candidateList.map(x => ({ ...x, selected: false }));
            this.selected = false;
          }
          else if (res.status == 'failure') {
            this.closeActiveModal()
            this.toastmessage("candidate addition failed", "error");
          }
        }
      }, (error: HttpErrorResponse) => {
                    this.isLoadingEmailCampaignApi = false;
                    if (error.status === 400 && error.error && Reflect.has(error.error, 'remainingTargets')) {
                      const remainingTargets = error.error.remainingTargets;
                      this.toastmessage(`Only ${remainingTargets} candidate(s) can be added to the campaign as you are nearing the campaign limit`, "error");
                    } else {
                      this.toastmessage("Something went wrong", "error");
                    }
                    this.closeActiveModal();
                  });
    } else {
      this.isLoadingEmailCampaignApi = false;
    }
  }
  getContactDetails(candidateid, type) {
    return new Promise((resolve, reject) => {
      let data = {
        "usernumber": this.localstorageservice.getItem('usernumber'),
        "candidatenumber": candidateid,
      };

      this.candidateservice.getContactDetails(data).subscribe(
        (res: any) => {
          if (res.status === 'success') {
            let email = null;
            if (type == 'FirstPersonal') {
              email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory == 'personal')?.contactdetail;
              if (email == null)
                email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory == 'professional')?.contactdetail;
            }
            else if (type == 'FirstProfessional') {
              email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory == 'professional')?.contactdetail;
              if (email == null)
                email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory == 'personal')?.contactdetail;
            }
            else {
              email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory == type)?.contactdetail;
            }
            if (email) {
              resolve(email);
            } else {
              // reject("Primary email not found for the candidate.");
              resolve(null);
            }
          } else {
            reject("Error fetching contact details for the candidate.");
          }
        },
        (error) => {
          reject("An error occurred while fetching contact details.");
        }
      );
    });
  }

  openAddToScreenAiModal(data: any) {
    if (data && data.id) {
      const candidateData = this.candidateList.filter(x => x.id === data.id)
      this.screenAiCandidatesArray = candidateData;
    }
    else {
      this.screenAiCandidatesArray = this.candidatetoBeGrabbed;
    }
    this.modalService.open(this.addCandidateToScreenAiModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  /**
   * Get all ScreenAI jobs for the dropdown.
   */
  getAllScreenAIJobs() {
    if (!this.job_input.value) {
      this.job_input.setValue('', { emitEvent: true });
    }
  }

  /**
   * Check if a job is currently being screened.
   */
  isScreeningInProgress(job: any){
    return job.batch_status === 'pending';
  }

  /**
   * Get tooltip text for a job.
   */
  getTooltipText(job: any){
    if(job.batch_status === 'pending'){
      return 'Screening in progress, please try after sometime';
    }
    return '';
  }

  /**
   * Search ScreenAI jobs as user types.
   */
  searchJob(event: any): void {
    const query = (event.target.value || '').trim();
    this.job_input.valueChanges
    .pipe(
      debounceTime(400),            // wait for user to stop typing
      distinctUntilChanged(),       // avoid same query twice
      switchMap((query: string) => {
        const q = (query || '').trim();
        return this.atsResumeScreenService.getAllScreenAIJobsBySource(q, 'create');
      })
    )
    .subscribe((res: any) => {

      if (res.status === 'success') {
        this.jobList = res.data || [];
      }

    });
  }

  onScreenAiJobSelected(value: any): void {
    this.selectedJob = value;
    this.job_input.setValue(value.name);
  }

  /**
   * Redirect to ScreenAI job listing page.
   */
  redirectToScreenAi(): void {
    if (this.selectedJob && this.selectedJob.ats_job_id) {
      this.router.navigate([`/resume-screen/candidate-listing/${this.selectedJob.ats_job_id}`]);
    } else {
      this.router.navigate(['/resume-screen']);
    }
    this.closeActiveModal();
  }

  /**
   * Add the current candidat to a ScreenAI job.
   * Performs a duplicate check first (per candidate), then calls the add API.
   */
  addToScreenAi(): void {
    this.job_input.markAllAsTouched();
    if (!this.job_input.valid || !this.selectedJob) {
      return;
    }

    this.isLoadingScreenAiApi = true;

    // Build the list of candidates we are attempting to add
    const candidatesForAdd = this.screenAiCandidatesArray.map(cnd =>{
      return {elastic_id: cnd.id,
        firstname: cnd.first_name,
        lastname: cnd.last_name,
        companyname: cnd.job_company_name,
        title: cnd.job_title}
    });

    if (!candidatesForAdd.length) {
      this.isLoadingScreenAiApi = false;
      this.screenAiDuplicateCheckDone = true;
      this.addCandidateSuccess = false;
      this.postAddMssg = 'No candidates selected.';
      return;
    }
    // Build bulk payload for all candidates at once
    const bulkDupPayload = {
      candidateDetails: candidatesForAdd,
      jobnumber: this.selectedJob.jobnumber
    }

    this.atsResumeScreenService.checkDuplicateCandidate(bulkDupPayload).toPromise()
      .then((res: any) => {
        const duplicateIds = new Set(res?.duplicateIds || []);
        const results = candidatesForAdd.map((candidate) => {
          const lookupId = candidate.elastic_id;
          return {
            candidate,
            isDuplicate: duplicateIds.has(lookupId)
          };
        });

        const duplicates = results.filter(r => r.isDuplicate);
        const nonDuplicates = results.filter(r => !r.isDuplicate);

        if (duplicates.length > 0 && nonDuplicates.length === 0) {
          // All are duplicates — do not proceed
          this.isLoadingScreenAiApi = false;
          this.screenAiDuplicateCheckDone = true;
          this.addCandidateSuccess = false;
          this.postAddMssg = `${duplicates.length === 1 ? 'This candidate is' : `${duplicates.length} candidates are`} already present in this ScreenAI job. ${candidatesForAdd.length - duplicates.length} new candidates will be added.`;
          return;
        }

        // Build candidateinfo for non-duplicate candidates only
        const candidateinfo = nonDuplicates.map(r => ({  // ← was `results`, should be `nonDuplicates`
          elasticid: r.candidate.elastic_id,
          source: 'Talent Discovery'
        })).filter(c => c.elasticid);

        const addPayload = {
          jobnumber: this.selectedJob.jobnumber,
          candidateinfo
        };

        this.atsResumeScreenService.addCandidatesToScreenAI(addPayload).subscribe((res: any) => {
          this.isLoadingScreenAiApi = false;
          this.screenAiDuplicateCheckDone = true;

          if (res && res.status === 'success') {
            this.addCandidateSuccess = true;
            const addedCount = candidateinfo.length;
            const skippedCount = duplicates.length;
            if (skippedCount > 0) {
              this.postAddMssg = `${addedCount} candidate${addedCount !== 1 ? 's' : ''} added to ScreenAI successfully. ${skippedCount} candidate${skippedCount !== 1 ? 's were' : ' was'} already present and skipped.`;
            } else {
              this.postAddMssg = `${addedCount} candidate${addedCount !== 1 ? 's' : ''} added to ScreenAI successfully.`;
            }
          } else {
            this.addCandidateSuccess = false;
            this.postAddMssg = (res && res.message) ? res.message : 'Something went wrong while adding to ScreenAI. Please try again.';
          }
        }, () => {
          this.isLoadingScreenAiApi = false;
          this.screenAiDuplicateCheckDone = true;
          this.addCandidateSuccess = false;
          this.screenAiCandidatesArray = [];
          this.selectedJob = null;
          this.postAddMssg = 'Something went wrong while adding to ScreenAI. Please try again.';
        });
      })
      .catch(() => {
        this.isLoadingScreenAiApi = false;
        this.screenAiDuplicateCheckDone = true;
        this.addCandidateSuccess = false;
        this.screenAiCandidatesArray = [];
        this.selectedJob = null;
        this.postAddMssg = 'Something went wrong during duplicate check. Please try again.';
      });
  }

  openDetailsModal(campaign_id, payload, emailsFound, total_target, unsubscribedCandidateCount) {
    const modalRef = this.modalService.open(BulkRevealModalComponent, { size: 'xs' as 'lg', centered: true });
    modalRef.componentInstance.campaign_id = campaign_id;
    modalRef.componentInstance.payload = payload;
    modalRef.componentInstance.emailsFound = emailsFound;
    modalRef.componentInstance.campaignDetails = this.selectedCampaign;
    modalRef.componentInstance.total_target = total_target;
    modalRef.componentInstance.unsubscribedCandidateCount = unsubscribedCandidateCount;
    modalRef.componentInstance.calledFor = 'email-campaign';
  }

  closeActiveModal() {
    this.campaign_input.markAsUntouched();
    this.campaign_input.markAsPristine();
    this.campaign_input.reset();
    // Reset ScreenAI modal state
    this.screenAiDuplicateCheckDone = false;
    this.isLoadingScreenAiApi = false;
    this.postAddMssg = '';
    this.addCandidateSuccess = false;
    this.selectedJob = null;
    this.job_input.markAsUntouched();
    this.job_input.markAsPristine();
    this.job_input.reset();
    this.jobList = []
    this.modalService.dismissAll()
  }

  getEmailPref(data) {
    if (data == 1) {
      return 'personal';
    }
    else if (data == 2) {
      return 'professional';
    }
    else if (data == 3) {
      return 'FirstPersonal';
    }
    else {
      return 'FirstProfessional';
    }
  }

  /**
   * Extract target email based on preference
   * @param details existing contact detail object
   * @returns
   */
  extractPreferredEmail(details) {
    let emailPref = this.selectedCampaign['email_pref']
    let personalPref_email = '';
    let professionalPref_email = '';
    let targetEmailFound = '';
    const existingContactDetails = details?.emails;
    if (existingContactDetails && existingContactDetails.length) {

      personalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingContactDetails, 'personal')
      professionalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingContactDetails, 'professional')

      switch (emailPref) {
        case 1: targetEmailFound = personalPref_email;
          break;
        case 2: targetEmailFound = professionalPref_email;
          break;
        case 3: targetEmailFound = personalPref_email ? personalPref_email : professionalPref_email;
          break;
        case 4: targetEmailFound = professionalPref_email ? professionalPref_email : personalPref_email;
          break;
      }
    }
    return targetEmailFound;
  }

  getLastActivity(elastic_id) {
    if (elastic_id && Array.isArray(elastic_id) && elastic_id.length) {
      elastic_id = elastic_id[0]
    }

    let currentIndex = this.candidateList.findIndex(x => x.idinindex === elastic_id)
    this.personSearchService.getLastCandidateActivity(elastic_id).subscribe((result: any) => {
      if (result && result.status == 'success') {
        this.candidateList[currentIndex]['lastcandidateactivity'] = result.message
      }
    });
  }

  refreshCurrentView($event) {
    const elastic_id = $event && $event.id ? $event.id : null
    if (elastic_id != null) {
      this.getLastActivity(elastic_id)
    }
  }


  getCandidateActivityInBulk(elastic_id, type) {
    this.personSearchService.getCandidateActivityInBulk(elastic_id).subscribe((result: any) => {
      if (result && result.status == "success") {
        const bulkCandidateActivity = result.message
        this.candidateList.forEach(candidate => {
          let availableData = bulkCandidateActivity.find(y => y.elastic_id == candidate.idinindex)
          if (availableData) {
            candidate['lastcandidateactivity'] = [availableData]
            if (type === 'email-campaign') {
              if (candidate['emailcampaigncount'] && candidate['emailcampaigncount'] >= 1) {
                candidate['emailcampaigncount'] = candidate['emailcampaigncount'] + 1
              } else {
                candidate['emailcampaigncount'] = 1;
              }
            }
          }
        })
      }
    });
  }



  autoSearch(query: string) {
    this.searchKeyword = query;
    this.search();
  }

  openaiLoading({ state, count }) {
    this.isOpenAILoading = state;
    this.showOpenAISuggestions = count;
  }

  aiChipUpdate(aiSelection: SuggestedTitle[]) {
    this.aiSuggestion = aiSelection;
  }

  updateChipSelection(chip: { suggestedTitle: SuggestedTitle, [key: string]: any }[]) {
    this.updateChips.emit(chip.map(c => c.suggestedTitle));
  }

  insightsHandler(event) {
    this.insightsaidata = event.insights;
    this.insightsSubject.next(this.insightsaidata);
    //console.log("eventdata",event);
  }

  editSimilarCandidateFilters(firstLoad = false) {

    this.personSearchService.passsimilarcandidatesdata({
      ...this.similarobject,
      calledfrom: this.isComingFromJD ? GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION : this.isComingNLSearch ? GeneralConstants.REDIRECT_SOURCES.NL_SEARCH : 'edit-similar-candidate'
    });
    if(firstLoad == true && this.similarobject?.data?.jobtitle?.length > 0 ) {
       this.talentdiscoveryhistoryid = null;
       // this.personSearchService.passsimilarcandidatesdata(res);
        this.localstorageservice.setItem('similar-candidates-additional-filters', JSON.stringify(this.similarobject));
        const requestObject = this.aggregationService.getRequestWithFilters()
        this.searchKeyword = requestObject.booleanquery;
        this.requestObject.continentstobeincluded = typeof this.similarobject?.data?.locationcontinent == 'string' ? [this.similarobject.data.locationcontinent] : this.similarobject?.data?.locationcontinent?.length > 0 ? this.similarobject.data.locationcontinent: [this.localstorageservice.getItem('defaultContinent')]
        const fromyrsofexperience = this.similarobject.data.fromYrsOfExperience;
        const toyrsofexperinece = this.similarobject.data.toYrsOfExperinece;

        this.requestObject['similarcandidates_industries'] = !Array.isArray(this.similarobject.data.jobindustryname) ? [this.similarobject.data.jobindustryname] : this.similarobject.data.jobindustryname
        this.requestObject['similarcandidates_locations'] = this.similarobject.data.currentlocation
        this.requestObject['similarcandidates_skills'] = this.similarobject.data.skills
        this.requestObject['similarcandidates_companysizes'] = this.similarobject.data.companysize != null ? this.similarobject.data.companysize : []
        this.requestObject['similarcandidates_fromyearsofexperience'] = fromyrsofexperience != null ? [fromyrsofexperience] : []
        this.requestObject['similarcandidates_toyearsofexperience'] = toyrsofexperinece != null ? [toyrsofexperinece] : []
        this.requestObject['similarcandidates_toyearsofexperience'] = toyrsofexperinece != null ? [toyrsofexperinece] : []
        this.requestObject['similarcandidates_totaltenure'] = this.similarobject.data.totaltenure
        this.requestObject['similarcandidates_jobtitles'] = this.similarobject.data.jobtitle || [];
        this.requestObject['similarcandidates_companies'] = this.similarobject.data.jobcompanyname || [];
        this.requestObject['similarcandidates_degrees'] = this.similarobject.data.degrees || [];
        this.requestObject['similarcandidates_schools'] = this.similarobject.data.schools || [];
        this.requestObject['similarcandidates_fieldofstudy'] = this.similarobject.data.fieldOfStudy || [];
        this.requestObject['similarcandidates_excludefirstname'] = this.similarobject.data.firstname || null;
        this.requestObject['similarcandidates_excludelastname'] = this.similarobject.data.lastname || null;

        // extra information for history
        this.requestObject['linkedinurl'] = this.similarobject.data.linkedinurl
        this.requestObject['isUploadedFromResume'] = this.similarobject.data.isUploadedFromResume
        this.requestObject['fullname'] = this.similarobject.data.fullname

        this.aggReqObjectHandlerService.setShareRequestObject(this.requestObject);
        this.similarCandidateService.setSimilarCandidatesData(this.similarobject);
        this.similarCandidateService.emitSimilarCandidateEvent();
        this.resetMustAndGoodFilters();
            /**
           * Similar seaarch CT event
           */
             const similarParams = {
              "User ID": this.localstorageservice.getItem('userdata').userid,
              "Search Type": "Similar Candidate Search",
              "Time": moment().format()
            }
            clevertap.event.push('Search Initiated', similarParams);

    } else {
    const modalRef = this.modalService.open(SimilarCandidateFilterComponent, { size: 'xl', windowClass: 'modal-size', centered: true, backdrop: 'static', keyboard: false });
    const modalInstance: SimilarCandidateFilterComponent = modalRef.componentInstance;
    modalInstance.type = "edit";
    modalRef.result.then((res) => {
      if (res?.action === 'submit' && this.isComingFromJD) {
        this.talentdiscoveryhistoryid = null;
        this.similarCandidateService.emitSimilarCandidateEvent();
        this.personSearchService.passsimilarcandidatesdata(res);
        const uniqueHash = this.route.snapshot.queryParamMap.get(GeneralConstants.LS_KEYS.UNIQUE_HASH);
        const similarObject = res?.data ? res.data : new SimilarCandidateDetails();
        this.jdDataService.setSessionData(uniqueHash, similarObject);
        this.similarobject = res;
                this.locationContinents = this.similarobject?.data?.locationContinentName?.length ? _.pluck(this.similarobject?.data?.locationContinentName, 'continent'): [this.localstorageservice.getItem('defaultContinent')]

        this.similarCandidateService.setSimilarCandidatesData(this.similarobject);
        const historyId = this.localstorageservice.getItem('jdinsightshistoryid');
          if(!historyId) {
              this.resetMustAndGoodFilters();
          } else {
            this.jdSearchActivity(res.data);

          }
         this.jdDataService.jdFilterUpdateEventEmit();

      } else if(res?.action === 'submit' && this.isComingNLSearch) {
        this.talentdiscoveryhistoryid = null;
        this.similarCandidateService.emitSimilarCandidateEvent();
        this.personSearchService.passsimilarcandidatesdata(res);
        const uniqueHash = this.route.snapshot.queryParamMap.get(GeneralConstants.LS_KEYS.UNIQUE_HASH);
        const similarObject = res?.data ? res.data : new SimilarCandidateDetails();
        this.jdDataService.setSessionData(uniqueHash, similarObject);
        this.similarobject = res;
        this.locationContinents = this.similarobject?.data?.locationContinentName?.length ? _.pluck(this.similarobject?.data?.locationContinentName, 'continent'): [this.localstorageservice.getItem('defaultContinent')]
        this.similarCandidateService.setSimilarCandidatesData(this.similarobject);
        this.resetMustAndGoodFilters();

        this.jdDataService.jdFilterUpdateEventEmit();
      } else if (res.action == 'submit') {
        this.talentdiscoveryhistoryid = null;
        this.personSearchService.passsimilarcandidatesdata(res);
        this.localstorageservice.setItem('similar-candidates-additional-filters', JSON.stringify(res));
        const requestObject = this.aggregationService.getRequestWithFilters()
        this.searchKeyword = requestObject.booleanquery;
        this.similarobject = res;
        this.locationContinents = this.similarobject?.data?.locationContinentName?.length ? _.pluck(this.similarobject?.data?.locationContinentName, 'continent'): [this.localstorageservice.getItem('defaultContinent')];

        this.requestObject.continentstobeincluded = this.similarobject?.data?.locationcontinent ? [this.similarobject.data.locationcontinent] : []
        const fromyrsofexperience = this.similarobject.data.fromYrsOfExperience;
        const toyrsofexperinece = this.similarobject.data.toYrsOfExperinece;

        this.requestObject['similarcandidates_industries'] = !Array.isArray(this.similarobject.data.jobindustryname) ? [this.similarobject.data.jobindustryname] : this.similarobject.data.jobindustryname
        this.requestObject['similarcandidates_locations'] = this.similarobject.data.currentlocation
        this.requestObject['similarcandidates_skills'] = this.similarobject.data.skills
        this.requestObject['similarcandidates_companysizes'] = this.similarobject.data.companysize != null ? this.similarobject.data.companysize : []
        this.requestObject['similarcandidates_fromyearsofexperience'] = fromyrsofexperience != null ? [fromyrsofexperience] : []
        this.requestObject['similarcandidates_toyearsofexperience'] = toyrsofexperinece != null ? [toyrsofexperinece] : []
        this.requestObject['similarcandidates_toyearsofexperience'] = toyrsofexperinece != null ? [toyrsofexperinece] : []
        this.requestObject['similarcandidates_totaltenure'] = this.similarobject.data.totaltenure
        this.requestObject['similarcandidates_jobtitles'] = this.similarobject.data.jobtitle || [];
        this.requestObject['similarcandidates_companies'] = this.similarobject.data.jobcompanyname || [];
        this.requestObject['similarcandidates_degrees'] = this.similarobject.data.degrees || [];
        this.requestObject['similarcandidates_schools'] = this.similarobject.data.schools || [];
        this.requestObject['similarcandidates_fieldofstudy'] = this.similarobject.data.fieldOfStudy || [];
        this.requestObject['similarcandidates_excludefirstname'] = this.similarobject.data.firstname || null;
        this.requestObject['similarcandidates_excludelastname'] = this.similarobject.data.lastname || null;

        // extra information for history
        this.requestObject['linkedinurl'] = this.similarobject.data.linkedinurl
        this.requestObject['isUploadedFromResume'] = this.similarobject.data.isUploadedFromResume
        this.requestObject['fullname'] = this.similarobject.data.fullname

        this.aggReqObjectHandlerService.setShareRequestObject(this.requestObject);
        this.similarCandidateService.setSimilarCandidatesData(this.similarobject);
        this.similarCandidateService.emitSimilarCandidateEvent();
        this.resetMustAndGoodFilters();
            /**
           * Similar seaarch CT event
           */
             const similarParams = {
              "User ID": this.localstorageservice.getItem('userdata').userid,
              "Search Type": "Similar Candidate Search",
              "Time": moment().format()
            }
            clevertap.event.push('Search Initiated', similarParams);
      } else if (res.action === 'close' && firstLoad) {
        this.location.back();
      }
      modalRef.dismiss();
    });
    }



  }

  redirectOpenSimilarCandidate(res) {
    this.modalService.dismissAll();
        this.talentdiscoveryhistoryid = null;
        this.personSearchService.passsimilarcandidatesdata(res);
        this.localstorageservice.setItem('similar-candidates-additional-filters', JSON.stringify(res));
        const requestObject = this.aggregationService.getRequestWithFilters()
        this.searchKeyword = requestObject.booleanquery;
        this.similarobject = res;
        this.requestObject.continentstobeincluded = typeof this.similarobject?.data?.locationcontinent == 'string' ? [this.similarobject.data.locationcontinent] : this.similarobject?.data?.locationcontinent?.length > 0 ? this.similarobject.data.locationcontinent: [this.localstorageservice.getItem('defaultContinent')]
        const fromyrsofexperience = this.similarobject?.data?.fromYrsOfExperience;
        const toyrsofexperinece = this.similarobject?.data?.toYrsOfExperinece;

        this.requestObject['similarcandidates_industries'] = this.similarobject?.data?.jobindustryname
        this.requestObject['similarcandidates_locations'] = this.similarobject?.data?.currentlocation
        this.requestObject['similarcandidates_skills'] = this.similarobject?.data?.skills
        this.requestObject['similarcandidates_companysizes'] = this.similarobject?.data?.companysize != null ? this.similarobject.data.companysize : []
        this.requestObject['similarcandidates_fromyearsofexperience'] = fromyrsofexperience != null ? [fromyrsofexperience] : []
        this.requestObject['similarcandidates_toyearsofexperience'] = toyrsofexperinece != null ? [toyrsofexperinece] : []
        this.requestObject['similarcandidates_toyearsofexperience'] = toyrsofexperinece != null ? [toyrsofexperinece] : []
        this.requestObject['similarcandidates_totaltenure'] = this.similarobject?.data?.totaltenure
        this.requestObject['similarcandidates_jobtitles'] = this.similarobject?.data?.jobtitle || [];
        this.requestObject['similarcandidates_companies'] = this.similarobject?.data?.jobcompanyname || [];
        this.requestObject['similarcandidates_degrees'] = this.similarobject?.data?.degrees || [];
        this.requestObject['similarcandidates_schools'] = this.similarobject?.data?.schools || [];
        this.requestObject['similarcandidates_fieldofstudy'] = this.similarobject?.data?.fieldOfStudy || [];
        this.requestObject['similarcandidates_excludefirstname'] = this.similarobject?.data?.firstname || null;
        this.requestObject['similarcandidates_excludelastname'] = this.similarobject?.data?.lastname || null;

        // extra information for history
        this.requestObject['linkedinurl'] = this.similarobject?.data?.linkedinurl
        this.requestObject['isUploadedFromResume'] = this.similarobject?.data?.isUploadedFromResume
        this.requestObject['fullname'] = this.similarobject?.data?.fullname;
        if(this.similarobject?.data?.currentlocation?.length > 0) {
          this.similarobject.data.locationContinentName = [{key: this.similarobject.data.currentlocation[0].key, continent: this.requestObject.continentstobeincluded[0], calledFrom: 'jd'}];

        }

        this.aggReqObjectHandlerService.setShareRequestObject(this.requestObject);
        this.similarCandidateService.setSimilarCandidatesData(this.similarobject);
        this.similarCandidateService.emitSimilarCandidateEvent();
        this.resetMustAndGoodFilters();
            /**
           * Similar seaarch CT event
           */
             const similarParams = {
              "User ID": this.localstorageservice.getItem('userdata').userid,
              "Search Type": "Similar Candidate Search",
              "Time": moment().format()
            }
            clevertap.event.push('Search Initiated', similarParams);

  }

  private resetMustAndGoodFilters() {
    this.mustHaveSimilarCandidate = [];
    this.goodToHaveFilters = [];
    this.getsimilarcandidatetooltiptext();
    this.setPage(1);
  }

  private getSafeKey(str: string): string {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
  }

  updateSuggestions(suggestions: any) {
    suggestions['isSelected'] = suggestions['isSelected'] ? false : true;
  }

  applySuggestion(type: string) {
    switch (type) {
      case 'location': {
        const location = this.topSuggestedLocations.filter(l => l.isSelected).map(l => ({ ...l, key: `${l.key}.aisearch`, isExcluded: false, isMandatory: false, chipkey: l.displayName }));
        this.filterDataHandlerService.setSuggestedLocation(location);
        break;
      }
      case 'company': {
        const company = this.topSuggestedCompanies.filter(c => c.isSelected).map(c => ({ ...c, key: c.key, isExcluded: false, isMandatory: false, chipkey: c.displayName }));
        this.filterDataHandlerService.setSuggestedCompany(company);
        break;
      }
    }
  }

  getDiversityCompanies() {
    const payload = this.aggregationService.getRequestWithFilters();
    payload['aggregatetype'] = 'current_company-gender';
    payload['aggregatescount'] = 50;

    delete payload['input'];
    delete payload['typeahead'];

    const filterData = this.filterDataHandlerService.fetchFilterData;
    const companyFilterData = filterData.companySelectedList.filter(c => c.key.replace('.searchastext', '').replace('.aisearch', ''));

    this.personSearchService.getTotalAggs(payload).subscribe((res: any) => {
      const topList = this.aggregationService.getCompanyTopList();
      let finalList = [];
      const companyData = res.data.aggregations['current_company-gender'].filter(c => !companyFilterData.find(cd => cd.key.replace('.searchastext', '').replace('.aisearch', '').toLowerCase() == c.key.toLowerCase()) && !topList.find(tl => tl.key.toLowerCase() == c.key.replace('.searchastext', '').replace('.aisearch', '').toLowerCase()) && c.gender).map(c => ({ ...c, displayName: c.key.replace('.searchastext', '').replace('.aisearch', '') }));
      if (this.malePercent < 25) {
        finalList = companyData.filter(c => (c.gender.length == 1 && c.gender[0].key == 'male') || (c.gender.length == 2 && c.gender[0].key == 'male' && c.gender[0].doc_count > c.gender[1].doc_count) || (c.gender.length == 2 && c.gender[1].key == 'male' && c.gender[0].doc_count < c.gender[1].doc_count)).slice(0, 5);
      } else {
        finalList = companyData.filter(c => (c.gender.length == 1 && c.gender[0].key == 'female') || (c.gender.length == 2 && c.gender[1].key == 'female' && c.gender[0].doc_count < c.gender[1].doc_count) || (c.gender.length == 2 && c.gender[0].key == 'female' && c.gender[0].doc_count > c.gender[1].doc_count)).slice(0, 5);
      }
      finalList && finalList.length && (this.showCompanyDisplayCard = true);
      const companyNames = finalList.map(c => c.key.replace('.searchastext', '').replace('.aisearch', ''));

      const payload = companyNames.map(item=>{
        if(item){
          return {name: item};
        };
      }).filter(Boolean);


      payload?.length &&
      this.personSearchService.getCompanyLogoV2(payload).subscribe((res: any) => {
          const response = res.data;
          finalList = finalList.map(c => ({ ...c, companylogo: response.find(r => r.key.toLowerCase() == c.key.replace('.searchastext', '').replace('.aisearch', '').toLowerCase())?.companylogo }));
          this.topSuggestedCompanies = finalList;
      });
    });
  }

  closeCard(type: string) {
    switch (type) {
      case 'company': {
        this.showCompanyDisplayCard = false;
        break;
      }
      case 'location': {
        this.showLocationDisplayCard = false;
        break;
      }
    }
  }

  showEUAccessModal() {
    const modalRef = this.modalService.open(EuropeAccessModalComponent, { windowClass: 'euAccessModal', centered: true, backdrop: 'static', keyboard: false });

  }


  /**
   * set Filter data
   * @param replace
   */
    setFilterDataInLocalStorage(replace: boolean = false) {
    if(window.location.pathname !== '/person/search/listing') return;
      let filterData = this.filterDataHandlerService.fetchFilterData;
      filterData['startindex'] = this.start;
      filterData['resultsize'] = this.profilesPerPage;
      filterData['isListingActive'] = this.isListingActive;
      filterData['isInsightsActive'] = this.isInsightsActive;
      filterData['booleanquery'] = this.getBooleanQuery();
      const localKey = GlobalService.hash(JSON.stringify(cjson.compress(filterData)));
      if (!window.location.search.includes(localKey)) {
        localStorage.setItem(localKey, JSON.stringify(cjson.compress(filterData)));
        const parsedUrl = this.router.parseUrl(this.router.url);
        const uniqueHash = this.route.snapshot.queryParams.uniqueHash;
        const redirectSource = parsedUrl.queryParams.redirectSource;
        const comingFrom = parsedUrl.queryParams.redirectFrom;
        this.location[replace ? 'replaceState' : 'go'](parsedUrl.toString().split('?')[0], 'filter=' + encodeURIComponent(localKey) + (this.searchKeyword && this.searchKeyword !== '' ? `&keyword=${this.searchKeyword}` : '') + (this.searchedfrom && this.searchedfrom !== '' ? `&type=${this.searchedfrom}` : '') + (this.filterType && this.filterType !== '' ? `&filtertype=${this.filterType}` : '') + (this.filterValue && this.filterValue !== '' ? `&filtervalue=${this.filterValue}` : '') + (this.searchSource && this.searchSource !== '' ? `&searchSource=${this.searchSource}` : '') + (uniqueHash && uniqueHash !== '' ? `&uniqueHash=${uniqueHash}` : '') + (redirectSource && redirectSource !== '' ? `&redirectSource=${redirectSource}` : '') + (comingFrom && comingFrom !== '' ? `&redirectFrom=${comingFrom}` : ''));
      }
    }



  /**
  * Update all selected filter from localstorage
  * @param filter - Filter key to get filterdata from localstorage
  */
  loadFilterFromLocalStorage(storedData: any) {
    // const cacheRequest = localStorage.getItem(filter);
    // const storeData = cjson.decompress(JSON.parse(cacheRequest))
    if(storedData && !storedData.calledFrom){

        if(storedData.startindex && storedData.resultsize){
          this.start = storedData.startindex;
          this.profilesPerPage = storedData.resultsize;
          this.currentPage = (storedData.startindex / Number(storedData.resultsize))+1;

          this.filterData.startindex = storedData.startindex;
          this.filterData.resultsize = storedData.resultsize;
        }else{
          this.start = 0;
          this.currentPage = 1;
          this.profilesPerPage = 25;
          this.filterData.startindex = 0;
          this.filterData.resultsize = 25;
        }

        if(storedData.booleanquery){
          this.searchKeyword = storedData.booleanquery;
          this.filterData.booleanquery = storedData.booleanquery;
        } else {
          this.searchKeyword = "";
          this.filterData.booleanquery = "";
        }

        if(this.localstorageservice.getItem('talentdiscoveryhistoryid')) {
          this.talentdiscoveryhistoryid = null;
          this.filterData.talentdiscoveryhistoryid = null;
        } else {
          if(storedData.talentdiscoveryhistoryid){
            this.talentdiscoveryhistoryid = storedData.talentdiscoveryhistoryid;
            this.filterData.talentdiscoveryhistoryid = storedData.talentdiscoveryhistoryid;
          } else if(this.talentdiscoveryhistoryid) {
            this.talentdiscoveryhistoryid = this.talentdiscoveryhistoryid;
            this.filterData.talentdiscoveryhistoryid = this.talentdiscoveryhistoryid;
          } else {
            this.talentdiscoveryhistoryid = null;
            this.filterData.talentdiscoveryhistoryid = null;
          }
        }

        if(this.browserBackEvent && this.localstorageservice.getItem('talentdiscoveryhistoryid')) {
          this.savehistory = true;
          this.filterData.savehistory = true;
        } else if (this.browserBackEvent) {
          this.savehistory = false;
          this.filterData.savehistory = false;
        } else {
            if(storedData && storedData.savehistory) {
              this.savehistory = storedData.savehistory;
              this.filterData.savehistory = storedData.savehistory;
            } else {
              this.savehistory = false;
              this.filterData.savehistory = false;
            }
          }


      if (storedData && storedData.jobTitleStatus) {
          this.jobTitleStatus = storedData.jobTitleStatus;
          this.filterData.jobTitleStatus = this.jobTitleStatus;
        } else {
          this.jobTitleStatus = CallStage.CURRENT.toString();
          this.filterData.jobTitleStatus = this.jobTitleStatus;
        }

        if (storedData && storedData.companyStatus) {
          this.companyStatus = storedData.companyStatus;
          this.filterData.companyStatus = this.companyStatus;
        } else {
          this.companyStatus = CallStage.CURRENT.toString();
          this.filterData.companyStatus = this.companyStatus;
        }

        if (storedData && storedData.industryStatus) {
          this.industryStatus = storedData.industryStatus;
          this.filterData.industryStatus = this.industryStatus;
        } else {
          this.industryStatus = CallStage.CURRENT.toString();;
          this.filterData.industryStatus = this.industryStatus;

        }

        if(storedData.jobTitleSelectedList){
          this.jobTitleSelectedList = storedData.jobTitleSelectedList;
          this.filterData.jobTitleSelectedList = _.clone(storedData.jobTitleSelectedList, true);
        } else {
          this.jobTitleSelectedList = [];
          this.filterData.jobTitleSelectedList = _.clone(storedData.jobTitleSelectedList, true);
        }

        if(storedData.pastJobTitleSelectedList){
          this.filterData.pastJobTitleSelectedList = _.clone(storedData.pastJobTitleSelectedList, true);
        }

        if(storedData.locationSelectedList){
          this.locationSelectedList = storedData.locationSelectedList;
          this.filterData.locationSelectedList = _.clone(this.locationSelectedList, true);
          this.locationContinents = _.uniq(_.pluck(this.locationSelectedList, 'continent'))
        }

        if(storedData.skillsSelectedList){
          this.skillsSelectedList = storedData.skillsSelectedList;
          this.filterData.skillsSelectedList = _.clone(this.skillsSelectedList, true);
        }

        if(storedData.companySelectedList){
          this.companySelectedList = storedData.companySelectedList;
          this.filterData.companySelectedList = _.clone(this.companySelectedList, true);
          this.showCompanyLoader = false;
        }

         if (storedData && storedData.companysize) {
           if(storedData.companysize.includes("All")){
            this.filterData.companysize = ['All'];
             this.isCompanySizeSelected = storedData.companySizeSelectedList?.length ? true: false;
             this.companysize = ["All","1-10", "11-50", "51-200", "201-500", "501-1000", "1001-5000", "5001-10000", "10001+"]
           }else{
             this.isCompanySizeSelected = storedData.companySizeSelectedList?.length ? true: false;
             this.filterData.companysize = _.clone(storedData.companysize, true);
             this.companysize = _.clone(storedData.companysize, true);
           }
         } else {
           this.filterData.companysize = [];
           this.isCompanySizeSelected  = false;
           this.companysize = ["All","1-10", "11-50", "51-200", "201-500", "501-1000", "1001-5000", "5001-10000", "10001+"]
         }

         if(storedData.industrySelectedList){
          this.industrySelectedList = storedData.industrySelectedList;
          this.filterData.industrySelectedList = _.clone(this.industrySelectedList, true);
          this.showIndustryLoader = false;
        }

        if(storedData.functionSelectedList){
          this.functionSelectedList = storedData.functionSelectedList;
          this.filterData.functionSelectedList = _.clone(this.functionSelectedList, true);
          this.showFunctionsLoader = false;
        }

        if (storedData && storedData.seniority) {
          if(storedData.seniority.includes("All")){
            this.filterData.seniority = ['All'];
            this.seniority = ["All", "cxo","director", "entry", "manager","owner", "partner","senior","training","unpaid","vp"]
          }else{
            this.filterData.seniority = _.clone(storedData.seniority, true);
            this.seniority = _.clone(storedData.seniority, true);
          }
        } else {
          this.filterData.seniority = [];
          this.seniority = ["All", "cxo","director", "entry", "manager","owner", "partner","senior","training","unpaid","vp"]
        }

        this.yearsofexperience = storedData.yearsofexperience;
        this.filterData.yearsofexperience = storedData.yearsofexperience
        this.yearsofexperienceFrom.setValue(storedData.yearsofexperienceFrom);
        this.filterData.yearsofexperienceFrom = storedData.yearsofexperienceFrom
        this.yearsofexperienceTo.setValue(storedData.yearsofexperienceTo);
        this.filterData.yearsofexperienceTo = storedData.yearsofexperienceTo
        if(storedData.yearsofexperienceFrom && storedData.yearsofexperienceTo){
          this.filterAppliedOnYearsOfExperience = true;
          this.filterData.filterAppliedOnYearsOfExperience = true;
        }else{
          this.filterAppliedOnYearsOfExperience = false;
          this.filterData.filterAppliedOnYearsOfExperience = false;
        }


        this.currentfromyearsofexperience.setValue(storedData.currentfromyearsofexperience);
        this.currenttoyearsofexperience.setValue(storedData.currenttoyearsofexperience);
        this.filterData.currentfromyearsofexperience = storedData.currentfromyearsofexperience;
        this.filterData.currenttoyearsofexperience = storedData.currenttoyearsofexperience;

        if(storedData.currentfromyearsofexperience && storedData.currenttoyearsofexperience){
          this.filterAppliedOnCurrentYearsOfExperience = true;
        }else{
          this.filterAppliedOnCurrentYearsOfExperience = false;
        }

        this.tograduationyear.patchValue(storedData.tograduationyear);
        this.fromgraduationyear.patchValue(storedData.fromgraduationyear);
        if(this.tograduationyear.value || this.fromgraduationyear.value){
          this.filterAppliedOnYearsOfGraduation = true;
        }

        if(storedData.gender){
          this.filterData.gender = storedData.gender;
          this.filterData.isGenderSelected = storedData.isGenderSelected;
          this.gender = storedData.gender;
          this.isGenderSelected = storedData.isGenderSelected ? true : false;
        } else {
          this.filterData.gender = 'All';
          this.filterData.isGenderSelected = false;
          this.gender = 'All';
          this.isGenderSelected = false;
        }

        if(storedData.educationSelectedList){
          this.educationSelectedList = storedData.educationSelectedList;
          this.filterData.educationSelectedList = _.clone(this.educationSelectedList, true);
          this.showEducationLoader = false;
        }

        if(storedData.schoolLocationSelectedList){
          this.schoolLocationSelectedList = storedData.schoolLocationSelectedList;
          this.filterData.schoolLocationSelectedList = _.clone(this.schoolLocationSelectedList, true);

        }

        if(storedData.schoolSelectedList){
          this.schoolSelectedList = storedData.schoolSelectedList;
          this.filterData.schoolSelectedList = _.clone(this.schoolSelectedList, true);
          this.showSchoolLoader = false;
        }

        if(storedData.fieldOfStudySelectedList){
          this.fieldOfStudySelectedList = storedData.fieldOfStudySelectedList;
          this.filterData.fieldOfStudySelectedList = _.clone(this.fieldOfStudySelectedList, true);
          this.showFieldOfStudyLoader = false;
        }

        if(storedData.fullNameSelectedList){
          this.fullNameSelectedList = storedData.fullNameSelectedList;
          this.filterData.fullNameSelectedList = storedData.fullNameSelectedList;
        }

        if (storedData && storedData.profilehighlights) {
          this.filterData.profilehighlights = storedData.profilehighlights;
        } else {
          this.filterData.profilehighlights = [];
        }

        if (storedData && storedData.positionhierarchy) {
          this.filterData.positionhierarchy = storedData.positionhierarchy;
        } else {
          this.filterData.positionhierarchy = [];
        }


        if(storedData.filterLikelyToMoveIn){
          this.filterLikelyToMoveIn = storedData.filterLikelyToMoveIn;
          this.isLikelyToMoveInFilterSelected = storedData.isLikelyToMoveInFilterSelected;
          this.filterData.candidateslikelytomove = storedData.candidateslikelytomove;
          this.candidateslikelytomove = storedData.candidateslikelytomove;

        }

        if(storedData.searchHistoryRegion){
          this.searchHistoryRegion = storedData.searchHistoryRegion;
          this.sessionStorageService.setItem('historyRegion', storedData.searchHistoryRegion)
        }else{
          this.searchHistoryRegion = null;
          this.sessionStorageService.setItem('historyRegion', null)
        }

        if(storedData.continentstobeincluded){
          // this.showregion = storedData.continentstobeincluded;
          // this.continentHandlerService.emitContinentUpdate(storedData.continentstobeincluded);
          this.localstorageservice.setItem('region', storedData.continentstobeincluded);

        } else {
          this.localstorageservice.setItem('region', this.localstorageservice.getItem('region'))
        }

        if(storedData && storedData.changedJobStatus === 'yes') {
          this.isChangedJobsSelected = true;
          this.changedJobStatus = storedData.changedJobStatus;
          this.changedJobStartDuration = storedData.changedJobStartDuration;
          this.changedJobEndDuration = storedData.changedJobEndDuration;
          this.filterData.isChangedJobsSelected = true;
          this.filterData.changedJobStatus = storedData.changedJobStatus;
          this.filterData.changedJobStartDuration = storedData.changedJobStartDuration;
          this.filterData.changedJobEndDuration = storedData.changedJobEndDuration;
        } else {
          this.isChangedJobsSelected = false;
          this.changedJobStatus = 'all';
          this.changedJobStartDuration = 0;
          this.changedJobEndDuration = 12;
          this.filterData.isChangedJobsSelected = false;
          this.filterData.changedJobStatus = 'all';
          this.filterData.changedJobStartDuration = 0;
          this.filterData.changedJobEndDuration = 12;
        }

        if(storedData && storedData.distancefromselectedlocations) {
          this.filterData.distancefromselectedlocations = storedData.distancefromselectedlocations;
        } else{
          this.filterData.distancefromselectedlocations = 20;
        }

        if(storedData && storedData.distancefromselectedlocationsmeasurementunit) {
          this.filterData.distancefromselectedlocationsmeasurementunit = storedData.distancefromselectedlocationsmeasurementunit;
        } else{
          this.filterData.distancefromselectedlocationsmeasurementunit = 'kilometers'
        }

        if(storedData && (storedData.isListingActive || storedData.isInsightsActive)) {
          this.isListingActive = storedData.isListingActive;
          this.isInsightsActive = storedData.isInsightsActive;
          this.filterData.isListingActive = storedData.isListingActive;
          this.filterData.isInsightsActive = storedData.isInsightsActive;
        } else {
          this.isListingActive = true;
          this.isInsightsActive = false;
          this.filterData.isListingActive = true;
          this.filterData.isInsightsActive = false;
        }
        if(storedData && storedData.positionhierarchy) {
          this.filterData.positionhierarchy = storedData.positionhierarchy;
        }

        if(storedData && storedData.jdsearchhistoryid) {
          this.localstorageservice.setItem('jdinsightshistoryid', storedData.jdsearchhistoryid);
        }

        if(storedData && storedData.includePersons.length > 0){
          this.filterData.includePersons = storedData.includePersons
        }
        if(this.areAllFiltersCleared() && (!this.isCalledFromSimilar && !this.isComingFromJD && !this.isComingNLSearch && !this.redirectSource)) {
          this.resetAll = true
        } else {
          this.resetAll = false;
   this.filterDataHandlerService.setFilterData(this.filterData);
        this.insightsEvent = false;
        this.getPersonSearchRecommendedCandidates();
        }
        // this.localstorageservice.setItem('talentdiscoveryhistoryid', null);


    }else{
      if(this.areAllFiltersCleared()&& (!this.isCalledFromSimilar && !this.isComingFromJD && !this.isComingNLSearch && !this.redirectSource)) {
        this.resetAll = true
      } else {
        this.resetAll = false;
 this.dataService.setData(storedData);
      this.getPersonSearchRecommendedCandidates();
      }
      // this.localstorageservice.setItem('talentdiscoveryhistoryid', null);

    }

  }

  jdSearchActivity(response) {
    const parsedResponse = {
      job_title: _.pluck(response.jobtitle, 'key').map(x=>x.includes('.searchastext') ? x.replace('.searchastext','') : x),
      mandatory_skills: response.skills ? _.pluck(response.skills.filter(s => s.isMandatory== true), 'key').map(x=>x.includes('.searchastext') ? x.replace('.searchastext','') : x) : [],
      preferred_skills: response.skills ? _.pluck(response.skills.filter(s => s.isMandatory== false), 'key').map(x=>x.includes('.searchastext') ? x.replace('.searchastext','') : x) : [],
      years_of_experience: {
        minimum_experience: response.fromYrsOfExperience,
        maximum_experience: response.toYrsOfExperience
      },
      industry: _.pluck(response.jobindustryname, 'key').map(x=>x.includes('.searchastext') ? x.replace('.searchastext','') : x),
      location: response.currentlocation ? _.pluck(response.currentlocation, 'key').map(x=>x.includes('.searchastext') ? x.replace('.searchastext','') : x) : [],
      target_company: response.jobcompanyname ? _.pluck(response.jobcompanyname, 'key').map(x=>x.includes('.searchastext') ? x.replace('.searchastext','') : x) : [],
      degree: response.degrees ? _.pluck(response.degrees, 'key').map(x=>x.includes('.searchastext') ? x.replace('.searchastext','') : x) : [],
      school: response.schools ? _.pluck(response.schools, 'key').map(x=>x.includes('.searchastext') ? x.replace('.searchastext','') : x) : [],
      field_of_study: response.fieldOfStudy ? _.pluck(response.fieldOfStudy, 'key').map(x=>x.includes('.searchastext') ? x.replace('.searchastext','') : x) : []
    }
    this.parsedjdkeys = parsedResponse;
    let payload = {
      jobdescription: this.jdDataService.fetchJdDescription,
      parsedjdkeys: parsedResponse
    }
    if(!this.jdDataService.fetchJdDescription) {
      payload['historyid'] = this.localstorageservice.getItem('jdinsightshistoryid');
    }

    const historyId = this.localstorageservice.getItem('jdinsightshistoryid');
    if(!historyId) {
      payload['parsed_jd'] = parsedResponse;
    }

    this.personSearchService.getJdSearchActivity(payload).subscribe((res: any) => {
      this.jdInsightsHistoryId = res.data.historyId;
      this.localstorageservice.setItem('jdinsightshistoryid', this.jdInsightsHistoryId);
      let filterData = this.filterDataHandlerService.fetchFilterData;
      filterData.jdsearchhistoryid = this.jdInsightsHistoryId;
      this.filterDataHandlerService.setFilterData(filterData);
        this.resetMustAndGoodFilters();
        this.setFilterDataInLocalStorage();

    });

  }

  onFilterEvent(event) {
    if(event == 'allfilters') {
      this.resetAll = true
    } else{
      this.resetAll = false;
    }

  }

  truncateText(text: string, limit: number = 80): string {
  return text?.length > limit ? text?.substring(0, limit) + '...' : text;
}

areAllFiltersCleared(): boolean {
  return (
    !this.filterData.jobTitleSelectedList?.length &&
    !this.filterData.locationSelectedList?.length &&
    !this.filterData.companySelectedList?.length &&
    !this.filterData.industrySelectedList?.length &&
    !this.filterData.educationSelectedList?.length &&
    !this.filterData.fieldOfStudySelectedList?.length &&
    !this.filterData.skillsSelectedList?.length &&
    !this.filterData.functionSelectedList?.length &&
    this.filterData.booleanquery == '*' &&
    !this.filterData.schoolSelectedList?.length &&
    !this.filterData.schoolLocationSelectedList?.length &&
    !this.filterData.pastJobTitleSelectedList?.length &&
    !this.filterData.positionhierarchy?.length &&
    !this.filterData.companysize?.length &&
    !this.filterData.seniority?.length &&
    // !this.filterData.fullNameSelectedList?.length &&

    // Gender
    this.gender === 'All' &&

    // Likely to move
    this.filterLikelyToMoveIn === 'All' &&

    // Experience filters
    !this.yearsofexperienceFrom.value &&
    !this.yearsofexperienceTo.value &&
    !this.currentfromyearsofexperience.value &&
    !this.currenttoyearsofexperience.value &&

    // Graduation
    !this.fromgraduationyear.value &&
    !this.tograduationyear.value &&

    // Location range
    this.filterData.distancefromselectedlocations === 20 &&
    this.filterData.distancefromselectedlocationsmeasurementunit === 'kilometers'
  );
}

getRevealContactStatus(event) {
    if(event && event.status == 'reveal-contact-clicked') {
      this.candidateList = this.candidateList.map(candidate => {
        if(candidate.id === event.data.candidatenumber) {
          candidate.contactRevealStatus = 'reveal-contact-clicked';
        } else {
          candidate.contactRevealStatus = null;
        }
        return candidate;
      })
    } else if(event && event.status == 'reveal-contact-notrevealed') {
      this.candidateList = this.candidateList.map(candidate => {
           if(candidate.id === event.data.candidatenumber) {
          candidate.contactRevealStatus = 'reveal-contact-notrevealed';
        } else {
          candidate.contactRevealStatus = null;
        }
        return candidate;
      })
    }
}

    redirectToEmailCampaign(campaign_id){
    this.router.navigateByUrl(`email-campaign/target-listing/${campaign_id}`);
    }

    getExcludeFilters(redirectData) {
      const excludeFilters = [];

  const jobTitleExclude = redirectData?.jobTitleSelectedList
  ?.filter(job => job.isExcluded)
  ?.map(job => ({ ...job, type: 'jobtitle' }));

const locationExclude = redirectData?.locationSelectedList
  ?.filter(location => location.isExcluded)
  ?.map(location => ({ ...location, type: 'location' }));

const companyExclude = redirectData?.companySelectedList
  ?.filter(company => company.isExcluded)
  ?.map(company => ({ ...company, type: 'company' }));

const industryExclude = redirectData?.industrySelectedList
  ?.filter(industry => industry.isExcluded)
  ?.map(industry => ({ ...industry, type: 'industry' }));

const skillsExclude = redirectData?.skillsSelectedList
  ?.filter(skill => skill.isExcluded)
  ?.map(skill => ({ ...skill, type: 'skill' }));

const functionExclude = redirectData?.functionSelectedList
  ?.filter(func => func.isExcluded)
  ?.map(func => ({ ...func, type: 'function' }));

excludeFilters.push(
  ...jobTitleExclude,
  ...locationExclude,
  ...companyExclude,
  ...industryExclude,
  ...skillsExclude,
  ...functionExclude
);

return excludeFilters;
    }

}

